export const TUTORIAL_MESSAGES = {
  // --- UI labels ---
  dismiss: "Masquer",
  suggestion_title: "Tutoriel disponible",
  suggestion_start_section: "Réaliser cette étape",
  suggestion_open_dialog: "Voir les tutoriels",
  later: "Plus tard",
  ignore_section: "Ne plus proposer",
  prev: "Précédent",
  next: "Suivant",
  next_section: "Section suivante",
  finish: "Terminer",
  quit_btn: "Quitter",
  step_counter: "#current / #total",
  section_done: "Terminé",
  section_active: "En cours",
  section_pending: "À faire",
  tip_label: "Astuce",
  action_click: "Cliquez sur l'élément mis en surbrillance",
  action_fill: "Remplissez le champ mis en surbrillance",
  expected_value: "Saisissez :",
  action_info: "Naviguez vers la page indiquée",
  action_verify: "Vérifiez les informations affichées",
  rating_title: "Comment avez-vous trouvé ce tutoriel ?",
  rating_subtitle: "Votre avis nous aide à améliorer les parcours.",
  sidenav_title: "Tutoriels",
  sidenav_level: "Niv. #level",
  sidenav_completed: "terminé(s)",
  sidenav_more: "Voir +",
  sidenav_less: "Réduire",
  sidenav_reset: "Reset progression",
  sidenav_open: "Voir les tutoriels",
  sidenav_start: "Démarrer",
  sidenav_resume: "Reprendre",
  sidenav_replay: "Refaire",
  sandbox_banner_text:
    "Mode tutoriel \u2014 les donn\u00e9es affich\u00e9es sont fictives et r\u00e9serv\u00e9es au parcours de formation",
  sandbox_banner_quit: "Quitter",
  demo_toggle_your_data: "Vos donn\u00e9es",
  demo_toggle_demo_data: "Donn\u00e9es de d\u00e9mo",

  // --- Group names ---
  groups: {
    "premiers-pas": "Premiers pas",
    parametrage: "Paramétrage",
    catalogue: "Catalogue produit",
    achat: "Achat & approvisionnement",
    production: "Production",
    qualite: "Qualité & non-conformités",
    commercial: "Vente & expédition",
    stock: "Stock & traçabilité",
    pilotage: "Pilotage & analyse",
  },

  // --- Module names & descriptions ---
  modules: {
    "premiers-pas": {
      name: "Premiers pas",
      description:
        "Découvrez les grandes sections de JustUp et apprenez à naviguer dans l'application.",
    },
    "parametrage-admin": {
      name: "Paramétrage administratif",
      description:
        "Configurez l'identité de votre entreprise, les numérotations et les documents commerciaux.",
    },
    "parametrage-activite": {
      name: "Paramétrage activité",
      description:
        "C'est parti pour le paramétrage de JustUp ajusté à votre entreprise !",
    },
    "gestion-articles": {
      name: "Gestion des articles",
      description:
        "Créez et configurez votre catalogue produit : matières premières, produits finis et emballages.",
    },
    "gestion-tiers": {
      name: "Gestion des tiers",
      description:
        "Créez et gérez vos fournisseurs, clients et transporteurs avec leurs conditions commerciales.",
    },
    "gestion-nomenclature": {
      name: "Nomenclature (recette)",
      description:
        "Définissez la recette de vos produits finis : ingrédients, quantités, taux de pertes et emballages.",
    },
    "gestion-process": {
      name: "Process de fabrication",
      description:
        "Définissez les étapes de fabrication de vos produits : pesée, mélange, cuisson, conditionnement et plus.",
    },
    "gestion-controles": {
      name: "Contrôles qualité",
      description:
        "Configurez les contrôles qualité à réaliser en production : quantitatifs, conformes/non-conformes, QCM et enregistrements.",
    },
    "reglages-pre-production": {
      name: "Réglages pré-production",
      description:
        "Derniers réglages avant la première production : mode de consommation (PDC, déclaration), DDM et validation de la spécification.",
    },
    "gestion-lignes": {
      name: "Lignes de production",
      description:
        "Créez et configurez vos lignes de production : cadences, paramètres techniques et horaires d'ouverture.",
    },
    "gestion-commandes-fourni": {
      name: "Commandes fournisseurs",
      description:
        "Passez vos commandes de matières premières : sélection fournisseur, lignes de commande, prix et confirmation.",
    },
    "gestion-reception": {
      name: "Réception fournisseur",
      description:
        "Réceptionnez vos livraisons : déchargement, contrôle des quantités, création de lots et validation de conformité.",
    },
    "gestion-of": {
      name: "Ordres de fabrication",
      description:
        "Créez et gérez vos ordres de fabrication : sélection d'article, quantité, ligne de production et paramètres.",
    },
    "gestion-planification": {
      name: "Planification production",
      description:
        "Planifiez vos ordres de fabrication sur les lignes de production via le Gantt interactif.",
    },
    "gestion-production": {
      name: "Opération de production",
      description:
        "Réalisez une opération de fabrication : étapes de process, contrôles qualité CNC et CCP récurrents.",
    },
    "gestion-traca-production": {
      name: "Traçabilité et fin d'opé",
      description:
        "Déclarez la traçabilité des lots consommés (PDC, Consos) et terminez l'opération de fabrication.",
    },
    "gestion-cloture-of": {
      name: "Clôture de production",
      description:
        "Clôturez vos OF : bilan matière, réintégration des pieds de chaîne et double validation production/qualité.",
    },
    "gestion-commandes-client": {
      name: "Commandes clients",
      description:
        "Créez et gérez les commandes de vos clients : sélection articles, prix, remises et envoi.",
    },
    "gestion-expedition": {
      name: "Expédition",
      description:
        "Préparez les expéditions : picking des lots, palettisation avec code SSCC et génération des fiches palette.",
    },
    "preparation-expedition": {
      name: "Préparation de commande",
      description:
        "Pilotez la préparation par produit : arbitrage des lots selon les DDM, pré-réservation auto, réservation physique, puis palettisation.",
    },
    "gestion-livraison": {
      name: "Livraison",
      description:
        "Gérez les bons de livraison et les chargements : création BL, affectation palettes, validation et mouvements de stock.",
    },
    "gestion-facturation": {
      name: "Facturation",
      description:
        "Créez et gérez les factures : émission depuis les BL, remises, paiements, avoirs et suivi des transactions.",
    },
    "gestion-transferts": {
      name: "Transferts inter-sites",
      description:
        "Transférez les stocks entre entrepôts : création du BT, préparation palettes/vrac, expédition et réception.",
    },
    "gestion-inventaire": {
      name: "Inventaire",
      description:
        "Réalisez vos inventaires physiques : création des zones, comptage par scan, bilans, arbitrage et clôture.",
    },
    "gestion-tracabilite": {
      name: "Traçabilité",
      description:
        "Visualisez la traçabilité complète des lots : diagramme Sankey amont/aval, stocks, mouvements et coûts.",
    },
    "planification-composants": {
      name: "Planification des composants",
      description:
        "Anticipez vos besoins : visualisez le stock prévisionnel jour par jour, repérez les articles sous seuil et créez vos commandes de réapprovisionnement.",
    },
    "saisie-heures": {
      name: "Saisie des heures",
      description:
        "Configurez le planning par défaut des équipes, puis saisissez les heures travaillées par jour et par opérateur, affectées aux ordres de fabrication.",
    },
    "analyse-rentabilite": {
      name: "Analyses de rentabilité",
      description:
        "Analysez la marge, les achats et le coût de fabrication d'un produit à partir de vos vraies données.",
    },
    "tableau-de-bord": {
      name: "Tableau de bord",
      description:
        "Pilotez votre activité d'un coup d'œil : valeur de stock, production, lots à surveiller, et personnalisez vos widgets.",
    },
    "evolution-couts": {
      name: "Évolution des coûts",
      description:
        "Suivez l'historique de coût d'un lot, revalorisez-le, et mesurez l'impact en cascade sur vos produits finis.",
    },
    "modeles-specifications": {
      name: "Modèles & variables de spécification",
      description:
        "Créez des modèles de spécification réutilisables avec des variables, associez-les à vos articles et renseignez les valeurs propres à chacun.",
    },
    "gestion-non-conformites": {
      name: "Non-conformités",
      description:
        "Déclarez un écart qualité, instruisez-le et clôturez-le avec sa décision et son coût.",
    },
    "cockpit-qualite": {
      name: "Cockpit qualité",
      description:
        "Lisez en une page ce qui demande votre attention : alertes, actions en retard et conformité des contrôles.",
    },
    "gestion-checklists": {
      name: "Listes de tâches",
      description:
        "Définissez les tâches périodiques — nettoyage, hygiène, maintenance — et faites-les cocher sur le terrain.",
    },
    "mouvements-stock": {
      name: "Mouvements de stock",
      description:
        "Lisez l'historique qui explique chaque quantité en stock, et retrouvez le mouvement derrière un écart.",
    },
    "preparateur-mobile": {
      name: "Préparateur (mobile)",
      description:
        "L'écran du quai : chercher sa commande, scanner les lots et sortir le bon de picking.",
    },
    "droits-utilisateurs": {
      name: "Utilisateurs & droits",
      description:
        "Ouvrez un compte à un collègue et donnez-lui le profil de droits qui correspond à son poste.",
    },
    "audit-bio": {
      name: "Audit bio",
      description:
        "Prouvez, sur une période, que vos entrées bio couvrent vos sorties bio — le bilan que réclame le certificateur.",
    },
    "gestion-equipes": {
      name: "Équipes",
      description:
        "Regroupez vos collaborateurs pour la saisie des heures et le suivi d'activité.",
    },
    "developpement-recette": {
      name: "Développement recette",
      description:
        "De l'idée au produit fini : projet, essais, composition, coût, étiquetage et fiche technique.",
    },
  },

  // --- Section titles & descriptions ---
  sections: {
    "analyse-marge": {
      title: "Analyse marge & prix",
      description:
        "KPIs de vente, évolution, marge par client et aide à la tarification.",
    },
    "analyse-achat": {
      title: "Analyse achats",
      description:
        "KPIs réceptions, prix payé, comparaison fournisseurs, conformité et négociation.",
    },
    "analyse-fabrication": {
      title: "Analyse fabrication",
      description:
        "Coût de revient, poids des composants, détail par OF et simulateur.",
    },
    "decouverte-dashboard": {
      title: "Le tableau de bord",
      description: "Tour des widgets clés et de la personnalisation.",
    },
    "evolution-couts": {
      title: "Évolution & impact des coûts",
      description:
        "Historique de coût, revalorisation et impact cascade sur l'aval.",
    },
    "comprendre-modele": {
      title: "Le modèle & ses variables",
      description:
        "Un squelette de recette réutilisable, avec des paramètres ajustables.",
    },
    "associer-article": {
      title: "Associer le modèle à un article",
      description:
        "Relier un article au modèle partagé pour hériter de ses variables.",
    },
    "renseigner-variables": {
      title: "Renseigner les variables",
      description: "Donner à chaque article ses propres valeurs de variables.",
    },
    "decouverte-planif-composants": {
      title: "Planification des composants",
      description:
        "Tableau de bord du stock prévisionnel et du réapprovisionnement.",
    },
    "config-planning": {
      title: "Planning par défaut",
      description: "Configuration des horaires de travail par défaut.",
    },
    "saisie-travail": {
      title: "Saisie des heures",
      description: "Saisie des heures travaillées par jour et par opérateur.",
    },
    "decouverte-infos": {
      title: "Données de base",
      description:
        "Découverte de la section Données de base et de ses sous-menus.",
    },
    "decouverte-daily": {
      title: "Tâches journalières",
      description: "Découverte de la section Tâches journalières.",
    },
    "decouverte-inventaire": {
      title: "Inventaire",
      description: "Découverte de la section Inventaire.",
    },
    "decouverte-production": {
      title: "Production",
      description: "Découverte de la section Production.",
    },
    "decouverte-commandes": {
      title: "Commandes",
      description: "Découverte de la section Commandes.",
    },
    "decouverte-admin": {
      title: "Administration",
      description: "Découverte de la section Administration.",
    },
    "mon-entreprise": {
      title: "Mon entreprise",
      description: "Renseignez les informations légales de votre société.",
    },
    numerotations: {
      title: "Numérotations",
      description:
        "Configurez les préfixes de vos documents (lots, OFs, factures...).",
    },
    "adresses-documents": {
      title: "Adresses & Documents",
      description: "Gérez vos adresses et mentions commerciales.",
    },
    enumerations: {
      title: "Énumérations",
      description:
        "Créez les listes de valeurs : familles, familles techniques, types de travail.",
    },
    "params-generaux": {
      title: "Paramètres généraux",
      description: "Consigne qualité et workflows de validation.",
    },
    "decouverte-articles": {
      title: "Découverte des articles",
      description:
        "Accédez à votre catalogue produit et découvrez la liste des articles.",
    },
    "creation-article": {
      title: "Créer un article",
      description: "Créez votre premier article pas à pas.",
    },
    "creation-mp": {
      title: "Créer une matière première",
      description: "Ajoutez un ingrédient manquant à votre catalogue.",
    },
    "creation-pf": {
      title: "Créer un produit fini",
      description: "Créez le produit que vous allez fabriquer et vendre.",
    },
    "config-article": {
      title: "Configurer un article",
      description:
        "Découvrez les options de configuration : type, DDM, stock, traçabilité.",
    },
    "fiche-biscuit": {
      title: "Fiche produit fini",
      description:
        "Découvrez la fiche technique du produit que vous venez de créer.",
    },
    "decouverte-tiers": {
      title: "Découverte des tiers",
      description:
        "Accédez à la liste de vos fournisseurs, clients et transporteurs.",
    },
    "creation-fournisseur": {
      title: "Créer un fournisseur",
      description:
        "Créez votre premier fournisseur avec ses coordonnées et conditions de paiement.",
    },
    "config-fournisseur": {
      title: "Configurer un fournisseur",
      description:
        "Explorez la fiche fournisseur : adresses, contacts et prix d'achat.",
    },
    "decouverte-nomenclature": {
      title: "Découverte de la nomenclature",
      description:
        "Comprenez l'interface de gestion des recettes et ses composants.",
    },
    "ajout-ingredients": {
      title: "Ajouter des ingrédients",
      description:
        "Apprenez à ajouter des lignes de nomenclature avec quantités et taux de pertes.",
    },
    "ajout-premier-ingredient": {
      title: "Ajouter le premier ingrédient",
      description:
        "Ajoutez la Farine de blé dans la recette des Biscuits sablés.",
    },
    "explorer-ligne": {
      title: "Explorer la ligne ajoutée",
      description:
        "Découvrez l'affichage d'une ligne et complétez la nomenclature.",
    },
    "nomenclature-complete": {
      title: "Recette complète",
      description:
        "Tous les ingrédients sont en place, découvrez la nomenclature.",
    },
    "config-nomenclature": {
      title: "Options avancées",
      description:
        "Modification, réordonnancement, héritage de lot et articles paramétrables.",
    },
    "decouverte-process": {
      title: "Découverte du process",
      description:
        "Comprenez l'interface de gestion des étapes de fabrication.",
    },
    "creation-etapes": {
      title: "Créer des étapes",
      description:
        "Ajoutez des étapes de fabrication avec leurs paramètres : durée, description, options.",
    },
    "config-process": {
      title: "Configurer le process",
      description:
        "Réordonnez les étapes, gérez les options avancées et liez aux contrôles qualité.",
    },
    "controle-reception-mp": {
      title: "Contrôle à réception",
      description: "Ajoutez un contrôle qualité à la réception du Lait.",
    },
    "controle-debut-ope-pf": {
      title: "Contrôle en début d'opé",
      description:
        "Ajoutez un contrôle en début d'opération pour les Biscuits.",
    },
    "reglage-pdc": {
      title: "Gestion pied de chaîne",
      description: "Configurez la Farine en mode pied de chaîne (PDC).",
    },
    "reglage-conso": {
      title: "Déclaration de consommation",
      description: "Configurez le Sucre en mode déclaration de conso.",
    },
    "reglage-ddm": {
      title: "Date de durabilité (DDM)",
      description: "Configurez la DDM sur les Biscuits sablés.",
    },
    "creation-ligne": {
      title: "Créer une ligne",
      description:
        "Créez votre première ligne de production pour fabriquer des biscuits.",
    },
    "fiche-ligne": {
      title: "Fiche de la ligne",
      description:
        "Découvrez les informations générales, horaires et paramètres techniques.",
    },
    "config-ligne": {
      title: "Configurer une ligne",
      description:
        "Ajoutez des paramètres techniques et définissez les horaires d'ouverture.",
    },
    "decouverte-commandes-fourni": {
      title: "Découverte des commandes",
      description:
        "Découvrez la liste des commandes fournisseurs et leur cycle de vie.",
    },
    "parametrage-article-achat": {
      title: "Article fourni (achat)",
      description:
        "Paramétrez les prix d'achat fournisseur pour le Sucre cristal.",
    },
    "creation-commande-fourni": {
      title: "Créer une commande",
      description: "Créez une commande fournisseur pour le Sucre cristal.",
    },
    "fiche-commande-fourni": {
      title: "Fiche commande",
      description:
        "Ajoutez des lignes, consultez les totaux et envoyez la commande.",
    },
    // === RÉCEPTION FOURNISSEUR ===
    "decouverte-reception": {
      title: "Découverte de la réception",
      description:
        "Comprenez le workflow de réception : du déchargement à la mise en stock.",
    },
    "creation-dechargement": {
      title: "Créer un déchargement",
      description:
        "Déclarez l'arrivée d'une livraison avec son numéro de BL et les quantités.",
    },
    "reception-lots": {
      title: "Réceptionner les lots",
      description:
        "Sélectionnez un lot existant ou créez-en un nouveau pour chaque article livré.",
    },
    "dechargement-reception": {
      title: "Décharger et réceptionner",
      description:
        "Déclarez l'arrivée d'une livraison, saisissez les quantités et créez les lots pour chaque article.",
    },
    // === ORDRES DE FABRICATION ===
    "decouverte-of": {
      title: "Découverte des OF",
      description:
        "Découvrez la liste des ordres de fabrication et leur cycle de vie.",
    },
    "creation-of": {
      title: "Créer un OF",
      description:
        "Créez un ordre de fabrication : article, quantité, ligne et paramètres.",
    },
    "config-of": {
      title: "Configurer un OF",
      description:
        "Détail d'un OF : édition, lien spécification, besoins matière et états.",
    },
    // === PLANIFICATION ===
    "decouverte-planif": {
      title: "Découverte de la planification",
      description:
        "Découvrez l'interface Gantt de planification des OF sur les lignes.",
    },
    "planifier-of": {
      title: "Planifier un OF",
      description:
        "Affectez un OF à un créneau et lancez la ligne de production.",
    },
    "vue-ensemble-planif": {
      title: "Vue d'ensemble et fonctionnalités",
      description:
        "Passez en vue semaine, découvrez le drag & drop et les contraintes de lignes.",
    },
    // === PRODUCTION ===
    "lancement-production": {
      title: "Préparation",
      description:
        "Sélectionnez l'OF, préparez le pied de chaîne (mise en PDC des lots).",
    },
    "execution-production": {
      title: "Opération de fabrication",
      description:
        "Créez l'opé, choisissez le lot héritier, démarrez et exécutez les étapes.",
    },
    "finalisation-production": {
      title: "Finalisation",
      description:
        "Déclarez la quantité produite, évaluez l'opération et terminez.",
    },
    "traca-production": {
      title: "Traçabilité et consommations",
      description:
        "Déclarez les lots consommés (PDC, Consos) pour chaque matière première.",
    },
    "fin-operation": {
      title: "Fin d'opération",
      description:
        "Déclarez la quantité produite, évaluez et terminez l'opération.",
    },
    // === CLÔTURE OF ===
    "bilan-matiere": {
      title: "Bilan matière",
      description:
        "Analysez les écarts entre consommation théorique et réelle.",
    },
    "stats-validation": {
      title: "Statistiques & Validation",
      description:
        "Analysez les performances matière, main d'œuvre et le coût de revient.",
    },
    "saisie-heures": {
      title: "Saisie des heures",
      description: "Déclarez les heures travaillées et validez l'OF.",
    },
    // === COMMANDES CLIENTS ===
    "decouverte-commandes-client": {
      title: "Découverte des commandes clients",
      description:
        "Découvrez la liste des commandes clients et leur cycle de vie.",
    },
    "creation-commande-client": {
      title: "Créer une commande client",
      description:
        "Sélectionnez le client, l'adresse de livraison et l'entrepôt de départ.",
    },
    "fiche-commande-client": {
      title: "Fiche commande client",
      description:
        "Explorez la fiche : lignes, prix, remises, récap financier, actions d'envoi et de livraison.",
    },
    "lignes-commande-client": {
      title: "Lignes et envoi",
      description:
        "Ajoutez des articles, vérifiez les prix et envoyez la commande.",
    },
    // === EXPÉDITION ===
    "parametrage-ue": {
      title: "Paramétrage des unités d'expédition",
      description:
        "Créez vos types d'unités (palette, bac, etc.) avec leur tare.",
    },
    "preparation-commande": {
      title: "Préparer la commande",
      description:
        "Découvrez l'onglet Préparation, les actions disponibles et créez une unité d'expédition.",
    },
    "livraison-retrait": {
      title: "Livrer par retrait",
      description:
        "L'onglet Livraison, les trois canaux de sortie, et la remise de marchandise au client sans passer par une unité d'expédition.",
    },
    "decouverte-expedition": {
      title: "Découverte de l'expédition",
      description:
        "Comprenez les modes d'expédition : palette, vrac ou sans expédition.",
    },
    "picking-lots": {
      title: "Picking des lots",
      description:
        "Sélectionnez les lots en stock et liez-les aux lignes de commande.",
    },
    palettisation: {
      title: "Palettisation",
      description:
        "Créez des palettes, assignez les lots et générez les fiches palette.",
    },
    // === PRÉPARATION EXPÉDITION ===
    "prepa-pilotage": {
      title: "Piloter la préparation",
      description:
        "Découvrez la vue de pilotage par produit : besoin, stock éligible et reste à réserver.",
    },
    "prepa-grille": {
      title: "Arbitrer les lots (grille DDM)",
      description:
        "Répartissez les lots entre les commandes selon leur DDM avec la pré-réservation auto, puis réservez.",
    },
    "preparer-ue": {
      title: "Préparer l'unité d'expédition",
      description:
        "Associez des lots à l'unité d'expédition et déclarez-la prête.",
    },
    // === LIVRAISON ===
    "creation-bl": {
      title: "Créer un chargement",
      description:
        "Créez un chargement, choisissez le transporteur et ajoutez les unités d'expédition.",
    },
    chargement: {
      title: "Charger et valider",
      description:
        "Scannez les UE, signez la lettre de voiture et validez le départ.",
    },
    "validation-chargement": {
      title: "Bons de livraison",
      description:
        "Consultez les BL générés, imprimez le PDF et envoyez-le au client.",
    },
    // === FACTURATION ===
    "decouverte-facturation": {
      title: "Découvrir la facturation",
      description: "Vue d'ensemble du module factures, KPI et BL en attente.",
    },
    "creation-facture": {
      title: "Créer une facture",
      description:
        "Créez une facture depuis un BL ou manuellement avec remises et lignes.",
    },
    "emission-paiement": {
      title: "Émettre et encaisser",
      description:
        "Figez la facture, envoyez-la par mail et enregistrez les paiements.",
    },
    // === TRANSFERTS ===
    "decouverte-transferts": {
      title: "Découvrir les transferts",
      description: "Vue d'ensemble des transferts inter-entrepôts et création.",
    },
    "creation-transfert": {
      title: "Créer un transfert",
      description: "Choisissez l'entrepôt de départ et l'entrepôt d'arrivée.",
    },
    "cycle-vie-transfert": {
      title: "Le cycle de vie",
      description:
        "De la validation à la réception : lignes, expédition, déchargement et solde.",
    },
    // === INVENTAIRE ===
    "inventaire-decouverte": {
      title: "Découvrir l'inventaire",
      description: "Créez un inventaire et configurez les zones de comptage.",
    },
    "comptage-inventaire": {
      title: "Compter les articles",
      description:
        "Scannez et comptez les articles par zone avec les différentes méthodes.",
    },
    "bilan-inventaire": {
      title: "Superviser et clôturer",
      description:
        "Analysez les écarts, arbitrez les bilans et clôturez l'inventaire.",
    },
    // === TRACABILITE ===
    "decouverte-tracabilite": {
      title: "Découvrir la traçabilité",
      description: "Explorez le diagramme Sankey et la légende des flux.",
    },
    "navigation-lots": {
      title: "Naviguer dans les lots",
      description:
        "Consultez les informations, stocks, mouvements et coûts d'un lot.",
    },
    "analyse-tracabilite": {
      title: "Analyser la traçabilité",
      description: "Comprenez les flux amont/aval et naviguez dans le graphe.",
    },
    "validation-specif": {
      title: "Approuver la spécification",
      description:
        "Validez la fiche technique pour la rendre utilisable en production.",
    },
    "adresses-tiers": {
      title: "Ajouter une adresse",
      description:
        "Renseignez l'adresse d'un tiers depuis l'onglet Adresses de sa fiche.",
    },
    "creation-modele": {
      title: "Créer un modèle de spécification",
      description:
        "Créez un modèle de spécification réutilisable depuis la liste.",
    },
    "droits-supervision": {
      title: "Droits de supervision",
      description:
        "Ouvrez l'accès à l'historique des actions depuis les profils de droits.",
    },
    "decouverte-nc": {
      title: "Lire le registre des NC",
      description:
        "Repérez une non-conformité dans la liste et filtrez par état, gravité ou type.",
    },
    "declaration-nc": {
      title: "Déclarer une non-conformité",
      description:
        "Ouvrez le formulaire, qualifiez l'écart et rattachez-le à un objet tracé.",
    },
    "traitement-nc": {
      title: "Instruire et clôturer",
      description:
        "Analysez la cause, tranchez la décision et chiffrez ce que l'écart a coûté.",
    },
    "lecture-cockpit": {
      title: "Lire le cockpit",
      description:
        "Comprendre ce que dit chaque bloc et dans quel ordre les regarder.",
    },
    "periode-rapport": {
      title: "Période et rapport",
      description:
        "Changer la fenêtre d'analyse et sortir le rapport qualité de la période.",
    },
    "decouverte-listes": {
      title: "Lire l'écran des listes",
      description:
        "Distinguer la définition d'une liste de sa réalisation quotidienne.",
    },
    "creation-liste": {
      title: "Définir une liste",
      description:
        "Créer la liste, sa périodicité et ses tâches — un acte de paramétrage, fait une fois.",
    },
    "realisation-liste": {
      title: "La remplir sur le terrain",
      description:
        "Cocher ce qui a été fait aujourd'hui, et retrouver ce qui ne l'a pas été.",
    },
    "lecture-mouvements": {
      title: "Lire l'historique",
      description:
        "Filtrer par type, par date, par emplacement, et remonter au lot d'origine.",
    },
    "correction-mouvement": {
      title: "Corriger un mouvement",
      description:
        "Ce qui se rectifie, ce qui ne se rectifie pas, et comment on corrige le reste.",
    },
    "decouverte-preparateur": {
      title: "L'écran du quai",
      description:
        "Trouver sa commande et comprendre les deux modes de préparation.",
    },
    "picking-preparateur": {
      title: "Prélever et clore",
      description:
        "Scanner, affecter chaque lot, puis imprimer le picking et le bon provisoire.",
    },
    "creation-utilisateur": {
      title: "Créer un compte",
      description:
        "Ouvrir l'accès à un collègue : identifiant, rôle et profil de droits.",
    },
    "profil-droits": {
      title: "Le profil de droits",
      description:
        "Créer un profil réutilisable plutôt que de régler chaque compte à la main.",
    },
    "preparer-audit-bio": {
      title: "Cadrer l'audit",
      description:
        "Choisir l'article, la période et les inventaires qui bornent le bilan.",
    },
    "lire-audit-bio": {
      title: "Lire le bilan",
      description:
        "Comprendre ce que dit l'écart entre entrées et sorties, et ce qu'on montre au certificateur.",
    },
    "creation-equipe": {
      title: "Créer une équipe",
      description:
        "Nommer l'équipe, désigner ses responsables et y placer ses membres.",
    },
    "projet-recette": {
      title: "Ouvrir un projet",
      description:
        "Décrire ce qu'on cherche à obtenir, et à quel prix.",
    },
    "essai-composition": {
      title: "Composer un essai",
      description:
        "Poser les composants, lire le bilan et le coût de revient de la formule.",
    },
    "etiquetage-fiche": {
      title: "Étiquetage et fiche technique",
      description:
        "Allergènes, Nutri-Score, liste d'ingrédients, puis la fiche pour le client.",
    },
  },

  // --- Step texts (title, body, tip) ---
  steps: {
    // ===== ANALYSES DE RENTABILITÉ =====
    "analyse-intro": {
      title: "Piloter la rentabilité",
      body: "Depuis la fiche d'un produit comme le Biscuit sablé du Moulin, trois analyses approfondies sont accessibles : marge & prix, achats, et fabrication. Elles agrègent vos vraies données (factures clients, réceptions, OF) pour répondre à une question simple : ce produit vous rapporte-t-il vraiment de l'argent ? Vous pilotez ainsi la rentabilité produit par produit, pas au global.",
      tip: "Idéal pour préparer une négociation fournisseur ou décider d'une hausse de tarif.",
    },
    "analyse-marge-btn": {
      title: "Analyse marge & prix",
      body: "Ce bouton ouvre l'analyse de marge du Biscuit sablé du Moulin : combien il rapporte, à quel prix il se vend selon les clients, et comment ce prix se situe face à votre tarif catalogue. C'est le point d'entrée pour savoir si votre prix de vente couvre bien le coût de revient et dégage la marge attendue.",
      tip: "La marge se calcule sur le coût réel observé, pas sur une estimation théorique.",
    },
    "analyse-marge-open": {
      title: "Ouvrir l'analyse",
      body: "Ouvrons l'analyse de marge & prix du Biscuit sablé du Moulin. Le dialog se charge avec vos données de vente réelles sur la période choisie.",
      tip: "Cliquez sur le bouton pour lancer le calcul.",
    },
    "analyse-marge-kpis": {
      title: "Les indicateurs clés",
      body: "En tête : volume vendu, CA net, prix moyen, coût unitaire et surtout le taux de marge (ici ~53 %). Vous lisez en un instant si le Biscuit sablé est rentable sur la période, sans avoir à ressortir une calculatrice. Un taux de marge qui baisse est le premier signal d'alerte.",
      tip: "La période (3 / 6 / 12 mois) et l'inclusion de la main-d'œuvre s'ajustent en haut du dialog.",
    },
    "analyse-marge-evolution": {
      title: "L'évolution dans le temps",
      body: "Le graphique mensuel montre comment le prix de vente, le coût et la marge du Biscuit sablé évoluent mois après mois. Si le coût de la farine grimpe sans que votre prix de vente suive, la courbe de marge se resserre visuellement — vous repérez l'érosion bien avant qu'elle ne pèse sur vos comptes.",
      tip: "Une marge qui se réduit régulièrement signale souvent un coût matière en hausse à répercuter.",
    },
    "analyse-marge-clients": {
      title: "La marge par client",
      body: "Le tableau détaille la rentabilité client par client, avec la comparaison au tarif catalogue. Vous voyez immédiatement qui achète le Biscuit sablé sous votre tarif (marge de négociation à récupérer) et quel client est le plus rentable. C'est la base concrète pour arbitrer remises et conditions commerciales.",
      tip: "Un gros volume vendu trop bas peut rapporter moins qu'un petit client au tarif plein.",
    },
    "analyse-marge-pricing": {
      title: "L'aide à la tarification",
      body: "Le simulateur propose un prix cible selon un taux de marge visé, à partir du coût réel observé du Biscuit sablé. Des conseils automatiques pointent les opportunités (client sous tarif, meilleur client à fidéliser…). Vous fixez ainsi vos prix sur des chiffres réels, pas au feeling.",
      tip: "Parfait pour fixer le prix d'un nouveau client en connaissance de cause.",
    },
    "analyse-marge-outro": {
      title: "Ce que révèle l'analyse de marge",
      body: "Vous savez lire l'analyse de marge : KPIs, évolution, marge par client et aide tarifaire. Sur le Biscuit sablé du Moulin, vous disposez maintenant de toute la matière pour défendre un prix ou repérer un client à renégocier. Les analyses Achats et Fabrication suivent la même logique, côté approvisionnement et coût de revient.",
      tip: "Relancez l'analyse après chaque hausse de tarif pour vérifier l'effet réel sur la marge.",
    },
    "achat-intro": {
      title: "Analyser les achats",
      body: "L'analyse achats se fait sur une matière première. Passons sur la fiche de la farine — l'ingrédient principal du Biscuit sablé. Son prix d'achat remonte toute la nomenclature jusqu'au coût du biscuit : maîtriser cet achat, c'est agir à la source de votre marge.",
      tip: "Elle agrège vos vraies réceptions et commandes fournisseurs.",
    },
    "achat-btn": {
      title: "Analyse achats",
      body: "Ce bouton ouvre l'analyse d'achat de la farine : combien vous en achetez, à quel prix, auprès de quels fournisseurs et avec quelle qualité. C'est l'outil pour savoir si vous payez votre farine au bon prix et chez le bon fournisseur, avant même de penser à négocier.",
      tip: "Le prix au kg affiché est le prix réellement payé, ports et écarts de réception inclus.",
    },
    "achat-open": {
      title: "Ouvrir l'analyse",
      body: "Ouvrons l'analyse des achats de la farine. Le dialog rassemble vos réceptions et commandes fournisseurs sur la période choisie.",
      tip: "Cliquez sur le bouton pour lancer le calcul.",
    },
    "achat-kpis": {
      title: "Les indicateurs d'achat",
      body: "Volume reçu, coût total, prix moyen au kg, évolution du prix, taux de conformité et délai de livraison moyen : l'état de santé de votre approvisionnement en farine en un coup d'œil. Si le prix moyen au kg dérive, vous le voyez ici avant que ça ne pèse sur le coût du biscuit.",
      tip: "Comparez le prix moyen actuel à celui des mois précédents pour anticiper une hausse.",
    },
    "achat-fournisseurs": {
      title: "Comparer les fournisseurs",
      body: "Le tableau classe vos fournisseurs de farine par volume et par coût, avec le prix payé face au tarif catalogue. On repère vite le moins cher et le plus fiable, et on évite de tout concentrer chez un fournisseur trop cher par habitude.",
      tip: "Ici le fournisseur principal est ~7 % moins cher que le second.",
    },
    "achat-conformite": {
      title: "Conformité & délais",
      body: "Taux de conformité et délais de livraison par fournisseur : un fournisseur de farine peu cher mais souvent non conforme ou en retard peut coûter plus cher au final (lots refusés, production retardée). Le prix au kg ne dit pas tout — la fiabilité compte autant.",
      tip: "Un fournisseur à 100 % conforme justifie parfois quelques centimes de plus au kg.",
    },
    "achat-nego": {
      title: "Aide à la négociation",
      body: "Le simulateur estime l'économie annuelle possible en concentrant les volumes de farine chez le meilleur fournisseur ou en négociant au tarif catalogue. Des conseils automatiques pointent les leviers concrets — vous arrivez en rendez-vous fournisseur avec des chiffres, pas des impressions.",
      tip: "Présentez votre volume annuel total : c'est votre principal argument de négociation.",
    },
    "analyse-achat-outro": {
      title: "De l'achat au coût de revient",
      body: "Vous savez analyser un achat : prix, fournisseurs, conformité et leviers de négociation. Sur la farine, vous tenez désormais l'amont du coût de revient de votre biscuit. Passons maintenant à l'aval : le coût de revient du produit fini.",
      tip: "Refaites ce diagnostic sur vos 2-3 matières les plus coûteuses pour le plus d'impact.",
    },
    "fab-intro": {
      title: "Analyser la fabrication",
      body: "Retour sur le Biscuit sablé du Moulin. L'analyse fabrication décompose son coût de revient réel, calculé à partir de vos ordres de fabrication clôturés. Au-delà du coût matière, elle intègre la main-d'œuvre et les écarts de consommation pour donner le vrai prix de production.",
      tip: "Le coût de revient réel diffère souvent du coût théorique de la nomenclature.",
    },
    "fab-btn": {
      title: "Analyse fabrication",
      body: "Ce bouton ouvre l'analyse du coût de revient : combien coûte réellement de produire le Biscuit sablé, et d'où vient ce coût. C'est ce coût réel qui sert de référence à l'analyse de marge — boucler la boucle entre production et vente.",
      tip: null,
    },
    "fab-open": {
      title: "Ouvrir l'analyse",
      body: "Ouvrons l'analyse de fabrication du Biscuit sablé. Le dialog rassemble vos OF clôturés et leurs consommations réelles.",
      tip: "Cliquez sur le bouton pour lancer le calcul.",
    },
    "fab-kpis": {
      title: "Le coût de revient",
      body: "Coût matière, coût main-d'œuvre et coût total unitaires, quantité produite, nombre d'OF et écart de consommation vs théorique : la rentabilité de production en synthèse. Un écart de consommation positif (vous consommez plus de farine que prévu) ronge directement votre marge.",
      tip: "Surveillez l'écart vs théorique : c'est souvent là que se cache la perte invisible.",
    },
    "fab-composants": {
      title: "Le poids des composants",
      body: "Le tableau décompose le coût matière composant par composant, avec leur part. Ici la farine pèse ~52 % du coût matière du biscuit — c'est là que se jouent les économies. Inutile de chasser quelques centimes sur un arôme à 1 % quand le gros levier est la farine.",
      tip: "Cliquez un composant pour voir le détail par OF.",
    },
    "fab-of": {
      title: "Le détail par OF",
      body: "Chaque ordre de fabrication apparaît avec son coût unitaire et sa cadence. On repère immédiatement un OF hors norme — un lot de biscuits où la farine a été sur-consommée ou la cadence anormalement basse. C'est le point d'entrée pour comprendre une dérive ponctuelle de coût.",
      tip: "Un OF isolé très coûteux mérite une vérification : casse, erreur de pesée, panne machine ?",
    },
    "fab-simulateur": {
      title: "Le simulateur de coût",
      body: "Le simulateur chiffre l'impact d'une baisse de prix d'achat de la farine ou d'un meilleur rendement matière sur le coût annuel du biscuit. Des conseils pointent les principaux leviers — vous voyez en euros ce que rapporterait, par exemple, 2 % d'économie sur la farine.",
      tip: "Combinez ce simulateur avec l'aide à la négociation achats pour chiffrer un objectif réaliste.",
    },
    "analyse-fab-outro": {
      title: "Les trois analyses en main",
      body: "Marge, achats, fabrication : les trois analyses couvrent la rentabilité du Biscuit sablé à partir de vos vraies données. Du prix d'achat de la farine jusqu'au prix facturé au client, vous tenez toute la chaîne de valeur.",
      tip: "Refaites le tour des trois analyses chaque trimestre pour garder la main sur vos marges.",
    },
    "analyse-marge-menu": {
      title: "Ouvrir le menu des analyses",
      body: "Depuis la refonte de l'aside, les analyses de l'article sont regroupées dans le menu « Statistiques & analyses ». Cliquez sur le bouton pour l'ouvrir.",
      tip: "Ce menu rassemble les statistiques, la marge & les prix, les achats, la fabrication et le planificateur.",
    },
    "achat-menu": {
      title: "Ouvrir le menu des analyses",
      body: "L'analyse des achats se trouve elle aussi dans le menu « Statistiques & analyses » de l'aside. Cliquez sur le bouton pour l'ouvrir.",
      tip: "Le même menu depuis n'importe quelle fiche article.",
    },
    "fab-menu": {
      title: "Ouvrir le menu des analyses",
      body: "L'analyse de fabrication est également dans le menu « Statistiques & analyses ». Cliquez sur le bouton pour l'ouvrir.",
      tip: "Dernière analyse du parcours : le coût de revient réel.",
    },
    "tdb-intro": {
      title: "Votre tableau de bord",
      body: "C'est l'écran d'accueil de la Boulangerie du Moulin : une vue synthétique de votre activité via des widgets. En un coup d'œil, vous voyez où en est la production des Biscuits sablés du Moulin, le chiffre d'affaires et la valeur de votre stock. Chacun, du gérant au responsable atelier, retrouve l'essentiel sans ouvrir dix menus.",
      tip: "Des onglets dédiés existent aussi : Financier, Stock, Production — pour creuser un sujet précis.",
    },
    "tdb-planning": {
      title: "Activité à venir",
      body: "En haut, l'agenda regroupe tout ce qui vous attend, jour par jour : commandes de farine à envoyer, réceptions fournisseurs, OF de biscuits à lancer, expéditions vers vos clients, factures à émettre. Le compteur « X évts · Y en retard » signale d'un coup d'œil ce qui est à traiter aujourd'hui et ce qui a déjà pris du retard, pour ne rien oublier en pleine fournée.",
      tip: "Chaque tuile est cliquable et mène directement au document concerné. C'est votre to-do quotidien.",
    },
    "tdb-widgets": {
      title: "Les widgets",
      body: "Chaque carte est un widget : un indicateur chiffré ou un graphique. La grille est entièrement personnalisable — vous déplacez, ajoutez ou retirez les widgets selon votre rôle. Un gérant suivra le CA et la marge, tandis qu'un chef d'atelier préférera la production et les lots à surveiller.",
      tip: "Glissez-déposez une carte pour la repositionner : votre disposition est mémorisée.",
    },
    "tdb-ca": {
      title: "Chiffre d'affaires",
      body: "Ce widget répartit votre CA — ici par client. Vous voyez par exemple quelle part vient de votre revendeur principal pour les Biscuits sablés du Moulin, et la marge globale s'affiche en dessous. Les onglets Article / Famille / Groupe changent l'angle d'analyse pour identifier les produits et clients qui rapportent vraiment.",
      tip: "Idéal pour repérer vos clients clés et mesurer votre dépendance commerciale.",
    },
    "tdb-valeur": {
      title: "Valeur du stock",
      body: "Ce widget répartit la valeur de votre stock par famille technique : matières premières (farine, beurre, sucre) d'un côté, produits finis (Biscuits sablés du Moulin) de l'autre. C'est l'argent immobilisé dans vos rayonnages — un repère utile avant de commander ou de lancer une grosse fournée. Cliquez « Voir tout » pour le détail par article, lot et entrepôt.",
      tip: "Une valeur de matières premières qui grimpe peut signaler un surstock à écouler avant la DDM.",
    },
    "tdb-ca-periode": {
      title: "CA par période",
      body: "L'évolution de votre chiffre d'affaires mois par mois, sous forme de barres. Pour une boulangerie, c'est précieux : vous visualisez vite les pics de fin d'année sur les biscuits et les creux de l'été, et vous comparez d'un coup deux périodes pour ajuster vos achats et votre planning de production.",
      tip: "Repérez vos mois forts pour anticiper les approvisionnements en farine et beurre.",
    },
    "tdb-ca-cumule": {
      title: "CA cumulé",
      body: "La même donnée, cumulée dans le temps : la courbe monte tant que vous facturez. Elle vous montre la progression de la Boulangerie du Moulin vers son objectif annuel, et permet de voir si l'année est en avance ou en retard par rapport à la précédente.",
      tip: "Comparez la pente avec celle de l'an dernier : un aplatissement signale un ralentissement des ventes.",
    },
    "tdb-production": {
      title: "Production par période",
      body: "La quantité produite par ligne et par période. Idéal pour suivre la cadence et comparer les mois.",
      tip: null,
    },
    "tdb-lots": {
      title: "Lots à surveiller",
      body: "Ce widget alerte sur les lots à DDM/DLC dépassée ou bloqués en non-conformité — un radar qualité pour éviter les ruptures réglementaires.",
      tip: null,
    },
    "tdb-refresh": {
      title: "Actualiser",
      body: "Recalcule à la demande les données de tous les widgets pour une vue à jour. Utile par exemple après avoir validé un OF de biscuits ou émis une facture le matin même : un clic et vos indicateurs reflètent la dernière activité, sans recharger toute la page.",
      tip: "Pensez à actualiser après une grosse session de saisie pour des chiffres fiables.",
    },
    "tdb-settings": {
      title: "Personnaliser",
      body: "Le bouton Paramètres ouvre le catalogue de widgets : ajoutez ceux qui comptent pour vous (CA, productivité, qualité, lots à surveiller…) et organisez votre tableau. À la Boulangerie du Moulin, le gérant garde le CA et la marge en haut, le responsable production met en avant les OF et la valeur de stock.",
      tip: "Composez un tableau par profil : ce qui sert au pilotage commercial n'est pas ce qui sert à l'atelier.",
    },
    "tdb-outro": {
      title: "Votre cockpit quotidien",
      body: "Le tableau de bord réunit en un écran l'agenda des tâches, le CA, la valeur de stock et la production. Couplé aux analyses de rentabilité, il vous fait passer du global au détail produit, du coût d'un biscuit jusqu'à la marge sur la facture.",
      tip: "Revenez-y chaque matin : c'est le réflexe qui structure votre journée.",
    },
    "ec-intro": {
      title: "L'évolution des coûts",
      body: "Chaque lot porte un historique de coût : prix de réception, coûts de production, revalorisations manuelles. Nous sommes sur l'onglet « Coûts » du lot de farine, la matière première de vos Biscuits sablés du Moulin. Suivre ce coût dans le temps vous permet de savoir, à tout moment, combien vous revient réellement un biscuit.",
      tip: "Le coût d'une matière première se propage à tous les produits qui la consomment : revaloriser la farine fait remonter le coût jusqu'au biscuit, puis sur la facture client.",
    },
    "ec-table": {
      title: "L'historique de coût",
      body: "Le tableau retrace l'évolution du coût unitaire du lot de farine dans le temps : ici une réception à 0,85 €/kg, puis une revalorisation à 0,92 €/kg. Chaque ligne indique sa source (réception, OF, manuelle), pour que vous sachiez d'où vient chaque variation. C'est votre journal de bord du prix de revient.",
      tip: "Une hausse régulière sur plusieurs réceptions est le signal qu'il faut renégocier avec le fournisseur ou répercuter sur vos tarifs.",
    },
    "ec-add": {
      title: "Revaloriser un coût",
      body: "Le bouton « Revaloriser » permet de corriger manuellement le coût d'un lot, avec un commentaire justificatif. Concrètement : votre meunier annonce une hausse de la farine, vous passez le lot de 0,85 à 0,92 €/kg sans attendre la prochaine réception. Le commentaire garde la trace de la raison (hausse fournisseur, erreur de saisie…).",
      tip: "Renseignez toujours un commentaire clair : dans six mois, vous comprendrez en un coup d'œil pourquoi ce coût a bougé.",
    },
    "ec-cascade-btn": {
      title: "L'impact cascade",
      body: "C'est le cœur du simulateur : quand le coût d'une matière change, JustUp recalcule en cascade le coût de tous les OF et produits finis qui la consomment. Si la farine grimpe, le simulateur remonte la nomenclature jusqu'au Biscuit sablé du Moulin et chiffre le surcoût. Ce bouton liste les éléments impactés.",
      tip: "Plus la farine pèse dans la recette, plus son impact sur le coût final du biscuit est fort : la cascade le quantifie pour vous.",
    },
    "ec-cascade-open": {
      title: "Voir les impacts",
      body: "Ouvrons l'aperçu des impacts cascade. JustUp va dérouler tout ce qui dépend de ce lot de farine, du premier OF jusqu'au lot de biscuits prêt à vendre.",
      tip: "Un clic suffit : aucune saisie, le calcul est instantané et n'altère rien tant que vous ne validez pas.",
    },
    "ec-cascade": {
      title: "Les éléments impactés",
      body: "Le dialog liste les OF et lots de produits finis en aval — ici l'OF des biscuits et son lot. Revaloriser la farine met automatiquement à jour leur coût de revient : vous voyez sur la même ligne l'ancien et le nouveau prix de revient du biscuit. Plus besoin de refaire les calculs à la main.",
      tip: "Vous mesurez ainsi l'effet d'une hausse matière sur votre marge avant qu'elle ne vous surprenne, et vous pouvez ajuster vos tarifs en connaissance de cause.",
    },
    "ec-outro": {
      title: "Anticiper une hausse avant qu'elle n'arrive",
      body: "Vous savez lire l'évolution d'un coût, le revaloriser et mesurer son impact en cascade sur vos produits finis. Couplé aux analyses de marge, cela ferme la boucle du pilotage de rentabilité : au lieu de subir les hausses de matières, vous les voyez venir.",
      tip: "Prenez l'habitude de simuler une hausse matière en début de saison : vous saurez à l'avance s'il faut revoir le prix de vente du biscuit.",
    },
    // ===== PREMIERS PAS =====
    welcome: {
      title: "Bienvenue dans JustUp !",
      body: "JustUp est l'ERP agroalimentaire de la Boulangerie du Moulin. Ce tutoriel vous fait découvrir, en quelques clics, les grandes sections de l'application : du catalogue de vos Biscuits sablés du Moulin jusqu'à la facturation. L'objectif est de vous donner une vue d'ensemble avant de plonger dans chaque module en détail.",
      tip: "Vous pouvez déplacer ce panneau en glissant sa barre sombre. Quittez à tout moment, votre progression est sauvegardée.",
    },
    // --- Saisie des heures ---
    "sh-intro": {
      title: "Saisie des heures",
      body: "Avant de saisir les heures, il faut définir le planning de travail. Nous sommes sur le paramétrage utilisateurs, onglet « Planning par défaut » : ce sont les horaires appliqués par défaut à toute l'équipe de la Boulangerie du Moulin. Ce planning sert de référence pour comparer les heures réellement travaillées aux heures prévues, et pour calculer le coût de main-d'œuvre qui se répercute sur le prix de revient des Biscuits sablés du Moulin.",
      tip: "Chaque opérateur peut ensuite avoir un planning personnalisé qui surcharge ce défaut (ex : un boulanger en horaires du matin).",
    },
    "sh-planning-card": {
      title: "Le planning par défaut",
      body: "Cette carte affiche l'horaire prévu pour chaque jour de la semaine. Pour la Boulangerie du Moulin, on peut par exemple prévoir 8 h du lundi au vendredi. Il sert de base au calcul des heures théoriques et à leur comparaison avec les heures réellement saisies, ce qui permet de détecter les écarts et d'estimer le coût horaire de la production des biscuits.",
      tip: "Un planning réaliste évite de fausser les bilans de productivité : ajustez-le si vos horaires changent selon la saison.",
    },
    "sh-edit-planning": {
      title: "Modifier le planning",
      body: "Cliquez sur le crayon pour passer en mode édition et ajuster les horaires de chaque jour. Tant que vous n'avez pas enregistré, vos modifications ne sont pas prises en compte : c'est le moment de caler les horaires réels de l'atelier de la Boulangerie du Moulin.",
      tip: "Vous pourrez rééditer ce planning à tout moment si l'organisation de l'équipe évolue.",
    },
    "sh-fill-lundi": {
      title: "Saisir un horaire",
      body: "Renseignez l'horaire de travail du jour, par exemple « 08:00 » pour le lundi. Faites de même pour chaque jour ouvré. Ces horaires définissent le volume d'heures théoriques attendu : à la Boulangerie du Moulin, cela correspond au temps de présence prévu des opérateurs au fournil.",
      tip: "Laissez vide (ou à 0) les jours non travaillés, comme le dimanche, pour ne pas gonfler les heures théoriques.",
    },
    "sh-save-planning": {
      title: "Enregistrer le planning",
      body: "Sauvegardez : ce planning devient la référence d'horaires pour les saisies d'heures à venir. Désormais, chaque journée saisie sera comparée à ce volume théorique, ce qui permet de mesurer la productivité de l'atelier et d'alimenter les coûts de main-d'œuvre des OF de biscuits.",
      tip: "En cas d'oubli d'enregistrement, vos horaires ne seront pas pris en compte : vérifiez que la confirmation s'affiche bien.",
    },
    "sh-saisie-intro": {
      title: "Saisir les heures travaillées",
      body: "Direction la page « Saisie des heures » (Tâches journalières). C'est ici qu'on enregistre, chaque jour, le temps réellement travaillé par chaque opérateur de la Boulangerie du Moulin. Cette saisie quotidienne est la matière première du suivi de productivité et du coût réel de fabrication des biscuits.",
      tip: "Prenez l'habitude de saisir en fin de journée : les écarts avec le planning sont plus fiables à chaud.",
    },
    "sh-saisie-matrix": {
      title: "La matrice des heures",
      body: "La grille croise les opérateurs (lignes) et les jours (colonnes). Chaque cellule indique les heures saisies par rapport aux heures théoriques du planning défini juste avant. Sélectionnez une équipe pour afficher ses opérateurs, par exemple l'équipe du fournil de la Boulangerie du Moulin.",
      tip: "Une cellule en écart par rapport au théorique se repère vite : c'est votre signal pour vérifier la journée.",
    },
    "sh-saisie-of": {
      title: "Affecter les heures à un OF",
      body: "Pour chaque opérateur et chaque jour, on ajoute des lignes de travail : un temps affecté à un ordre de fabrication (par exemple l'OF des Biscuits sablés du Moulin), ou à un type particulier (congés, RTT, maladie…). C'est ce qui alimente les bilans de productivité et le coût de main-d'œuvre rattaché à chaque OF, et donc le prix de revient des biscuits.",
      tip: "La somme des temps saisis est comparée aux heures travaillées du planning pour valider la journée : visez l'équilibre.",
    },
    "sh-outro": {
      title: "Des heures saisies aux coûts réels",
      body: "Le planning est calé, les heures se saisissent au quotidien. Ces données nourrissent la planification, les bilans de production et le suivi des coûts : à la Boulangerie du Moulin, elles disent combien d'heures de main-d'œuvre entrent réellement dans chaque lot de Biscuits sablés du Moulin.",
      tip: "Reprenez ce module si vous changez d'organisation d'équipe ou ajoutez de nouveaux opérateurs.",
    },
    // --- Planification des composants ---
    "pc-intro": {
      title: "Planification des composants",
      body: "Cet écran anticipe vos besoins en composants. Pour chaque article, il calcule le stock prévisionnel jour par jour à partir du stock actuel, des commandes fournisseurs attendues (entrées) et des consommations d'OF et expéditions à venir (sorties). À la Boulangerie du Moulin, vous voyez ainsi quand la farine, le beurre ou le sucre vont manquer pour produire les Biscuits sablés du Moulin.",
      tip: "Objectif : repérer les ruptures à venir et déclencher les réapprovisionnements au bon moment, avant que la production ne soit bloquée.",
    },
    "pc-grille": {
      title: "La grille prévisionnelle",
      body: "Chaque ligne est un article, chaque colonne un jour. La barre indique le niveau de stock projeté : verte au-dessus du seuil de réappro, orange sous le réappro, rouge sous le seuil de sécurité. Un coup d'œil sur la ligne de la farine vous dit si vous tiendrez jusqu'à la prochaine livraison fournisseur.",
      tip: "Les couleurs reprennent les seuils définis sur la fiche article : une barre rouge signale un risque de rupture imminent.",
    },
    "pc-filtres": {
      title: "Filtrer les articles",
      body: "Utilisez les filtres pour cibler une famille, un fournisseur, ou n'afficher que les articles sous leur seuil de réapprovisionnement. Pratique pour traiter en priorité les cas critiques : par exemple n'afficher que les ingrédients secs (farine, sucre) achetés chez le même meunier afin de grouper une commande.",
      tip: "Filtrer par fournisseur vous aide à regrouper plusieurs réapprovisionnements en une seule commande et limiter les frais de port.",
    },
    "pc-tri": {
      title: "Trier par criticité",
      body: "Le tri par priorité remonte en tête les articles les plus critiques : ceux qui passent sous le seuil de sécurité en premier. La farine, consommée par l'OF de Biscuits sablés du Moulin, apparaît ici sous son seuil — c'est donc elle qu'il faut réapprovisionner en premier.",
      tip: "Commencez toujours par le haut de la liste triée : ce sont les articles dont la rupture arrive le plus tôt.",
    },
    "pc-cellule": {
      title: "Cliquer sur une case",
      body: "Cliquez sur la case d'un jour pour ouvrir son détail : stock projeté ce jour-là et événements prévus (commandes fournisseurs, OF, expéditions). Par exemple, en cliquant sur le jour où la farine passe au rouge, vous voyez l'OF de biscuits qui en consomme une grosse quantité.",
      tip: "Chaque case = un article × un jour. C'est le point d'entrée pour agir sur cette journée précise.",
    },
    "pc-popover-commande": {
      title: "Créer une commande en un clic",
      body: "Le détail du jour s'ouvre. Le bouton « Créer une commande » génère une commande de réapprovisionnement provisoire pour cet article, directement depuis la planification — le moyen le plus rapide de réagir à une rupture repérée. La quantité proposée vise à remonter le stock au-dessus du seuil de réappro.",
      tip: "La commande est ajoutée à un panier local ; vous la validez ensuite avec les autres, sans quitter cet écran.",
    },
    "pc-mode": {
      title: "Mode stock / flux",
      body: "Basculez l'affichage d'un article entre le stock prévisionnel (niveau cumulé jour après jour) et le flux (entrées et sorties de chaque jour). Le mode stock répond à « combien me reste-t-il de farine ? », le mode flux à « combien entre et sort chaque jour ? ». Le choix est mémorisé par article.",
      tip: "Le mode flux est idéal pour comprendre pourquoi un stock chute : il isole les grosses consommations d'OF.",
    },
    "pc-echelle": {
      title: "Échelle temporelle",
      body: "Choisissez l'horizon de planification : par jour (30 / 60 / 90 jours) pour le détail des prochaines semaines, ou par semaine (4 / 6 / 12 mois) pour une vision à plus long terme. La vue jour convient au pilotage quotidien des ingrédients ; la vue semaine aide à anticiper les commandes saisonnières (fêtes de fin d'année).",
      tip: "Restez en vue jour pour réagir vite ; passez en vue semaine ou mois pour planifier vos achats de fond.",
    },
    "pc-commande": {
      title: "Créer une commande de réappro",
      body: "La commande provisoire rejoint un panier local, sans ressaisir le fournisseur ni le prix d'achat déjà connus de la fiche article. Vous cumulez ainsi plusieurs réapprovisionnements avant de les valider d'un bloc.",
      tip: "Les commandes provisoires se regroupent automatiquement par fournisseur et date de livraison : moins de bons de commande à gérer.",
    },
    "pc-resume": {
      title: "Résumé des commandes",
      body: "Le résumé liste toutes vos commandes provisoires regroupées par fournisseur. Vous pouvez ajuster les quantités puis les valider en une fois — elles deviennent alors de vraies commandes fournisseurs, prêtes à être envoyées au meunier ou au grossiste.",
      tip: "Vérifiez les quantités avant validation : une fois validées, les commandes alimentent les entrées de stock prévues dans la grille.",
    },
    "pc-outro": {
      title: "Anticiper plutôt que subir les ruptures",
      body: "Lecture du stock prévisionnel, repérage des articles critiques, réappro déclenché au bon moment : à la Boulangerie du Moulin, ce réflexe évite d'arrêter une fournée faute de farine ou de beurre.",
      tip: "Prenez l'habitude de consulter cet écran chaque matin : quelques minutes suffisent pour sécuriser la production de la journée.",
    },
    "open-menu-premiers-pas": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral : c'est le point de départ de toute navigation dans JustUp. Tous les modules, du paramétrage à la production, y sont regroupés par grandes familles d'usage.",
      tip: "Le menu latéral reste accessible partout dans l'application : c'est votre boussole au quotidien.",
    },
    // 1. Données de base
    "menu-infos": {
      title: "Données de base",
      body: "La première section regroupe tout votre référentiel : articles, spécifications produit, lignes de production, paramétrage activité et fournisseurs/clients. C'est ici que vous décrivez une bonne fois pour toutes vos farines, vos recettes et vos équipements ; tout le reste de JustUp s'appuie ensuite sur ces données. Un référentiel bien tenu, c'est des OF justes et des coûts fiables.",
      tip: "C'est la section la plus utilisée au quotidien et la première à renseigner sur un nouvel espace.",
    },
    "menu-articles": {
      title: "Articles",
      body: "Votre catalogue produit : matières premières (farine, beurre, sucre), emballages et produits finis comme le Biscuit sablé du Moulin. Chaque article a sa fiche avec code, famille, unité et spécification associée. C'est le socle de la traçabilité : chaque lot reçu ou produit est rattaché à un article.",
      tip: "Classez vos articles par famille dès le départ : vous gagnerez du temps dans les filtres et les statistiques.",
    },
    "menu-etapes": {
      title: "Spécifications produit",
      body: "Les fiches techniques de vos produits finis : nomenclature (liste des ingrédients et quantités), procédés de fabrication et contrôles qualité à réaliser. Pour le Biscuit sablé, la spécification dit qu'il faut tant de farine, tant de beurre, et quelles étapes suivre. C'est elle qui permet à JustUp de calculer le coût de revient et de lancer un OF complet.",
      tip: "Une spécification se valide quand elle est complète : nomenclature, process et contrôles cohérents.",
    },
    "menu-lignes": {
      title: "Lignes de production",
      body: "Vos équipements de production : le four, le pétrin, la ligne d'emballage… Chaque ligne a sa cadence, ses opérations et ses paramètres de coût (coût horaire, capacité). Ces données servent à planifier la fabrication des biscuits et à affecter le coût machine sur chaque OF.",
      tip: "Renseignez la cadence réelle de chaque ligne : c'est elle qui fiabilise la durée estimée des OF.",
    },
    "menu-parametrage": {
      title: "Paramétrage activité",
      body: "Les réglages métier de votre boulangerie : énumérations (familles d'articles, types de travail), contrôles qualité réutilisables, unités d'expédition (carton, palette) et paramètres généraux. Ces listes de valeurs alimentent les menus déroulants partout dans l'app : bien les définir évite les doublons et les saisies libres incohérentes.",
      tip: "Définissez ces listes avant de créer vos articles : elles s'utilisent dès la première fiche.",
    },
    "menu-tiers": {
      title: "Fournisseurs et clients",
      body: "Votre carnet d'adresses : fournisseurs de matières premières (minoterie, laiterie), clients distributeurs, contacts et adresses de livraison. Chaque tiers est réutilisé dans les commandes, les réceptions et les factures, avec ses conditions tarifaires propres.",
      tip: "Renseignez l'adresse de livraison et les conditions de paiement : elles sont reprises automatiquement sur les documents.",
    },
    // 2. Tâches journalières
    "menu-daily": {
      title: "Tâches journalières",
      body: "Cette section regroupe la gestion du quotidien : listes de tâches et saisie des heures de travail. C'est l'espace de vos opérateurs au jour le jour, là où le travail réel se note et alimente le suivi de production.",
      tip: null,
    },
    "menu-todo": {
      title: "Listes de tâches",
      body: "Vos opérateurs y retrouvent leur planning du jour et leurs tâches à réaliser : préparer une pâte, surveiller une cuisson, emballer un lot. Cocher une tâche fait avancer le suivi de production en temps réel.",
      tip: null,
    },
    "menu-info-journalieres": {
      title: "Saisie des heures",
      body: "Enregistrez les heures de travail par opérateur et par poste. Ces heures alimentent le suivi de productivité et, surtout, le coût de main-d'œuvre affecté à chaque OF : si l'on passe 3 h sur la fournée de biscuits, ce temps remonte dans le coût de revient.",
      tip: "Saisir les heures régulièrement fiabilise vos bilans de production et vos marges.",
    },
    // 3. Inventaire
    "menu-inventaire": {
      title: "Inventaire",
      body: "Gestion des stocks : inventaires physiques, mouvements de stock et transferts entre entrepôts. C'est ici que vous gardez la vérité sur ce que vous avez réellement en magasin — combien de kilos de farine, combien de cartons de biscuits prêts à partir.",
      tip: null,
    },
    // 4. Production
    "menu-production": {
      title: "Production",
      body: "Le cœur de l'activité : suivi des productions en temps réel, ordres de fabrication (OF), planification et statistiques. C'est ici que la recette devient des biscuits : on lance un OF, on consomme la farine et le beurre, on enregistre les contrôles et on récupère les produits finis.",
      tip: null,
    },
    // 5. Commandes
    "menu-commandes": {
      title: "Commandes",
      body: "Tout le cycle achat/vente : commandes fournisseurs, déchargements, commandes clients et expéditions. C'est le flux commercial complet, depuis l'achat de la farine jusqu'à l'envoi des biscuits chez le distributeur.",
      tip: null,
    },
    // 6. Administration
    "menu-admin": {
      title: "Administration",
      body: "Réservé aux administrateurs : factures et avoirs, gestion des équipes, paramétrage de l'entreprise et des utilisateurs. C'est ici que se gèrent l'identité légale de la Boulangerie du Moulin et les droits d'accès de chacun.",
      tip: null,
    },
    "menu-cost-impact": {
      title: "Impact des coûts",
      body: "Analysez l'impact des variations de coûts sur vos marges et vos prix de revient. Si le prix de la farine grimpe, vous voyez immédiatement comment le coût du Biscuit sablé évolue et où votre marge se tend.",
      tip: "Idéal pour décider d'une hausse de tarif ou d'un changement de fournisseur en connaissance de cause.",
    },
    "menu-admin-settings": {
      title: "Paramétrage administratif",
      body: "Identité de l'entreprise (SIRET, forme juridique), numérotations des documents et mentions commerciales. Ces réglages se retrouvent sur toutes vos factures et bons de livraison. Un tutoriel dédié vous accompagne pas à pas dans cette configuration.",
      tip: "À configurer en priorité : ces informations sont reprises automatiquement sur vos documents officiels.",
    },
    outro: {
      title: "Vous connaissez le menu !",
      body: "Vous avez fait le tour des grandes sections de JustUp, des données de base jusqu'à l'administration, et vous voyez maintenant où trouver chaque fonctionnalité. Pour aller plus loin, lancez les tutoriels dédiés depuis la carte en haut du menu : ils vous guident pas à pas dans le paramétrage et chaque processus métier.",
      tip: "Suivez les tutoriels dans l'ordre proposé : ils se complètent du paramétrage jusqu'à la facturation.",
    },
    "menu-inventaire-sub": {
      title: "Inventaires",
      body: "Réalisez vos inventaires physiques et suivez les écarts de stock entre le théorique et le réel. Un inventaire régulier corrige les dérives (pertes, casse, démarque) et garde vos coûts justes.",
      tip: null,
    },
    "menu-mouvements": {
      title: "Mouvements de stocks",
      body: "Consultez l'historique complet de tous les mouvements : entrées (réceptions de farine), sorties (consommation en OF), transferts et ajustements. Chaque mouvement est tracé et daté, ce qui permet de reconstituer le parcours d'un lot du fournisseur au biscuit fini.",
      tip: null,
    },
    "menu-transferts": {
      title: "Transferts",
      body: "Transférez des marchandises entre vos différents entrepôts et sites : par exemple déplacer un stock de farine du magasin de réception vers l'atelier de production. Le transfert met à jour les deux stocks d'un coup, sans perte de traçabilité.",
      tip: null,
    },
    "menu-suivi-production": {
      title: "Suivi des productions",
      body: "Suivez en temps réel l'avancement de vos productions en cours : quel OF est en pétrissage, lequel est au four, lequel attend l'emballage. Une vue d'ensemble idéale pour piloter l'atelier au quotidien.",
      tip: null,
    },
    "menu-ofs": {
      title: "Ordres de fabrication",
      body: "Créez et gérez vos OFs : quantités à produire, composants à consommer, lignes de production utilisées. Un OF de 2 000 Biscuits sablés réserve automatiquement la farine et le beurre nécessaires d'après la spécification, et planifie le passage sur le four.",
      tip: null,
    },
    "menu-of-plannif": {
      title: "Planification",
      body: "Planifiez vos ordres de fabrication sur un calendrier visuel : positionnez chaque OF dans le temps en fonction de la disponibilité du four et des opérateurs. Une bonne planification évite les goulots et lisse la charge de l'atelier.",
      tip: null,
    },
    "menu-article-planification": {
      title: "Planification des composants",
      body: "Anticipez vos besoins en matières premières en fonction des OFs planifiés. JustUp calcule, jour par jour, le stock prévisionnel de chaque article : vous voyez à l'avance quand la farine passera sous le seuil et déclenchez la commande avant la rupture.",
      tip: null,
    },
    "menu-non-conformites": {
      title: "Non-conformités",
      body: "Déclarez et suivez les non-conformités détectées en production ou à la réception : un lot de farine hors spécification, une fournée de biscuits trop cuits. Chaque NC est tracée, traitée et sert de base à l'amélioration continue.",
      tip: null,
    },
    "menu-commandes-fourni": {
      title: "Commandes fournisseurs",
      body: "Passez vos commandes de matières premières auprès de vos fournisseurs : farine à la minoterie, beurre à la laiterie, emballages. La commande prépare la réception et permet de comparer les quantités commandées et reçues.",
      tip: null,
    },
    "menu-dechargements": {
      title: "Déchargements",
      body: "Réceptionnez les marchandises livrées par vos fournisseurs et contrôlez les quantités réellement reçues. Le déchargement crée les lots en stock et rattache le bon de livraison : c'est le point d'entrée de la traçabilité, par exemple à l'arrivée d'une palette de farine.",
      tip: null,
    },
    "menu-commandeclient": {
      title: "Commandes clients",
      body: "Gérez les commandes de vos clients : articles, quantités, dates de livraison. Une commande de 500 paquets de Biscuits sablés pour le 20 du mois déclenche la planification de la production et la préparation de l'expédition.",
      tip: null,
    },
    "menu-expeditions": {
      title: "Expéditions",
      body: "Préparez et expédiez les commandes clients avec suivi des palettes et bons de livraison. C'est l'étape qui sort vos Biscuits sablés du stock : on prépare les cartons, on les palettise puis on édite le BL qui accompagne la marchandise.",
      tip: null,
    },
    "menu-facture": {
      title: "Factures et avoirs",
      body: "Gérez la facturation : factures clients, factures fournisseurs et avoirs. La facture reprend automatiquement les quantités livrées et les prix négociés du tiers, et porte l'identité légale et les mentions définies dans le paramétrage administratif.",
      tip: null,
    },
    "menu-equipes": {
      title: "Gestion des équipes",
      body: "Créez des équipes et attribuez des rôles et permissions aux utilisateurs. Vous décidez ici qui peut produire, qui peut facturer et qui peut paramétrer : chacun ne voit que ce qui le concerne.",
      tip: null,
    },
    "menu-user-settings": {
      title: "Paramétrage utilisateurs",
      body: "Configurez les profils d'accès (Pass) et les préférences par utilisateur. Chaque opérateur, chef de production ou administrateur a son profil, sa langue et ses droits : c'est ce qui personnalise l'expérience de chacun dans JustUp.",
      tip: null,
    },

    // ===== PARAMETRAGE ADMIN =====
    "admin-intro": {
      title: "Paramétrage de votre entreprise",
      body: "Ce tutoriel vous guide dans la configuration administrative de la Boulangerie du Moulin : identité légale, préfixes de numérotation et mentions commerciales. C'est la fondation de votre espace : ces réglages sont repris automatiquement partout dans JustUp. Bien les poser maintenant vous évite des corrections fastidieuses plus tard.",
      tip: "Ces informations apparaîtront sur vos documents officiels (factures et bons de livraison de vos Biscuits sablés du Moulin).",
    },
    "open-menu": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral pour naviguer vers la bonne section. C'est depuis ce menu que vous accédez à tous les modules de JustUp, du paramétrage à la production.",
      tip: "Le menu latéral reste accessible partout : c'est votre point de départ pour toute navigation.",
    },
    "open-admin-section": {
      title: "Section Administration",
      body: "Déployons la section Administration du menu pour accéder au paramétrage. Elle regroupe tous les réglages structurants de votre établissement : identité, numérotations et documents.",
      tip: "La section Administration est réservée aux droits admin : c'est ici que se règle la configuration de fond.",
    },
    "open-menu-activite": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral pour accéder au paramétrage activité. C'est le point d'entrée vers toutes les listes de valeurs et les réglages globaux de la Boulangerie du Moulin.",
      tip: null,
    },
    "open-infos-section": {
      title: "Section Données de base",
      body: "Déployons la section « Données de base » pour accéder au paramétrage activité. C'est ici que sont regroupés les réglages structurants partagés par tous les modules (catalogue, production, qualité).",
      tip: null,
    },
    "nav-admin": {
      title: "Ouvrir le paramétrage admin",
      body: "Cliquez sur « Paramétrage administratif » pour accéder aux réglages. Vous y trouverez les onglets Mon entreprise, Numérotations, Adresses et Documents qui définissent l'identité de la Boulangerie du Moulin.",
      tip: "Tout est regroupé ici : pas besoin de chercher ailleurs pour configurer votre société.",
    },
    "tab-business": {
      title: "Onglet Mon entreprise",
      body: "Cliquez sur l'onglet « Mon entreprise » pour renseigner les informations légales de votre société. Ces données (raison sociale, SIRET, forme juridique) alimentent automatiquement vos factures et bons de livraison.",
      tip: "Renseigner ces champs une seule fois suffit : ils sont repris partout dans vos documents.",
    },
    "edit-infos": {
      title: "Passer en mode édition",
      body: "Cliquez sur le bouton crayon pour déverrouiller les champs et pouvoir modifier les informations. Par défaut la fiche est en lecture seule pour éviter toute modification accidentelle de données légales sensibles.",
      tip: "Pensez à enregistrer avant de quitter : tant que vous êtes en édition, le changement d'onglet est bloqué.",
    },
    "fill-denomination": {
      title: "Dénomination sociale",
      body: "Saisissez le nom officiel de votre entreprise tel qu'il figure au registre du commerce : « Boulangerie du Moulin ». C'est ce nom qui sera imprimé en en-tête de toutes vos factures et bons de livraison.",
      tip: "Ce nom apparaîtra sur tous vos documents commerciaux : saisissez-le exactement comme au Kbis.",
    },
    "fill-fj": {
      title: "Forme juridique",
      body: "Sélectionnez votre forme juridique (SAS, SARL, SA, etc.). Pour la Boulangerie du Moulin, choisissez « SARL ». Cette mention est obligatoire sur vos factures et conditionne certaines règles légales d'affichage.",
      tip: "SARL, SAS, EI, EURL… la forme choisie conditionne les mentions légales imprimées sous votre raison sociale.",
    },
    "fill-siret": {
      title: "Numéro SIRET",
      body: "Saisissez votre numéro SIRET (14 chiffres), par exemple « 81234567800019 ». Il identifie de manière unique votre établissement et est exigé sur toutes les factures destinées à vos clients professionnels.",
      tip: "Le SIRET combine le SIREN (9 chiffres) et le numéro d'établissement (5 chiffres).",
    },
    "fill-gs1": {
      title: "Code d'entreprise GS1",
      body: "Votre préfixe entreprise GS1 (ex: « 3012345 ») sert à générer les codes-barres (EAN-13/EAN-14) de vos Biscuits sablés du Moulin et les SSCC de vos palettes. Sans lui, l'étiquetage logistique normalisé est impossible.",
      tip: "Indispensable si vous éditez des étiquettes logistiques ou expédiez vers la grande distribution.",
    },
    "fill-date-exercice": {
      title: "Date de début d'exercice",
      body: "Définit le début de votre exercice comptable (ex: « 01/01 »). JustUp s'en sert pour borner les statistiques, le chiffre d'affaires des Biscuits sablés du Moulin et les analyses par période. Une date juste garantit des bilans cohérents.",
      tip: "La plupart des boulangeries calent leur exercice sur l'année civile : début au 1er janvier.",
    },
    "intro-identite": {
      title: "Identité visuelle",
      body: "Ajoutez votre logo et votre couleur d'entreprise : ils apparaîtront sur vos documents commerciaux (factures, bons de livraison) et personnalisent votre espace de travail. Pour la Boulangerie du Moulin, un logo soigné renforce l'image de marque auprès de vos clients.",
      tip: "Privilégiez un logo au format PNG sur fond transparent pour un rendu net sur les documents.",
    },
    "save-infos": {
      title: "Enregistrer",
      body: "Cliquez sur Enregistrer pour sauvegarder les informations de votre entreprise. C'est aussi nécessaire pour débloquer le changement d'onglet : tant que la fiche est en édition, JustUp protège vos saisies non sauvegardées.",
      tip: "Vous pourrez modifier ces informations à tout moment en repassant en mode édition.",
    },
    "tab-numbering": {
      title: "Onglet Numérotations",
      body: "Passons aux préfixes de numérotation. Cliquez sur l'onglet « Numérotations ». Ces préfixes structurent l'identifiant de chaque document (lots, OF, commandes...) et facilitent la traçabilité au quotidien.",
      tip: "Une numérotation lisible vous fera gagner du temps quand vous rechercherez un lot ou un OF précis.",
    },
    "intro-numerotations": {
      title: "Les préfixes de vos documents",
      body: "Chaque type de document (lot, OF, commande, facture...) a un préfixe de 2 à 4 caractères. Les numéros sont ensuite auto-incrémentés, ce qui garantit des identifiants uniques et sans trou dans la séquence.",
      tip: "Exemple : le préfixe « LT » donnera des lots numérotés LT00001, LT00002, etc.",
    },
    "edit-numerotations": {
      title: "Modifier les préfixes",
      body: "Cliquez sur le bouton crayon pour pouvoir modifier les préfixes. Comme pour les informations de l'entreprise, l'écran est verrouillé par défaut afin d'éviter de changer une numérotation par mégarde.",
      tip: "Fixez vos préfixes dès le départ : changer en cours de route rend l'historique moins lisible.",
    },
    "fill-prefix-lot": {
      title: "Préfixe lots",
      body: "Saisissez le préfixe pour la numérotation de vos lots de production (2 à 4 caractères), par exemple « LT ». Chaque fournée de Biscuits sablés du Moulin recevra un numéro de lot du type LT00001, clé de votre traçabilité.",
      tip: "Les lots tracent chaque production. Un bon préfixe est court et identifiable (ex: LT, LOT).",
    },
    "fill-prefix-of": {
      title: "Préfixe ordres de fabrication",
      body: "Saisissez le préfixe pour vos OFs (ordres de fabrication), par exemple « OF ». Chaque lancement de production de biscuits portera un numéro type OF00001, qui relie la recette, les lots consommés et la quantité fabriquée.",
      tip: "L'OF est le document central de la production. Préfixes courants : OF, FAB.",
    },
    "save-numerotations": {
      title: "Enregistrer les numérotations",
      body: "Cliquez sur Enregistrer. Les préfixes seront appliqués aux prochains documents créés : vos futurs lots et OF de Biscuits sablés du Moulin adopteront immédiatement la nouvelle numérotation.",
      tip: "Les documents existants ne sont pas impactés : seuls les nouveaux suivent les préfixes mis à jour.",
    },
    "tab-addresses": {
      title: "Onglet Adresses",
      body: "Cliquez sur « Adresses » pour gérer les adresses de votre entreprise (siège, entrepôts, sites de production). Pour la Boulangerie du Moulin, ce sont par exemple le fournil, le dépôt et le siège social.",
      tip: "Saisir vos sites une fois ici vous permet de les réutiliser partout sans les retaper.",
    },
    "intro-addresses": {
      title: "Vos adresses",
      body: "Les adresses représentent vos sites physiques : siège, entrepôts, ateliers.\nElles sont utilisées partout dans JustUp : commandes, livraisons, lignes de production, stocks.\nCréons l'adresse du siège de la Boulangerie du Moulin.",
      tip: "Une adresse bien renseignée s'affiche automatiquement sur vos bons de livraison et factures.",
    },
    "click-add-adresse": {
      title: "Ajouter une adresse",
      body: "Cliquez sur le bouton pour créer votre première adresse. Un formulaire s'ouvre pour saisir les coordonnées complètes du site.",
      tip: "Vous pourrez ajouter autant d'adresses que de sites : fournil, dépôt, points de vente.",
    },
    "adresse-dialog-intro": {
      title: "Formulaire d'adresse",
      body: "Renseignez les coordonnées du site. Cette adresse sera réutilisée dans la suite des tutoriels (lignes de production, commandes, etc.). Nous pré-remplissons ici un exemple pour aller plus vite.",
      tip: "Vérifiez bien le code postal et la commune : ils servent aux calculs de livraison et aux documents.",
    },
    "fill-adresse-denomination": {
      title: "Nom du site",
      body: "Saisissez « Boulangerie du Moulin - Siege » — c'est le nom qui identifiera ce site dans toute l'application, lors du choix d'une adresse de livraison ou de production.",
      tip: "Donnez un nom parlant à chaque site (Siege, Fournil, Depot) pour les retrouver facilement.",
    },
    "fill-adresse-numero": {
      title: "Numéro",
      body: "Saisissez « 12 ». C'est le numéro de voie de votre site, indispensable pour une adresse de livraison exploitable par vos transporteurs.",
      tip: null,
    },
    "fill-adresse-voie": {
      title: "Voie",
      body: "Saisissez « Route des Alpilles ». Le nom de voie complète l'adresse postale qui s'imprimera sur vos bons de livraison et factures.",
      tip: null,
    },
    "fill-adresse-cp": {
      title: "Code postal",
      body: "Saisissez « 13520 ». Le code postal localise précisément votre site et conditionne les zones de livraison.",
      tip: null,
    },
    "fill-adresse-commune": {
      title: "Commune",
      body: "Saisissez « Maussane-les-Alpilles ». La commune complète l'adresse et apparaît sur tous les documents liés à ce site.",
      tip: null,
    },
    "fill-adresse-pays": {
      title: "Pays",
      body: "Saisissez « France ». Le pays détermine notamment les règles de TVA et les mentions applicables sur vos documents commerciaux.",
      tip: null,
    },
    "save-adresse": {
      title: "Enregistrer l'adresse",
      body: "Cliquez sur Enregistrer pour créer l'adresse du siège. Elle devient immédiatement sélectionnable dans les commandes, livraisons et lignes de production de la Boulangerie du Moulin.",
      tip: "Vous pourrez modifier ou ajouter d'autres adresses à tout moment depuis cet onglet.",
    },
    "tab-documents": {
      title: "Onglet Documents",
      body: "Cliquez sur « Documents » pour configurer les mentions qui apparaissent sur vos documents commerciaux. C'est ici que vous personnalisez l'apparence et les textes légaux de vos factures et bons de livraison.",
      tip: "Bien renseigner ces mentions vous met en conformité et évite des relances de vos clients.",
    },
    "intro-documents": {
      title: "Mentions commerciales",
      body: "Définissez les mentions légales et conditions qui figureront sur vos bons de commande, factures et avoirs. Pour la Boulangerie du Moulin, on y indique par exemple les conditions de paiement et les pénalités de retard.",
      tip: "Préparez vos conditions générales de vente une fois : elles se reportent ensuite sur tous les documents.",
    },
    "admin-outro": {
      title: "Paramétrage terminé !",
      body: "Votre entreprise est configurée dans JustUp : identité, numérotations, adresse et mentions sont en place. Vous pouvez maintenant passer au paramétrage de votre activité (énumérations, contrôles qualité...) pour préparer la fabrication des Biscuits sablés du Moulin.",
      tip: "Revenez dans ce module à tout moment si vous devez ajuster une adresse ou une mention légale.",
    },

    // ===== PARAMETRAGE ACTIVITE =====
    "activite-intro": {
      title: "Paramétrage de votre activité",
      body: "Ce tutoriel configure le socle métier de JustUp pour la Boulangerie du Moulin : les listes de valeurs (familles d'articles, familles techniques, unités, types de travail) et les paramètres généraux. Ce sont ces réglages qui structurent ensuite tout votre catalogue et vos productions.",
      tip: "Ces réglages s'appliquent à tous les utilisateurs : prenez quelques minutes pour les poser proprement, vous gagnerez du temps sur tout le reste.",
    },
    "nav-parametrage": {
      title: "Ouvrir le paramétrage activité",
      body: "Dans le menu « Données de base », cliquez sur « Paramétrage activité ». Vous arrivez sur le hub qui centralise les énumérations, les contrôles généraux et les paramètres globaux de votre activité.",
      tip: null,
    },
    "tab-enums": {
      title: "Onglet Énumérations",
      body: "Cliquez sur l'onglet « Énumérations » pour accéder aux listes de valeurs personnalisables. Familles, familles techniques, unités et types de travail s'éditent ici, en glisser-déposer et saisie directe.",
      tip: null,
    },
    "intro-familles": {
      title: "Les familles d'articles",
      body: "Les familles servent surtout à l'analyse et aux statistiques : elles regroupent vos articles par catégorie pour suivre les performances et filtrer vos données. Pour la Boulangerie du Moulin, vous pourriez avoir « Produits finis », « Matières premières » ou « Emballages ».",
      tip: "Chaque famille peut contenir des sous-familles pour affiner le classement (ex: Produits finis → Biscuits → Sablés).",
    },
    "add-famille": {
      title: "Ajouter une famille",
      body: "Cliquez sur le bouton « + » pour créer votre première famille d'articles. Une ligne de saisie apparaît pour la nommer.",
      tip: null,
    },
    "fill-famille": {
      title: "Nommer la famille",
      body: "Saisissez « Produits finis » comme nom de famille. C'est sous cette catégorie que vous classerez vos biscuits sablés du Moulin et autres produits vendables.",
      tip: "Choisissez des libellés clairs : ils serviront ensuite à filtrer vos articles, vos statistiques et vos exports.",
    },
    "save-famille": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour créer la famille. Elle devient immédiatement sélectionnable lors de la création de vos articles.",
      tip: null,
    },
    "intro-sous-famille": {
      title: "Les sous-familles",
      body: "Chaque famille peut être découpée en sous-familles pour affiner vos analyses. Ce petit bouton « + » permet d'en créer : par exemple, sous « Produits finis » vous pourriez ajouter « Sablés » et « Madeleines ».\nNous n'en créons pas maintenant, mais l'outil reste là quand vous en aurez besoin.",
      tip: null,
    },
    "intro-familles-tech": {
      title: "Les familles techniques",
      body: "Les familles techniques font le lien entre un article et une ligne de production : elles définissent quel produit est fabricable sur quelle ligne. Pour la Boulangerie du Moulin, la famille « Biscuits » sera rattachée à votre ligne de cuisson des biscuits.",
      tip: "C'est grâce aux familles techniques que JustUp propose automatiquement les bonnes lignes lors de la planification.",
    },
    "add-famille-tech": {
      title: "Ajouter une famille technique",
      body: "Cliquez sur « + » pour créer la famille technique « Biscuits ». Elle sera réutilisée dans la suite des tutoriels pour relier vos articles à vos lignes de production.",
      tip: null,
    },
    "fill-famille-tech": {
      title: "Créer la famille Biscuits",
      body: "Saisissez « Biscuits » comme nom de famille technique. Vos biscuits sablés du Moulin seront rattachés à cette famille, qui pointera ensuite vers la ligne de fabrication adaptée.",
      tip: "Cette famille sera liée aux articles et aux lignes de production dans les prochains tutoriels.",
    },
    "save-famille-tech": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour créer la famille technique. Elle sera disponible dès la création de vos articles et lignes de production.",
      tip: null,
    },
    "intro-unites": {
      title: "Les unités de gestion",
      body: "Les unités de base (Kilogramme, Litre, Unité) sont fournies par défaut dans JustUp. Vous pouvez créer des unités personnalisées adaptées à la Boulangerie du Moulin, par exemple « Sachet de 200 g » ou « Carton de 24 sachets ».",
      tip: "Chaque unité custom définit un coefficient de conversion vers une unité de base : c'est ce qui permet à JustUp de convertir automatiquement les quantités sur les nomenclatures et les stocks.",
    },
    "intro-travaux": {
      title: "Les types de travail",
      body: "Les types de travail catégorisent les opérations de production : Pétrissage, Cuisson, Conditionnement, etc. Ils servent ensuite à la saisie des temps passés sur chaque étape de fabrication de vos biscuits.",
      tip: "Nous y reviendrons dans un tutoriel dédié à la production — pour l'instant, gardez en tête qu'ils alimentent le suivi des heures.",
    },
    "intro-autres-enums": {
      title: "Autres énumérations",
      body: "Vous remarquerez aussi les sections « Mode de règlement » et « Nature de NC » (non-conformité) plus bas. Ces listes serviront respectivement à vos conditions de facturation et au classement des problèmes qualité de vos productions.",
      tip: "Pas besoin de les remplir maintenant : nous y reviendrons dans les tutoriels dédiés à la facturation et à la qualité.",
    },
    "enums-done": {
      title: "Énumérations configurées !",
      body: "Vos listes de valeurs sont prêtes : familles, familles techniques et unités structureront désormais tout votre catalogue. Passons maintenant aux paramètres généraux de l'activité.",
      tip: null,
    },
    "tab-params": {
      title: "Onglet Paramètres généraux",
      body: "Cliquez sur « Paramètres généraux » pour configurer la consigne qualité et les workflows de validation des spécifications et des OFs. Ce sont des réglages transverses qui s'appliquent à toute la Boulangerie du Moulin.",
      tip: null,
    },
    "intro-params": {
      title: "Les paramètres généraux",
      body: "Cette page contrôle trois aspects clés : la consigne de non-conformité (qualité), les circuits de validation des spécifications et des OFs, et le mode de facturation. Bien réglés, ils déterminent à quel point votre flux est rapide ou contrôlé.",
      tip: null,
    },
    "edit-params": {
      title: "Passer en mode édition",
      body: "Cliquez sur le bouton crayon pour déverrouiller et modifier les paramètres. Tant que vous n'êtes pas en édition, les champs restent en lecture seule.",
      tip: null,
    },
    "fill-consigne-nc": {
      title: "Consigne de non-conformité",
      body: "Ce texte s'affichera par défaut aux opérateurs lorsqu'un contrôle qualité est déclaré non conforme — par exemple un biscuit hors calibre ou une cuisson irrégulière. Si un contrôle possède sa propre consigne spécifique, c'est celle-ci qui prime.",
      tip: "Soyez clair et précis : cette consigne guide les opérateurs en cas de problème qualité sur les écrans de production (ex: « Isoler le produit, prévenir le responsable qualité et tracer l'incident »).",
    },
    "fill-validation-specif": {
      title: "Validation des spécifications",
      body: "Sélectionnez « Sans Validation » dans la liste déroulante. Vos spécifications (recettes, nomenclatures) seront publiables directement, sans circuit d'approbation — idéal pour gagner du temps pendant la prise en main de la Boulangerie du Moulin.",
      tip: "Vous pourrez repasser en « Approbation et Validation » plus tard pour imposer un circuit de vérification avant mise en production.",
    },
    "intro-validation-of": {
      title: "Validation des ordres de fabrication",
      body: "Ce paramètre définit ce qui se passe à la clôture d'un OF, une fois la réintégration du pied de chaîne faite et les consommations déclarées. Soit l'OF est directement validé, soit il passe par un processus de validation manuelle (production et/ou qualité).",
      tip: "Pour une petite structure comme la Boulangerie du Moulin, la validation directe suffit souvent ; la double validation se justifie quand un service qualité distinct doit donner son feu vert.",
    },
    "save-params": {
      title: "Enregistrer les paramètres",
      body: "Cliquez sur Enregistrer. Les paramètres prennent effet immédiatement pour tous les utilisateurs de la Boulangerie du Moulin.",
      tip: null,
    },
    "activite-outro": {
      title: "Activité configurée !",
      body: "Votre paramétrage activité est en place : familles, unités et règles de validation sont prêtes. Vous pouvez maintenant créer vos articles et bâtir le catalogue de la Boulangerie du Moulin.",
      tip: "Prochaine étape recommandée : le tutoriel Gestion des articles.",
    },
    // ===== GESTION DES ARTICLES =====
    "articles-intro": {
      title: "Gestion des articles",
      body: "Les articles sont le socle de votre ERP : matières premières (farine, sucre, beurre, sel), produits finis (vos Biscuits sablés du Moulin) et emballages. Tout ce que vous achetez, fabriquez ou vendez est un article. Ce tutoriel vous guide pour créer et configurer votre catalogue, brique par brique.",
      tip: "Un article bien renseigné dès le départ vous fait gagner du temps partout ensuite : nomenclature, traçabilité, stocks et facturation s'appuient dessus.",
    },
    "open-menu-articles": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral pour accéder à la section Articles. C'est depuis ce menu que vous naviguez entre toutes les fonctions de l'ERP.",
      tip: "Le menu reste accessible partout : un clic sur l'icône l'ouvre ou le referme.",
    },
    "open-infos-section-articles": {
      title: "Section Données de base",
      body: "Dépliez la section Données de base : elle regroupe tout ce qui décrit votre activité avant de produire (articles, tiers, nomenclatures). Le lien Articles s'y trouve.",
      tip: "Les sections se déplient et se replient pour garder le menu lisible.",
    },
    "nav-articles": {
      title: "Accéder aux articles",
      body: "Cliquez sur Articles pour ouvrir le catalogue produit. Vous y verrez la liste de tous vos articles et pourrez en créer de nouveaux.",
      tip: "C'est le point d'entrée pour gérer tout votre catalogue.",
    },
    "intro-liste-articles": {
      title: "La liste des articles",
      body: "Voici votre catalogue. Chaque ligne représente un article avec son code, sa dénomination, sa famille et son unité de gestion. Une pastille d'état indique si la fiche technique (spécification) du produit est en rédaction ou validée.",
      tip: "Utilisez la barre de recherche et les filtres (famille, sous-famille, état) pour retrouver un article en quelques secondes.",
    },
    "click-add-article": {
      title: "Ajouter un article",
      body: "Cliquez sur le bouton « + » pour créer un nouvel article. Commençons par une matière première : le sel fin, un des ingrédients de vos biscuits.",
      tip: "Vous pouvez aussi dupliquer un article existant pour aller plus vite sur des produits proches.",
    },
    "intro-dialog-creation": {
      title: "Dialog de création",
      body: "Ce formulaire définit les informations de base de l'article : dénomination, unité de gestion, famille et sous-famille. Ces quelques champs suffisent à créer l'article ; vous compléterez le reste sur sa fiche.",
      tip: "La dénomination est le nom commercial du produit. L'unité (kg, L, Unité) détermine comment il sera compté en stock.",
    },
    "fill-denomination-mp": {
      title: "Dénomination",
      body: "Saisissez le nom de la matière première : Sel fin. C'est sous ce nom qu'elle apparaîtra dans vos stocks, vos commandes fournisseurs et la recette de vos biscuits.",
      tip: "Restez précis : « Sel fin » plutôt que « Sel » évite les confusions si vous achetez plusieurs sels.",
    },
    "fill-unite-mp": {
      title: "Unité de gestion",
      body: "Sélectionnez l'unité de gestion : Kilogramme. Le sel sera donc acheté, stocké et consommé en kg. C'est cette unité qui servira de base au calcul des quantités dans la nomenclature des biscuits.",
      tip: "Choisissez l'unité dans laquelle vous gérez réellement le produit au quotidien (kg pour les ingrédients en vrac).",
    },
    "intro-no-specif": {
      title: "Pas de spécification",
      body: "Pour une matière première, on laisse le toggle « Article fabriqué » désactivé : le sel n'a ni recette ni process, vous l'achetez tel quel. Ce toggle est réservé aux produits finis que vous fabriquez.",
      tip: "Matières premières et emballages n'ont pas de spécification ; seuls les produits transformés en ont besoin.",
    },
    "save-mp": {
      title: "Enregistrer",
      body: "Cliquez sur Enregistrer pour créer la matière première. Le Sel fin rejoint alors votre catalogue et devient disponible pour les commandes fournisseurs et les recettes.",
      tip: "Une fois enregistré, l'article reste modifiable à tout moment depuis sa fiche.",
    },
    "mp-done": {
      title: "Matière première créée !",
      body: "Le Sel fin est maintenant dans votre catalogue. En répétant l'opération, vous y ajoutez tous vos ingrédients (farine, sucre, beurre…). Passons maintenant à un cas plus riche : créer le produit fini, vos Biscuits sablés du Moulin.",
      tip: "Créez d'abord toutes vos matières premières : vous en aurez besoin pour bâtir la recette du produit fini.",
    },
    "click-add-pf": {
      title: "Créer le produit fini",
      body: "Cliquez à nouveau sur « + » pour créer votre produit fabriqué : les Biscuits sablés du Moulin. Contrairement au sel, ce produit aura une recette et un process, donc une fiche technique complète.",
      tip: "Le produit fini est ce que vous vendez : c'est lui qui portera votre marge et votre traçabilité de fabrication.",
    },
    "fill-denomination-pf": {
      title: "Dénomination du produit fini",
      body: "Saisissez le nom du produit que vous fabriquez : Biscuits sablés du Moulin. C'est ce nom qui apparaîtra sur les ordres de fabrication, les bons de livraison et les factures de vos clients.",
      tip: "Choisissez le nom commercial exact, celui que vos clients reconnaîtront sur leurs documents.",
    },
    "fill-unite-pf": {
      title: "Unité de gestion",
      body: "Sélectionnez l'unité de gestion : Kilogramme. Les biscuits seront produits, stockés et vendus au kg. Cette unité sert de référence pour le calcul des coûts et des quantités tout au long de la fabrication.",
      tip: "Gardez une unité cohérente avec vos matières premières : ici tout est en kg, ce qui simplifie la recette.",
    },
    "intro-toggle-specif": {
      title: "Article fabriqué",
      body: "Cette fois, activez le toggle « Article fabriqué » ! Un produit fini a besoin d'une spécification (fiche technique) qui portera sa recette (nomenclature) et son process de fabrication. Sans elle, impossible de lancer un ordre de fabrication.",
      tip: "C'est ce toggle qui distingue un produit fabriqué d'une matière première achetée.",
    },
    "fill-sous-famille": {
      title: "Sous-famille",
      body: "Sélectionnez la sous-famille de l'article : Biscuits. Elle classe vos produits finis par catégorie, ce qui facilite la recherche, les filtres et les statistiques de vente par gamme. La sous-famille est requise pour un article fabriqué.",
      tip: "Une sous-famille bien choisie vous permet ensuite d'analyser votre chiffre d'affaires par gamme de produits.",
    },
    "save-pf": {
      title: "Enregistrer",
      body: "Cliquez sur Enregistrer pour créer le produit fini. Comme vous avez activé « Article fabriqué », JustUp crée automatiquement sa fiche technique (spécification) vide, prête à recevoir la recette et le process.",
      tip: "Vous serez redirigé vers la fiche technique du produit juste après l'enregistrement.",
    },
    "pf-done": {
      title: "Produit fini créé !",
      body: "Les Biscuits sablés du Moulin sont dans votre catalogue, avec une fiche technique créée automatiquement. Vous allez maintenant pouvoir y définir sa recette (nomenclature) et son process de fabrication.",
      tip: "Prochaine étape : la nomenclature — quels ingrédients et en quelle quantité pour produire un kg de biscuits.",
    },
    "fill-denomination-article": {
      title: "Dénomination",
      body: "Saisissez le nom de votre article.",
      tip: "Exemples : Farine T65, Beurre doux 82%, Sachet 200g.",
    },
    "fill-unite": {
      title: "Unité de gestion",
      body: "Sélectionnez l'unité principale de gestion de cet article : kilogramme, litre ou unité.",
      tip: "L'unité détermine comment les quantités sont exprimées dans les stocks, les commandes et les OFs.",
    },
    "save-new-article": {
      title: "Enregistrer l'article",
      body: "Cliquez sur Enregistrer pour créer l'article. Il apparaîtra dans la liste et vous pourrez compléter sa fiche.",
      tip: null,
    },
    "creation-done": {
      title: "Article créé !",
      body: "Votre article est créé. Vous êtes maintenant sur sa fiche détaillée où vous pouvez configurer tous ses paramètres.",
      tip: "Voyons maintenant les différentes sections de configuration disponibles.",
    },
    "intro-config-article": {
      title: "Configuration d'un article",
      body: "La fiche article contient plusieurs cartes de configuration. Explorons les plus importantes pour bien paramétrer votre produit.",
      tip: null,
    },
    "intro-type-article": {
      title: "Type d'article",
      body: "Deux types possibles : « Fabriqué » pour les produits avec une recette et un process de fabrication, « Prestation » pour les services sans stock ni traçabilité.",
      tip: "Le type détermine les fonctionnalités disponibles : un article Prestation n'a pas de stock, DDM ni traçabilité.",
    },
    "intro-ddm": {
      title: "DDM / DLUO",
      body: "La Date de Durabilité Minimale définit la durée de vie de votre produit. Configurez-la en jours, mois ou années selon le type de produit.",
      tip: "Pour les produits frais, utilisez les jours. Pour les conserves ou surgelés, les mois ou années.",
    },
    "intro-stock": {
      title: "Gestion du stock",
      body: "Deux modes de gestion : « Global » pour un stock agrégé simple, « Lot par lot » pour une traçabilité fine avec numéro de lot, dates et quantités par lot.",
      tip: "Le mode lot par lot est recommandé pour les matières premières et produits finis soumis à la traçabilité agroalimentaire.",
    },
    "intro-lot-par-lot": {
      title: "Traçabilité lot par lot",
      body: "En mode lot par lot, chaque entrée en stock crée un lot avec son numéro, sa date de fabrication et sa DDM. Cela permet de tracer chaque produit de la réception à l'expédition.",
      tip: "La traçabilité est essentielle pour les rappels produit et les audits qualité.",
    },
    "intro-consommation": {
      title: "Mode de consommation",
      body: "Trois modes exclusifs : « Théorique » (calculé depuis la recette), « Volée » (consommation libre en production), « Pied de chaîne » (décompte en fin de ligne).",
      tip: "Le mode théorique est le plus courant. Volée et PDC sont utilisés pour les ingrédients difficiles à doser précisément.",
    },
    "intro-description": {
      title: "Ingrédients & Allergènes",
      body: "Renseignez la liste des ingrédients et les allergènes présents. Ces informations apparaissent sur les étiquettes et les fiches techniques.",
      tip: "Les allergènes déclarés ici seront automatiquement reportés dans les spécifications des produits finis.",
    },
    "intro-fiche-biscuit": {
      title: "Fiche technique du produit",
      body: "Voici la fiche technique des Biscuits sablés du Moulin. Elle est en état « En rédaction » : c'est votre brouillon de travail, modifiable librement. Vous la complèterez avec la recette (nomenclature) puis le process de fabrication.",
      tip: "Tant qu'une fiche est « En rédaction », vous pouvez tout ajuster ; une fois validée, elle devient la référence figée pour produire.",
    },
    "intro-tabs": {
      title: "Les onglets",
      body: "La fiche est organisée en onglets : Infos générales, Nomenclature (la recette), Procédés (les étapes de fabrication), Contrôles (qualité), et plus encore. Chaque onglet décrit un aspect de votre produit.",
      tip: "Vous remplirez ces onglets dans les prochains tutoriels, un par un, dans l'ordre logique de la fabrication.",
    },
    "intro-version": {
      title: "Versioning",
      body: "Chaque spécification est versionnée. La version en rédaction (v1) est celle que vous complétez maintenant. Une fois finalisée et validée, elle devient figée ; toute modification ultérieure crée une nouvelle version, ce qui garde l'historique de vos recettes.",
      tip: "Le versioning vous permet de faire évoluer une recette sans perdre la trace de ce qui a réellement été produit avec les versions précédentes.",
    },
    "articles-outro": {
      title: "Prochaine étape : la nomenclature",
      body: "Votre matière première et votre produit fini sont créés, et la fiche technique des Biscuits sablés est prête à être complétée. Passez au tutoriel suivant pour définir la recette (nomenclature) : les ingrédients et leurs quantités.",
      tip: "Astuce : pour des produits proches (ex. biscuits nature et biscuits chocolat), dupliquez un article existant plutôt que de tout ressaisir.",
    },
    "valid-spec-intro": {
      title: "Pourquoi approuver la spécification ?",
      body: "Tant qu'une spécification est « En rédaction », c'est une copie de travail : pratique pour construire, mais inutilisable en production. Pour lancer un ordre de fabrication de vos biscuits sablés, il faut d'abord l'approuver. L'approbation fige la version de référence : c'est elle qui sera réellement produite et tracée.",
      tip: "N'approuvez qu'une fois la fiche complète (nomenclature, procédés, contrôles) : la version courante doit correspondre exactement à ce que vous fabriquez.",
    },
    "valid-spec-approuve": {
      title: "Le bouton « Approuver »",
      body: "Ce bouton lance l'approbation de la spécification en rédaction. Il ouvre une fenêtre de confirmation avant tout changement d'état : rien n'est figé tant que vous n'avez pas confirmé. C'est votre dernière occasion de vérifier que la fiche est complète.",
      tip: "Avant d'approuver, assurez-vous que la recette et les paramètres sont renseignés : une spécification incomplète ne peut pas être validée.",
    },
    "valid-spec-confirm": {
      title: "Confirmer l'approbation",
      body: "Confirmez pour figer la version de référence. La spécification passe en « Approuvée » et devient utilisable par les ordres de fabrication.",
      tip: "Une nouvelle version en rédaction pourra être ouverte plus tard : la version approuvée, elle, ne bouge plus.",
    },
    // ===== GESTION DE LA NOMENCLATURE =====
    "nom-intro": {
      title: "La nomenclature",
      body: "La nomenclature (ou recette) liste tous les composants nécessaires à la fabrication d'un produit fini : matières premières, ingrédients et emballages avec leurs quantités. Pour vos Biscuits sablés du Moulin, c'est ici que vous déclarez farine, beurre, sucre, œufs et lait. Une fois définie, elle pilote vos besoins d'achat et le calcul du coût de revient.",
      tip: "C'est le cœur de la spécification : le prix d'achat de la farine remonte la nomenclature jusqu'au coût du biscuit, puis sur la facture.",
    },

    // --- modeles-specifications ---
    "ms-intro": {
      title: "Modèles & variables, à quoi ça sert ?",
      body: "Plutôt que de recréer la même fiche technique pour chaque produit qui se ressemble, vous créez UN modèle de spécification partagé. Dans votre boulangerie, un même modèle « Biscuit sablé » sert pour les sablés nature, au chocolat ou à la cannelle : seuls les détails qui changent (parfum, taux de sucre) deviennent des variables. Chaque article reprend le modèle et renseigne ses propres valeurs.",
      tip: "Un modèle = une recette commune. Les variables = les « cases à remplir » propres à chaque article.",
    },
    "ms-params-tab": {
      title: "L'onglet Paramètres de spécification",
      body: "Sur un modèle, l'onglet « Paramètres de spécification » liste ses variables. C'est ici qu'on définit les paramètres ajustables, ceux qui varieront d'un biscuit à l'autre tout en gardant la même recette de base. Cliquez dessus pour voir les variables du modèle.",
      tip: "Pensez à cet onglet comme au panneau de réglages partagé par tous les articles qui suivent le modèle.",
    },
    "ms-variables-overview": {
      title: "Les variables du modèle",
      body: "Voici les variables de ce modèle de biscuit. Chacune a un nom, un type et une valeur par défaut (par exemple un taux de sucre à 20 %). Un article associé hérite de ces variables et peut surcharger les valeurs : le sablé au chocolat montera à 22 % de sucre sans toucher au modèle commun.",
      tip: "La valeur par défaut sert de point de départ ; chaque article peut l'adapter.",
    },
    "ms-var-number": {
      title: "Une variable Nombre",
      body: "« Taux de sucre cible (%) » est une variable de type Nombre. On l'utilise pour un paramètre chiffré qui varie selon l'article : un pourcentage, une durée de cuisson, une température de four… Comme c'est un nombre, il peut alimenter directement vos formules de procédé ou de contrôle.",
      tip: "Les variables Nombre peuvent être réutilisées dans des formules de procédé ou de contrôle (ex : durée de cuisson calculée à partir du taux de sucre).",
    },
    "ms-var-string": {
      title: "Une variable Texte",
      body: "« Parfum dominant » est une variable de type Texte. Idéale pour un libellé qui change selon l'article : un parfum (« vanille », « chocolat »), une mention d'étiquetage, une référence fournisseur… Sa valeur peut ensuite remonter sur l'étiquette ou la fiche produit.",
      tip: "Nombre et Texte sont les deux seuls types que vous créez à la main.",
    },
    "ms-add-variable": {
      title: "Ajouter une variable",
      body: "Ce bouton ouvre le formulaire de création d'une variable. Vous donnez un nom, choisissez le type (Nombre ou Texte) et une valeur par défaut. Toute variable ajoutée ici sera réclamée sur chaque article qui suit le modèle : ajoutez « Grammage du sablé (g) » et tous vos biscuits devront le renseigner.",
      tip: "Nommez clairement vos variables avec leur unité (ex : « Taux de sucre cible (%) ») pour éviter toute ambiguïté à la saisie.",
    },
    "ms-auto-types": {
      title: "Les variables automatiques",
      body: "Deux autres types de variables existent, mais ils se créent tout seuls. Une ligne de nomenclature optionnelle ou « dynamique » (onglet Nomenclature) — par exemple une pépite de chocolat présente seulement sur certains sablés — et une étape de procédé optionnelle (onglet Procédé) génèrent automatiquement leur variable.",
      tip: "Vous n'avez donc à créer manuellement que les variables Nombre et Texte.",
    },
    "ms-assoc-intro": {
      title: "Associer un modèle à un article",
      body: "Passons côté article. Un article peut « partager » la spécification d'un modèle : il en hérite la recette (nomenclature), le procédé, les contrôles… et ses variables. C'est ce qui vous évite de ressaisir toute la fiche pour chaque variante de sablé.",
      tip: "On est sur l'article « Biscuits sablés du Moulin ».",
    },
    "ms-assoc-card": {
      title: "Spécification de l'article",
      body: "Cette carte pilote le rattachement de l'article à une spécification. C'est ici qu'on choisit s'il a sa propre fiche, autonome, ou s'il suit un modèle partagé. Pour vos sablés qui se ressemblent, suivre un modèle garantit qu'une correction de recette se propage partout en une fois.",
      tip: "Une seule carte décide de tout le rattachement : prenez le temps de bien choisir entre fiche propre et modèle partagé.",
    },
    "ms-assoc-toggle": {
      title: "Propre ou partagée ?",
      body: "Le sélecteur bascule entre « Aucune spécification » (l'article a sa fiche propre, indépendante) et « Spécification partagée » (il suit un modèle). Ici, l'article suit un modèle : choisissez « partagée » dès qu'un produit appartient à une famille de recettes comme vos sablés.",
      tip: "Réservez la fiche propre aux produits vraiment uniques ; pour tout le reste, le modèle partagé fait gagner un temps précieux.",
    },
    "ms-assoc-chooser": {
      title: "Choisir le modèle",
      body: "Ce sélecteur liste les modèles disponibles. L'article est rattaché au modèle « Biscuit sablé paramétrable ». Le bouton « Consulter » permet d'ouvrir le modèle pour vérifier sa recette et ses variables avant de confirmer le rattachement.",
      tip: "En cas de doute, cliquez sur « Consulter » pour vérifier que le modèle correspond bien à votre produit avant de le rattacher.",
    },
    "ms-assoc-edit": {
      title: "Modifier l'association",
      body: "Le bouton crayon passe la carte en édition pour changer de modèle ou détacher l'article. C'est modifiable tant que la spécification est en rédaction ; une fois passée en courante, elle se verrouille pour garantir la traçabilité des produits déjà fabriqués.",
      tip: "Faites vos changements de modèle pendant la phase rédaction : après passage en courante, l'association est figée.",
    },
    "ms-assoc-inherit": {
      title: "Hériter des variables",
      body: "Dès qu'on associe le modèle, l'article reçoit une copie de toutes ses variables : taux de sucre, parfum dominant, etc. Il ne reste plus qu'à leur donner les valeurs propres à cet article. Le modèle reste votre référentiel central : une variable ajoutée plus tard se répercute sur tous les sablés liés.",
      tip: "Le modèle reste la source : si on y ajoute une variable, les articles liés la réclameront automatiquement.",
    },
    "ms-fill-intro": {
      title: "Les paramètres de l'article",
      body: "Cette carte « Paramètres de spécification » regroupe les variables héritées du modèle, vues côté article. C'est ici qu'on saisit les valeurs propres à ce sablé : son taux de sucre réel, son parfum. Ces valeurs sont ce qui distingue concrètement cet article de ses cousins partageant le même modèle.",
      tip: null,
    },
    "ms-fill-ok": {
      title: "Variables renseignées",
      body: "Le taux de sucre est ici fixé à 22 % pour ce biscuit — il surcharge la valeur par défaut du modèle (20 %). Chaque valeur renseignée apparaît dans cette liste, ce qui vous donne d'un coup d'œil le profil exact du produit.",
      tip: "Surcharger n'altère jamais le modèle : seule la copie de l'article change.",
    },
    "ms-fill-required": {
      title: "Variables non renseignées",
      body: "Les variables du modèle pas encore renseignées pour cet article apparaissent en orange. Ici, « Parfum dominant » attend une valeur. Tant qu'il manque une valeur, la fiche reste incomplète et le produit ne pourra pas partir en fabrication.",
      tip: "Cette alerte évite d'oublier un paramètre indispensable à la production.",
    },
    "ms-fill-edit": {
      title: "Renseigner une valeur",
      body: "Le crayon ouvre le formulaire de la variable : on y saisit la valeur propre à l'article, par exemple « vanille » pour le parfum dominant. Le nom et le type sont verrouillés car ils viennent du modèle : vous ne renseignez que la valeur.",
      tip: "Un bouton « Remettre la valeur par défaut » permet de revenir à celle du modèle.",
    },
    "ms-fill-validation": {
      title: "Validation bloquante",
      body: "Tant qu'une variable du modèle reste non renseignée, l'article ne peut pas passer en spécification courante. Le système vous oblige à compléter tous les paramètres : impossible de lancer un OF de sablés sans avoir fixé le taux de sucre et le parfum.",
      tip: "Un blocage en validation est en réalité un garde-fou : il garantit qu'aucun produit ne part en fabrication avec une donnée manquante.",
    },
    "ms-outro": {
      title: "Et en production ?",
      body: "Au lancement d'un ordre de fabrication, JustUp résout automatiquement chaque variable avec la valeur de l'article : les quantités de la nomenclature, les libellés d'étiquette et les formules de procédé s'adaptent. Un seul modèle « Biscuit sablé », autant de variantes que d'articles !",
      tip: "Vous savez créer un modèle, l'associer et renseigner ses variables.",
    },
    "nom-tab": {
      title: "Onglet Nomenclature",
      body: "Cliquez sur l'onglet Nomenclature pour ouvrir la recette de cet article. C'est dans cet onglet de la spécification que vous composez et modifiez la liste des ingrédients de vos Biscuits sablés du Moulin.",
      tip: "La nomenclature vit à l'intérieur de la spécification : modifier la recette ici met à jour automatiquement la spécification du produit.",
    },
    "nom-overview": {
      title: "Vue d'ensemble",
      body: "L'onglet Nomenclature affiche toutes les lignes de composants. Chaque ligne indique l'article, la quantité par unité produite et les éventuels taux de pertes. Pour le moment la recette est vide : vous allez y ajouter vos premiers ingrédients juste après.",
      tip: "Les lignes sont ordonnées et peuvent être réorganisées par glisser-déposer pour suivre l'ordre d'incorporation.",
    },
    "nom-add-btn": {
      title: "Ajouter une ligne",
      body: "Ce bouton ouvre le formulaire d'ajout d'un composant à la nomenclature. C'est le point de départ pour intégrer chaque ingrédient de vos biscuits, de la farine jusqu'à l'emballage.",
      tip: "Vous pouvez ajouter autant de lignes que nécessaire. Chaque article ne peut apparaître qu'une seule fois dans la recette.",
    },
    "nom-ligne-display": {
      title: "Affichage des lignes",
      body: "Chaque ligne montre l'article, sa quantité unitaire, l'unité de gestion et les indicateurs de pertes si définis. Les lignes optionnelles sont marquées distinctement. En un coup d'œil, vous lisez la composition complète de vos biscuits.",
      tip: "Les chips colorées signalent les options actives : ligne optionnelle, héritage de lot ou paramètre dynamique.",
    },
    "nom-menu-btn": {
      title: "Menu contextuel",
      body: "Le bouton « ⋮ » de chaque ligne donne accès aux actions : modifier la quantité ou les paramètres, supprimer la ligne, ou activer l'héritage de lot. C'est votre point d'entrée pour ajuster une recette déjà saisie.",
      tip: "La modification reste possible tant que la spécification est en statut Brouillon ; une fois validée, la recette est figée.",
    },
    "nom-click-add": {
      title: "Créer une ligne",
      body: "Cliquez sur « Ajouter » pour ouvrir le formulaire de création d'une ligne de nomenclature.",
      tip: null,
    },
    "nom-dialog-intro": {
      title: "Formulaire d'ajout",
      body: "Le formulaire permet de sélectionner un article, de définir la quantité par unité produite et de configurer des options avancées. C'est ici que se joue la précision de votre recette : une quantité juste garantit des besoins d'achat et un coût de revient fiables.",
      tip: "Tous les articles du catalogue sont disponibles : matières premières, emballages, et même d'autres produits finis (sous-ensembles).",
    },
    "nom-select-article": {
      title: "Sélection de l'article",
      body: "Tapez le nom ou le code de l'article pour le rechercher, puis sélectionnez-le dans la liste déroulante. Ici, choisissez la Farine de blé T65, l'ingrédient principal de vos sablés.",
      tip: "Seuls les articles non déjà présents dans la nomenclature sont proposés : impossible de saisir deux fois la même farine.",
    },
    "nom-fill-quantite": {
      title: "Quantité unitaire",
      body: "Indiquez la quantité de cet ingrédient nécessaire pour produire une unité du produit fini. L'unité dépend de l'article (kg, L, pièce). Pour vos biscuits, saisissez 0.4 : il faut 0,4 kg de farine par kilogramme de Biscuits sablés du Moulin.",
      tip: "Cette quantité est multipliée par le volume de l'OF : pour un OF de 100 kg de biscuits, JustUp prévoit 40 kg de farine.",
    },
    "nom-explain-pertes": {
      title: "Taux de pertes",
      body: "Les paramètres avancés permettent de définir un taux de perte normale (usage habituel) et un taux max (seuil d'alerte). La quantité réelle attendue est ajustée en conséquence, ce qui rend vos prévisions d'achat et votre coût de revient plus justes.",
      tip: "Exemple : 2 % de perte normale sur le sucre = 0.030 kg × 1.02 = 0.0306 kg réellement consommés par unité.",
    },
    "nom-explain-optional": {
      title: "Lignes optionnelles",
      body: "Une ligne peut être marquée « optionnelle ». Elle apparaît dans la nomenclature mais peut être activée ou désactivée selon les ordres de fabrication.",
      tip: "Utile pour les variantes de recette : un glaçage optionnel, un arôme ajouté sur demande.",
    },
    "nom-more-params": {
      title: "Plus de paramètres",
      body: "Ouvrez les paramètres avancés pour configurer les pertes, l'héritage de lot et d'autres options de la ligne. Ces réglages affinent le calcul de consommation et la traçabilité, au-delà de la simple quantité.",
      tip: "Inutile de tout remplir : les paramètres avancés sont optionnels et ont des valeurs par défaut raisonnables.",
    },
    "nom-qtt-undefined": {
      title: "Quantité non définie",
      body: "Si activé, l'article n'a pas de quantité cible : il n'est pas obligatoirement consommé lors de la production. Utile pour les ingrédients optionnels — par exemple un arôme de vanille ajouté ponctuellement à certaines fournées, ou des pépites de chocolat selon la variante.",
      tip: "Un article sans quantité définie n'apparaîtra pas en écart si vous ne le consommez pas sur un OF donné.",
    },
    "nom-pertes": {
      title: "Seuils de perte",
      body: "La perte normale correspond au taux de perte habituel en production (chutes de pâte, résidus de pétrin, biscuits cassés). La perte maximale fixe le seuil d'alerte : au-delà, un avertissement s'affiche quand vous surconsommez cet ingrédient. Cela protège votre marge en signalant les dérives.",
      tip: "Exemple : 2 % de perte normale et 5 % de perte maximale sur la farine. Au-delà de 5 %, un warning vous prévient d'une surconsommation anormale.",
    },
    "nom-lot-heritier-toggle": {
      title: "Héritage de lot",
      body: "Activez ce toggle pour que le numéro de lot du produit fini soit hérité de cet ingrédient. Pratique pour la traçabilité amont : le lot de vos biscuits pourra refléter directement le lot de farine utilisé, facilitant un éventuel rappel.",
      tip: "Un seul ingrédient peut être « lot héritier » par nomenclature : activer le flag sur une ligne le désactive automatiquement sur les autres.",
    },
    "nom-save-ligne": {
      title: "Enregistrer la ligne",
      body: "Cliquez sur Enregistrer pour ajouter la ligne à la nomenclature. La Farine de blé T65 apparaît immédiatement dans la liste avec sa quantité et ses paramètres.",
      tip: "Tant que la spécification est en Brouillon, vous pourrez rééditer ou supprimer la ligne à tout moment.",
    },
    "nom-ajout-done": {
      title: "Ingrédients ajoutés",
      body: "Répétez l'opération pour chaque composant de votre recette : matières premières, ingrédients secondaires et emballages. Pour vos sablés, cela donne farine, beurre, sucre, œufs et lait, chacun avec sa quantité par kilogramme produit.",
      tip: "L'ordre des lignes peut être modifié ensuite par glisser-déposer pour refléter l'ordre d'incorporation.",
    },
    "nom-first-line-done": {
      title: "Premier ingrédient ajouté !",
      body: "La Farine de blé T65 est maintenant dans la recette de vos Biscuits sablés du Moulin. Vous avez vu tout le parcours d'ajout d'une ligne ; les autres ingrédients vont être ajoutés automatiquement pour compléter la recette.",
      tip: "Le même geste se répète pour chaque composant : article, quantité, paramètres avancés si besoin, puis Enregistrer.",
    },
    "nom-all-lines": {
      title: "Recette complète !",
      body: "Tous les ingrédients sont en place : Farine, Beurre, Sucre, Œufs et Lait. Chaque ligne indique la quantité nécessaire par kilogramme de Biscuits produit. Votre nomenclature est désormais prête à alimenter les calculs de besoins et de coût.",
      tip: "Vous pouvez réorganiser les lignes par glisser-déposer et ajuster les quantités à tout moment tant que la spécification est en Brouillon.",
    },
    "nom-edit-intro": {
      title: "Modifier une ligne",
      body: "Pour modifier une ligne existante, ouvrez son menu contextuel via le bouton « ⋮ ».",
      tip: "La modification est possible tant que la spécification est en statut Brouillon.",
    },
    "nom-edit-action": {
      title: "Action Éditer",
      body: "Cliquez sur « Éditer » pour rouvrir le formulaire avec les valeurs actuelles. Modifiez la quantité ou les paramètres puis enregistrez.",
      tip: null,
    },
    "nom-drag-reorder": {
      title: "Réordonner les lignes",
      body: "Glissez-déposez les lignes pour réorganiser l'ordre des composants ; l'ordre est sauvegardé automatiquement. Calez-le sur votre process réel : d'abord la farine et le sucre, puis le beurre, les œufs et le lait.",
      tip: "L'ordre des lignes correspond à l'ordre d'utilisation dans le process de fabrication et facilite la lecture en atelier.",
    },
    "nom-lot-heritier": {
      title: "Héritage de lot",
      body: "Cette chip signale que le produit fini hérite du numéro de lot d'un composant spécifique. Un seul composant peut être « lot héritier » par nomenclature. Sur vos biscuits, c'est souvent la farine qui sert de référence pour la traçabilité.",
      tip: "Utile quand le numéro de lot du produit fini doit refléter celui de la matière première principale, pour un rappel ciblé.",
    },
    "nom-emballage": {
      title: "Emballages dans la nomenclature",
      body: "Les emballages font partie de la nomenclature au même titre que les ingrédients. Ajoutez sachets, cartons et étiquettes avec leur quantité par unité produite.",
      tip: "L'emballage impacte le coût de revient et la gestion des stocks d'emballage.",
    },
    "nom-dynamic": {
      title: "Articles paramétrables",
      body: "Un article paramétrable permet de définir une catégorie (ex : « Arôme ») plutôt qu'un article précis. Le choix final se fait lors de la création de l'ordre de fabrication.",
      tip: "Les paramètres dynamiques offrent de la flexibilité pour les recettes à variantes.",
    },
    "nom-outro": {
      title: "La recette est complète",
      body: "Votre nomenclature est en place : lignes, quantités, pertes, héritage de lot et ordre d'incorporation. Prochaine étape : définir le process de fabrication, c'est-à-dire les étapes de production de vos biscuits.",
      tip: "La nomenclature et le process forment ensemble la spécification complète de votre produit : la recette et la manière de la réaliser.",
    },
    // ===== GESTION DES TIERS =====
    "tiers-intro": {
      title: "Gestion des tiers",
      body: "Les tiers sont tous vos partenaires commerciaux : fournisseurs de matières premières (farine, sucre, beurre), clients distributeurs qui revendent vos Biscuits sablés du Moulin, transporteurs. Bien renseigner vos tiers, c'est pouvoir passer des commandes, facturer et tracer chaque échange. Ce tutoriel vous guide dans la création et la configuration de votre carnet d'adresses.",
      tip: "Un même tiers peut être à la fois fournisseur et client. Les conditions commerciales (paiement, franco) se définissent au niveau de chaque tiers.",
    },
    "open-menu-tiers": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral pour accéder à la section Tiers. C'est depuis ce menu que vous naviguez entre toutes les rubriques de gestion de la Boulangerie du Moulin.",
      tip: null,
    },
    "open-infos-section-tiers": {
      title: "Section Données de base",
      body: "Dépliez la section Données de base : elle regroupe vos référentiels (articles, tiers, nomenclatures). C'est ici que se trouve le lien Tiers.",
      tip: "Les Données de base sont le socle de l'ERP : tout le reste (commandes, OF, factures) s'appuie dessus.",
    },
    "nav-tiers": {
      title: "Accéder aux tiers",
      body: "Cliquez sur Tiers pour ouvrir la liste de vos fournisseurs et clients. C'est votre carnet d'adresses central, partagé par toute la Boulangerie du Moulin.",
      tip: null,
    },
    "intro-liste-tiers": {
      title: "La liste des tiers",
      body: "Voici votre carnet d'adresses. Chaque fiche regroupe les coordonnées, les conditions de paiement, les adresses de livraison et les prix d'achat négociés. Par exemple, votre fournisseur de sucre y stocke son tarif au kilo, qui alimentera ensuite le coût de vos biscuits.",
      tip: "Filtrez par type (fournisseur, client) pour retrouver rapidement un tiers dans une liste qui grandit vite.",
    },
    "click-add-tiers": {
      title: "Ajouter un tiers",
      body: "Cliquez sur le bouton « + » pour créer un nouveau fournisseur ou client. Nous allons créer la Sucrerie de Camargue, qui fournit le sucre de vos Biscuits sablés du Moulin.",
      tip: null,
    },
    "intro-dialog-tiers": {
      title: "Formulaire de création",
      body: "Renseignez les informations essentielles : dénomination, coordonnées et conditions de paiement. L'objectif est de pouvoir commander et facturer dès maintenant ; vous compléterez la fiche (adresses, articles fournis) ensuite.",
      tip: "La dénomination est le nom commercial du tiers. Les champs obligatoires sont marqués d'un astérisque.",
    },
    "fill-denomination-tiers": {
      title: "Dénomination",
      body: "Saisissez le nom du tiers (raison sociale ou nom commercial). Ici, tapez « Sucrerie de Camargue » : c'est sous ce nom que ce fournisseur apparaîtra dans vos commandes et factures.",
      tip: "Exemples : Sucrerie de Camargue, Minoterie du Sud, Beurrerie de Normandie.",
    },
    "fill-telephone-tiers": {
      title: "Téléphone",
      body: "Renseignez le numéro de téléphone principal du tiers, par exemple 04 90 11 22 33. Vous le retrouverez sur la fiche pour relancer rapidement un fournisseur en cas de rupture de sucre.",
      tip: null,
    },
    "fill-siret-tiers": {
      title: "SIRET",
      body: "Entrez le numéro SIRET à 14 chiffres du tiers (ex. 12345678900014). Il identifie l'établissement dans le registre national et sera repris sur vos documents légaux (factures, BL).",
      tip: "Le SIRET = SIREN (9 chiffres) + code établissement (5 chiffres).",
    },
    "intro-reglement": {
      title: "Conditions de paiement",
      body: "Définissez le mode de règlement (virement, espèces, prélèvement...) et le délai de paiement, par exemple virement à 30 jours. Ces conditions seront reprises automatiquement sur les commandes et factures de la Sucrerie de Camargue, ce qui évite de les ressaisir à chaque achat.",
      tip: "Le délai peut être en jours nets, fin de mois ou fin de décade selon ce que vous avez négocié.",
    },
    "save-tiers": {
      title: "Enregistrer le tiers",
      body: "Cliquez sur Enregistrer. La Sucrerie de Camargue apparaîtra immédiatement dans la liste et vous pourrez compléter sa fiche (adresses, articles fournis, prix d'achat).",
      tip: null,
    },
    "creation-tiers-done": {
      title: "Tiers créé !",
      body: "Votre fournisseur de sucre est créé. Vous êtes maintenant sur sa fiche détaillée, organisée en plusieurs onglets de configuration. C'est ici que vous affinerez les conditions d'achat qui pèseront sur le coût de vos biscuits.",
      tip: "Voyons les différentes sections de la fiche tiers.",
    },
    "intro-fiche-tiers": {
      title: "Fiche tiers",
      body: "La fiche tiers se compose de plusieurs onglets : Infos générales, Adresses, Contacts, RIB et Commercial. Chacun complète le profil de la Sucrerie de Camargue. Explorons les plus importants.",
      tip: "Plus la fiche est complète, plus les commandes et factures se génèrent automatiquement, sans ressaisie.",
    },
    "intro-edit-tiers": {
      title: "Mode édition",
      body: "Cliquez sur le crayon pour passer en mode édition et modifier les informations du tiers. Tant que vous n'êtes pas en édition, la fiche reste en lecture seule pour éviter les modifications accidentelles.",
      tip: "N'oubliez pas d'enregistrer après vos modifications, sinon elles seront perdues.",
    },
    "intro-franco": {
      title: "Conditions franco",
      body: "Le franco définit le seuil (quantité ou montant) à partir duquel les frais de port sont offerts par le fournisseur. Par exemple, si la Sucrerie de Camargue offre le port dès 500 € de commande, JustUp vous alerte quand vous approchez ce seuil pour grouper vos achats de sucre et économiser sur la livraison.",
      tip: "Laissez vide si le fournisseur n'applique pas de franco.",
    },
    "tiers-save-fiche": {
      title: "Enregistrer la fiche",
      body: "Cliquez sur « Enregistrer » pour valider les conditions commerciales saisies. Tant que la fiche est en cours de modification, la navigation vers les autres onglets est bloquée pour éviter de perdre vos saisies.",
      tip: "Un clic sur un autre onglet sans enregistrer déclenche une demande de confirmation.",
    },
    "intro-adresses-tab": {
      title: "Onglet Adresses",
      body: "Gérez les adresses du tiers : siège, entrepôts, plateformes de livraison. Vous pouvez définir une adresse de livraison et une adresse de facturation par défaut. Pour la Sucrerie de Camargue, c'est l'adresse de son entrepôt qui sera reprise sur vos bons de commande de sucre.",
      tip: "Les adresses sont réutilisées automatiquement dans les commandes, bons de livraison et factures.",
    },
    "intro-commercial-tab": {
      title: "Onglet Commercial",
      body: "L'onglet Commercial contient les articles fournis : la liste des matières premières achetées chez ce fournisseur avec leurs références et prix d'achat. C'est ici que vous reliez l'article Sucre à la Sucrerie de Camargue avec son tarif négocié.",
      tip: "C'est ce lien article-fournisseur qui permet de proposer automatiquement le bon prix lors d'une commande.",
    },
    "intro-prix-achat": {
      title: "Prix d'achat par paliers",
      body: "Chaque article fourni peut avoir plusieurs paliers de prix selon la quantité commandée : plus vous commandez, plus le prix unitaire baisse. Ce prix d'achat du sucre remonte la nomenclature jusqu'au coût de revient de vos Biscuits sablés du Moulin, puis sur la marge de la facture client.",
      tip: "Exemple : 1-99 kg à 2,50 €/kg, 100 kg et plus à 2,20 €/kg.",
    },
    "tiers-outro": {
      title: "Fournisseurs et clients en place",
      body: "Fournisseurs (sucre, farine, beurre) et clients sont renseignés : vous pouvez maintenant passer aux nomenclatures, puis aux commandes et à la production de vos Biscuits sablés du Moulin.",
      tip: "Les groupes de tiers permettent de regrouper vos fournisseurs par catégorie (ex : centrale d'achat, fournisseurs bio).",
    },
    "adr-tiers-intro": {
      title: "Les adresses d'un tiers",
      body: "Un tiers a besoin d'au moins une adresse pour que JustUp puisse générer ses commandes, ses bons de livraison et ses factures. Ajoutons l'adresse de la Sucrerie de Camargue pour pouvoir lui commander du sucre.",
      tip: "Sans adresse, impossible de finaliser une commande ou une livraison pour ce tiers.",
    },
    "adr-tiers-tab": {
      title: "L'onglet Adresses",
      body: "Ouvrez l'onglet Adresses de la fiche du tiers. C'est là que vous gérez toutes ses adresses : siège, entrepôt, plateforme de livraison ou adresse de facturation.",
      tip: "Vous pouvez enregistrer plusieurs adresses et désigner celles utilisées par défaut pour la livraison et la facturation.",
    },
    "adr-tiers-add": {
      title: "Ajouter une adresse",
      body: "Cliquez sur Ajouter une adresse pour ouvrir le formulaire de saisie. Une fenêtre s'ouvre pour renseigner les coordonnées postales du tiers.",
      tip: null,
    },
    "adr-tiers-dialog": {
      title: "Le formulaire d'adresse",
      body: "Cette fenêtre rassemble les champs de l'adresse : voie, code postal, commune et pays. Renseignez-les pour localiser précisément le tiers.",
      tip: "Une adresse complète, ce sont des bons de livraison et des factures sans erreur d'acheminement.",
    },
    "adr-tiers-voie": {
      title: "La voie",
      body: "Saisissez le numéro et le nom de la voie, par exemple Avenue des Tilleuls. C'est la première ligne de l'adresse et elle apparaîtra en tête de vos documents.",
      tip: "Ajoutez aussi un complément (bâtiment, zone) si besoin, pour faciliter la livraison.",
    },
    "adr-tiers-cp": {
      title: "Le code postal",
      body: "Saisissez le code postal de la commune, par exemple 13200. Il sert à acheminer correctement les colis et à calculer les zones de livraison.",
      tip: null,
    },
    "adr-tiers-commune": {
      title: "La commune",
      body: "Saisissez la commune, par exemple Arles. Avec le code postal et le pays, elle complète la localisation du tiers.",
      tip: null,
    },
    "adr-tiers-pays": {
      title: "Le pays",
      body: "Sélectionnez le pays dans la liste, par exemple France. Le pays pilote notamment le format de l'adresse et les règles de TVA appliquées sur les factures.",
      tip: "Commencez à taper le nom du pays pour le retrouver rapidement dans la liste.",
    },
    "adr-tiers-save": {
      title: "Enregistrer l'adresse",
      body: "Enregistrez : l'adresse est rattachée au tiers et devient utilisable sur ses commandes et ses documents.",
      tip: null,
    },
    "adr-tiers-done": {
      title: "Adresse enregistrée !",
      body: "L'adresse de la Sucrerie de Camargue est en place. Le tiers est complet : vous pouvez désormais lui passer commande et générer ses documents en autonomie.",
      tip: "Refaites l'opération pour ajouter une adresse de facturation distincte si elle diffère de l'adresse de livraison.",
    },
    // ===== PROCESS DE FABRICATION =====
    "proc-intro": {
      title: "Process de fabrication",
      body: "Le process décrit la suite des étapes qui transforment vos matières premières en produit fini : pour le Biscuit sablé du Moulin, ce sera le mélange des poudres, l'incorporation du beurre, le repos, le façonnage, la cuisson puis le conditionnement. Chaque étape est une action concrète que l'opérateur exécutera sur sa tablette en production. Bien défini, le process garantit que chaque fournée suit exactement la même recette, quel que soit l'opérateur.",
      tip: "Le process est rattaché à la spécification du produit fini, au même titre que la nomenclature : l'un décrit le « comment fabriquer », l'autre le « avec quoi ».",
    },
    "proc-tab": {
      title: "Onglet Procédés",
      body: "L'onglet Procédés regroupe toutes les étapes de fabrication du Biscuit sablé du Moulin. C'est ici que vous construisez le mode opératoire qui sera servi à l'opérateur, étape par étape, lors de chaque ordre de fabrication.",
      tip: "Chaque produit fini a son propre onglet Procédés : la recette des sablés est indépendante de celle d'une autre gamme.",
    },
    "proc-overview": {
      title: "Vue d'ensemble",
      body: "Les étapes s'affichent dans l'ordre de réalisation, du mélange jusqu'au conditionnement. Chaque étape peut porter une durée (timer), une description précise et être marquée comme optionnelle. C'est cette séquence exacte que l'opérateur déroulera sur sa tablette en fabriquant les sablés.",
      tip: "L'ordre affiché ici est l'ordre suivi en production : pensez-le comme la fiche recette que vous donneriez à un nouvel arrivant.",
    },
    "proc-add-btn": {
      title: "Ajouter une étape",
      body: "Cliquez sur ce bouton pour ajouter une nouvelle étape au process de fabrication.",
      tip: null,
    },
    "proc-ligne-display": {
      title: "Affichage d'une étape",
      body: "Chaque ligne du process affiche le nom de l'étape, sa durée (si définie) et son statut (obligatoire ou optionnelle).",
      tip: "Les étapes optionnelles sont marquées d'un badge spécifique.",
    },
    "proc-edit-btn": {
      title: "Modifier une étape",
      body: "Cliquez sur le crayon pour ouvrir le formulaire de modification d'une étape existante.",
      tip: null,
    },
    "proc-click-add": {
      title: "Créer une étape",
      body: "Cliquez sur le bouton « + » pour ouvrir le formulaire de création d'étape. Vous allez ajouter la première étape du Biscuit sablé du Moulin : le mélange des poudres.",
      tip: "Construisez le process dans l'ordre réel de fabrication, vous gagnerez du temps et éviterez de réordonner ensuite.",
    },
    "proc-dialog-intro": {
      title: "Formulaire d'étape",
      body: "Ce formulaire permet de définir une étape de fabrication : son nom, sa description, sa durée et ses options. Ce que vous saisissez ici sera affiché tel quel à l'opérateur en production. Remplissons-le ensemble pour l'étape de mélange.",
      tip: null,
    },
    "proc-fill-label": {
      title: "Nom de l'étape",
      body: "Saisissez un nom clair et court, ici « Mélange des poudres ». C'est le libellé que l'opérateur lira en tête de l'étape sur sa tablette : il doit comprendre en un coup d'œil ce qu'il a à faire.",
      tip: "Exemples pour les sablés : Mélange des poudres, Incorporation du beurre, Repos 30min, Cuisson, Conditionnement.",
    },
    "proc-fill-description": {
      title: "Description",
      body: "Ajoutez le détail du geste : ici « Mélanger farine, sucre et levure au batteur ». L'opérateur pourra l'ouvrir en cas de doute. Plus la consigne est précise (vitesse, durée, ordre d'ajout), moins vous dépendez du savoir-faire d'une seule personne.",
      tip: "Notez les points de vigilance : température, vitesse du batteur, homogénéité attendue avant de passer à la suite.",
    },
    "proc-toggle-timer": {
      title: "Activer le timer",
      body: "Activez le timer si l'étape a une durée précise à respecter. Un compte à rebours s'affichera alors à l'opérateur en production, ce qui sécurise les temps critiques. Pour le mélange des sablés, on vise un mélange homogène en quelques minutes.",
      tip: "Indispensable sur les étapes où le temps fait la qualité : repos de la pâte, cuisson, refroidissement.",
    },
    "proc-fill-timer": {
      title: "Durée du timer",
      body: "Définissez la durée en minutes, ici 10 minutes pour le mélange des poudres. Le compte à rebours se déclenchera automatiquement quand l'opérateur démarrera l'étape sur sa tablette.",
      tip: "Saisissez une durée réaliste constatée en atelier : un timer trop court pousse à bâcler, trop long fait perdre du temps.",
    },
    "proc-toggle-optional": {
      title: "Étape optionnelle",
      body: "Cochez cette option si l'étape n'est pas toujours nécessaire. L'opérateur pourra alors la passer en production sans bloquer l'ordre de fabrication. Pour les sablés, l'enrobage chocolat ne concerne qu'une partie des recettes.",
      tip: "Une étape optionnelle reste tracée : si elle est passée, vous le verrez dans l'historique de l'OF.",
    },
    "proc-save-etape": {
      title: "Enregistrer l'étape",
      body: "Cliquez sur Enregistrer pour ajouter l'étape « Mélange des poudres » au process. Elle vient se placer dans la séquence et sera prête à être servie à l'opérateur dès le prochain ordre de fabrication des sablés.",
      tip: null,
    },
    "proc-etapes-done": {
      title: "Première étape ajoutée !",
      body: "L'étape « Mélange des poudres » fait maintenant partie du process des sablés. Pour la démonstration, les autres étapes de la recette (incorporation du beurre, repos, façonnage, cuisson, conditionnement…) vont être ajoutées automatiquement afin d'obtenir un process complet.",
      tip: "En conditions réelles, vous répéteriez simplement l'ajout d'étape pour chacune des phases de fabrication.",
    },
    "proc-all-steps": {
      title: "Procédé complet !",
      body: "Les 8 étapes du process sont en place : mélange, incorporation, repos, façonnage, cuisson, refroidissement et conditionnement, chacune avec sa durée et sa description. C'est ce déroulé qui guidera l'opérateur tablette en main, et qui alimentera la traçabilité de chaque fournée de sablés.",
      tip: "Vous pouvez réorganiser, modifier ou supprimer n'importe quelle étape tant que le produit n'est pas figé.",
    },
    "proc-reorder-intro": {
      title: "Réordonner les étapes",
      body: "Utilisez ce bouton pour réordonner les étapes du process. L'ordre n'est pas qu'esthétique : c'est exactement la séquence que l'opérateur déroulera. Inverser repos et façonnage sur les sablés changerait le produit final.",
      tip: "Vérifiez l'ordre après chaque ajout : une étape créée arrive souvent en fin de liste.",
    },
    "proc-menu-intro": {
      title: "Menu d'actions",
      body: "Le menu contextuel d'une étape permet de la modifier, la dupliquer ou la supprimer. La duplication fait gagner du temps quand deux étapes se ressemblent, par exemple deux cuissons à températures différentes pour deux gammes de sablés.",
      tip: "Dupliquez plutôt que de tout ressaisir : vous ne corrigez ensuite que ce qui change.",
    },
    "proc-delete-intro": {
      title: "Supprimer une étape",
      body: "Supprimez une étape devenue inutile. Attention, cette action est irréversible.",
      tip: null,
    },
    "proc-haccp": {
      title: "Lien HACCP",
      body: "Le process est un pilier de votre plan HACCP. À chaque étape, vous pouvez rattacher des contrôles qualité, et chaque contrôle peut être marqué CCP (point critique) ou PrPO (programme prérequis opérationnel). Sur les sablés, la cuisson est typiquement un point critique à surveiller. Voyons comment ajouter ces contrôles.",
      tip: "Les tags CCP et PrPO se posent sur les contrôles, jamais sur les étapes elles-mêmes.",
    },
    "proc-click-edit": {
      title: "Modifier une étape",
      body: "Cliquez sur le crayon pour ouvrir le formulaire d'édition de cette étape. Nous allons y ajouter un contrôle qualité, par exemple la vérification de l'aspect du mélange avant de passer à la suite.",
      tip: null,
    },
    "proc-controles-section": {
      title: "Section contrôles",
      body: "En bas du formulaire, la section Contrôles liste les contrôles qualité rattachés à cette étape. Ici, un contrôle « Aspect du mélange » est déjà configuré : c'est un contrôle Conforme/Non conforme ponctuel (one-shot). C'est ce que l'opérateur devra valider avant de passer à l'incorporation du beurre.",
      tip: "Une étape peut porter autant de contrôles que nécessaire : ils s'enchaînent pour l'opérateur pendant la production.",
    },
    "proc-controle-oneshot": {
      title: "Contrôle ponctuel (one-shot)",
      body: "Ce contrôle est ponctuel : il est réalisé une seule fois pendant l'étape. L'opérateur valide que le mélange est homogène, puis passe à la suite. C'est le mode par défaut tant qu'aucune fréquence ni événement n'est configuré.",
      tip: "Sur les étapes Cuisson et Conditionnement des sablés, on utilise plutôt des contrôles récurrents et sur événement, que nous verrons juste après.",
    },
    "proc-controle-advanced": {
      title: "Créer un contrôle",
      body: "Créons un nouveau contrôle pour découvrir les options avancées. Cliquez sur « Ajouter un contrôle » : vous allez définir une vérification supplémentaire sur l'étape de mélange.",
      tip: null,
    },
    "proc-select-type": {
      title: "Choisir le type",
      body: "Sélectionnez « Conforme / Non conforme ». C'est le contrôle le plus simple : l'opérateur valide ou rejette une condition, sans saisir de valeur. Idéal pour un contrôle visuel rapide comme l'aspect du mélange.",
      tip: "Autres types disponibles : quantitatif (mesure avec bornes mini/maxi), QCM (choix multiples), enregistrement (photo + texte).",
    },
    "proc-fill-controle-denom": {
      title: "Dénomination",
      body: "Saisissez le nom du contrôle, par exemple « Aspect du mélange ». C'est le libellé affiché à l'opérateur sur sa tablette au moment de la vérification : soyez concis et explicite pour qu'il sache immédiatement quoi contrôler.",
      tip: null,
    },
    "proc-fill-controle-desc": {
      title: "Mode opératoire",
      body: "Décrivez les instructions pour l'opérateur : quoi vérifier, quel outil utiliser, quel critère d'acceptation. Par exemple « Vérifier que le mélange est homogène, sans grumeaux ». Plus c'est précis, plus le contrôle est fiable d'un opérateur à l'autre.",
      tip: "Le petit bouton ⊞ en bas à droite permet d'insérer des formules de calcul dynamiques et de joindre des documents (photos, PDF…).",
    },
    "proc-open-advanced": {
      title: "Options avancées",
      body: "Ouvrons les options avancées du contrôle. Vous y trouvez les modes de déclenchement (récurrent, sur événement) et les tags HACCP. C'est ici que se règle la fréquence d'un contrôle de température en cuisson, par exemple.",
      tip: null,
    },
    "proc-controle-recurrent": {
      title: "Contrôle récurrent",
      body: "Ce toggle transforme un contrôle one-shot en contrôle récurrent : l'opérateur devra le réaliser à intervalle fixe (par exemple toutes les 30 min). Une matrice temps-réel s'affiche en production pour suivre les créneaux et garder une trace horodatée de chaque mesure.",
      tip: "Idéal pour la cuisson ou le refroidissement des sablés : un relevé de température toutes les 15 minutes.",
    },
    "proc-controle-event": {
      title: "Contrôle sur événement",
      body: "Ce toggle crée un contrôle déclenché manuellement par l'opérateur, autant de fois que nécessaire. Il n'est ni ponctuel ni récurrent : il est lié à un événement dont on ne maîtrise pas la fréquence, comme un changement de lot de farine en cours de production.",
      tip: "Exemple sur les sablés : un contrôle à chaque changement de rouleau d'étiquettes ou de lot de matière première.",
    },
    "proc-controle-haccp-flags": {
      title: "Tags HACCP",
      body: "Marquez un contrôle comme CCP (Point Critique de Contrôle) ou PrPO (Programme Prérequis Opérationnel) pour structurer votre plan HACCP. Sur les sablés, le contrôle de température à la cuisson serait typiquement un CCP. Ces tags sont mutuellement exclusifs : un contrôle est l'un ou l'autre, pas les deux.",
      tip: "Les contrôles tagués CCP/PrPO ressortent dans vos bilans qualité : c'est la base d'un audit sanitaire serein.",
    },
    "proc-save-controle": {
      title: "Enregistrer le contrôle",
      body: "Cliquez sur Enregistrer pour sauvegarder le contrôle et revenir au formulaire du process. Le contrôle vient s'ajouter à l'étape et sera présenté à l'opérateur au bon moment de la fabrication.",
      tip: null,
    },
    "proc-save-process": {
      title: "Enregistrer le process",
      body: "Cliquez sur Enregistrer pour sauvegarder l'étape de process avec son nouveau contrôle. La modification est prise en compte pour les prochains ordres de fabrication des sablés.",
      tip: null,
    },
    "proc-outro": {
      title: "Votre process est complet",
      body: "Votre process combine désormais des étapes ordonnées et des contrôles ponctuels, récurrents ou sur événement. Avec les tags CCP/PrPO, ils forment votre plan de maîtrise sanitaire. Sur le Biscuit sablé du Moulin, chaque fournée suivra la même recette tracée, du mélange au conditionnement.",
      tip: "Prochaine étape logique : approfondir le module Contrôles qualité pour exploiter tous les types de contrôles.",
    },
    // ===== CONTRÔLES QUALITÉ =====
    "ctrl-intro": {
      title: "Contrôles qualité",
      body: "Les contrôles qualité garantissent la conformité de vos productions et tracent chaque vérification faite par vos opérateurs. Ils se paramètrent dans la fiche de chaque article, par étape du flux : réception d'une matière première, démarrage d'une opération, expédition, etc. Bien posés, ils déclenchent automatiquement le bon contrôle au bon moment et bloquent un lot non conforme avant qu'il ne parte en fabrication. Nous allons commencer par un contrôle à réception sur la matière première Lait.",
      tip: "JustUp propose plusieurs types de contrôles : quantitatif (mesure chiffrée), conforme/non-conforme (CNC), à choix multiple (QCM) et enregistrement (saisie libre).",
    },
    "ctrl-onglet-intro": {
      title: "Onglet Contrôles",
      body: "Vous êtes dans l'onglet Contrôles de la fiche article « Lait entier pasteurisé ». C'est ici que se définit toute la qualité attendue sur cet article. Les contrôles sont organisés par contexte (déchargement, réception de lot, début/fin d'opération…) afin que chacun s'affiche exactement au moment où l'opérateur en a besoin sur le terrain.",
      tip: "Chaque article a son propre onglet Contrôles : une matière première et un produit fini n'auront pas les mêmes vérifications.",
    },
    "ctrl-select-reception": {
      title: "Contexte Réception de lot",
      body: "Cliquez sur « Réception d'un lot » pour basculer sur ce contexte. Tous les contrôles que vous y créez seront proposés à l'opérateur au moment où il enregistre l'arrivée d'un lot de lait fournisseur. C'est le bon endroit pour vérifier la qualité d'une matière première dès qu'elle entre dans votre stock.",
      tip: "Un même article peut porter des contrôles différents selon le contexte : un à la réception, un autre au déchargement, etc.",
    },
    "ctrl-click-add": {
      title: "Ajouter un contrôle",
      body: "Cliquez sur le bouton pour créer un nouveau contrôle dans le contexte Réception de lot. Vous pourrez ajouter autant de contrôles que nécessaire : un seul ne suffit pas toujours pour qualifier une matière première.",
      tip: "Les contrôles s'affichent dans l'ordre de création ; placez d'abord les vérifications les plus critiques.",
    },
    "ctrl-select-type": {
      title: "Type : Quantitatif",
      body: "Choisissez le type « Quantitatif » pour mesurer la concentration en acide lactique du lait reçu. Ce type attend une valeur chiffrée et la compare automatiquement à des limites min/max : si la mesure sort de la plage, le lot est déclaré non conforme sans intervention manuelle. C'est le type idéal pour tout ce qui se mesure (température, pH, poids, taux…).",
      tip: "Utilisez le quantitatif dès qu'un instrument donne un chiffre : il alimente aussi les graphiques de suivi qualité dans le temps.",
    },
    "ctrl-fill-denomination": {
      title: "Dénomination",
      body: "Saisissez « Concentration acide lactique » — c'est le nom qui identifiera ce contrôle dans la fiche article et sur l'écran de l'opérateur. Choisissez un libellé clair et sans ambiguïté : c'est lui qui apparaîtra dans les rapports qualité et l'historique des lots.",
      tip: "Préférez un nom court mais précis ; il sera lu rapidement par l'opérateur en pleine production.",
    },
    "ctrl-fill-description": {
      title: "Mode opératoire",
      body: "Décrivez la procédure de contrôle, par exemple « Prélever un échantillon et mesurer au pH-mètre ». Ce texte s'affiche à l'opérateur au moment du contrôle : plus il est précis, moins il y a d'écart d'interprétation entre deux opérateurs. C'est ce qui garantit qu'une mesure faite le lundi vaut bien celle du jeudi.",
      tip: "Indiquez le matériel et le geste exact (où prélever, avec quel instrument) pour fiabiliser le résultat.",
    },
    "ctrl-fill-unite": {
      title: "Unité de mesure",
      body: "Saisissez « g/L » (grammes par litre) — c'est l'unité dans laquelle l'opérateur saisira sa mesure. L'unité s'affiche à côté du champ de saisie pour éviter toute confusion (g/L plutôt que mg/L) et garantit que les limites min/max sont comparées sur la même échelle.",
      tip: "Fixez l'unité dès la conception du contrôle : la changer plus tard fausserait l'historique des mesures déjà saisies.",
    },
    "ctrl-fill-limite-basse": {
      title: "Limite basse (Min)",
      body: "Saisissez « 0.5 » — en dessous de cette valeur, le contrôle sera automatiquement déclaré non conforme. C'est le garde-fou bas : un lait trop peu acide signalera un problème de fraîcheur ou de process chez le fournisseur, et le lot sera bloqué avant d'entrer en fabrication.",
      tip: "Calez vos limites sur votre cahier des charges fournisseur ou vos seuils réglementaires.",
    },
    "ctrl-fill-limite-haute": {
      title: "Limite haute (Max)",
      body: "Saisissez « 1.5 » — au-dessus de cette valeur, le contrôle sera non conforme. Avec la limite basse, vous définissez la plage acceptable : la mesure de l'opérateur devra se situer entre 0.5 et 1.5 g/L pour valider le lot. Tout dépassement remonte immédiatement comme une non-conformité tracée.",
      tip: "Une plage trop large laisse passer des dérives ; une plage trop serrée multiplie les faux refus. Ajustez avec l'expérience terrain.",
    },
    "ctrl-fill-cible": {
      title: "Cible",
      body: "Saisissez « 1.0 » — c'est la valeur idéale attendue, au centre de votre plage 0.5–1.5. Elle sert de référence pour les graphiques de suivi qualité : vous verrez d'un coup d'œil si vos lots tournent autour de la cible ou dérivent vers une limite, bien avant qu'un lot ne devienne non conforme.",
      tip: "La cible ne bloque rien ; elle sert au pilotage et à l'amélioration continue de la régularité fournisseur.",
    },
    "ctrl-save": {
      title: "Enregistrer le contrôle",
      body: "Cliquez sur Enregistrer pour créer le contrôle. Il rejoint aussitôt la liste du contexte Réception de lot et sera désormais proposé à chaque arrivée d'un lot de lait. Vous pourrez toujours le modifier ou en ajouter d'autres par la suite.",
      tip: "Vérifiez que dénomination, unité et limites sont cohérentes avant d'enregistrer : ce contrôle servira à qualifier de vrais lots.",
    },
    "ctrl-reception-done": {
      title: "Contrôle à réception créé",
      body: "Le contrôle « Concentration acide lactique » sera désormais proposé automatiquement à l'opérateur lors de la réception d'un lot de lait : pas de risque d'oubli, et chaque mesure est tracée. Passons maintenant à un autre type de contrôle, en début d'opération cette fois, sur un produit fini : les Biscuits sablés du Moulin.",
      tip: "Un produit fini se contrôle souvent pendant sa fabrication, alors qu'une matière première se contrôle surtout à l'entrée.",
    },
    "ctrl-pf-go-articles": {
      title: "Changeons d'article",
      body: "Le contrôle de réception est en place sur le Lait. Nous allons maintenant configurer un contrôle en début d'opération sur un produit fini : les Biscuits sablés du Moulin. Chaque article ayant sa propre fiche de contrôles, il faut d'abord rejoindre la fiche du biscuit.",
      tip: "Les contrôles ne se partagent pas entre articles : pensez à les définir sur chaque produit que vous fabriquez.",
    },
    "ctrl-pf-open-menu": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu latéral pour naviguer vers la section Articles.",
      tip: null,
    },
    "ctrl-pf-open-section": {
      title: "Section Catalogue",
      body: "Repérez la ligne « Articles » dans le menu. Elle se trouve dans la section Catalogue.",
      tip: null,
    },
    "ctrl-pf-nav-articles": {
      title: "Accéder aux Articles",
      body: "Cliquez sur « Articles » pour ouvrir la liste de vos articles.",
      tip: null,
    },
    "ctrl-pf-click-biscuits": {
      title: "Ouvrir la fiche Biscuits",
      body: "Cliquez sur la carte « Biscuits sablés du Moulin » (PF-BIS-001) pour accéder à sa fiche.\nC'est sur ce produit fini que nous ajouterons le contrôle de démarrage d'opération.",
      tip: null,
    },
    "ctrl-pf-click-tab-controles": {
      title: "Onglet Contrôles",
      body: "Cliquez sur l'onglet « Contrôles » pour accéder à la configuration des contrôles qualité du biscuit. Vous retrouvez la même organisation par contexte que sur le Lait, mais avec des étapes adaptées à un produit fabriqué : démarrage d'opération, fin d'opération, etc.",
      tip: "Sur un produit fini, c'est ici que vous formalisez les autocontrôles de vos opérateurs en ligne.",
    },
    "ctrl-pf-intro": {
      title: "Contrôle en début d'opé",
      body: "Nous sommes dans la fiche article « Biscuits sablés du Moulin », onglet Contrôles. Nous allons ajouter un contrôle à choix multiple en début d'opération pour vérifier le réglage du four avant de lancer la cuisson. Un mauvais réglage = des biscuits trop cuits ou pas assez : ce contrôle évite de lancer un lot entier sur une erreur de paramétrage.",
      tip: "Les contrôles de démarrage sécurisent les réglages machine avant la première pièce produite.",
    },
    "ctrl-pf-select-startope": {
      title: "Contexte Démarrage opé.",
      body: "Cliquez sur « Démarrage d'une opé. » pour basculer sur ce contexte. Les contrôles ajoutés ici seront proposés à l'opérateur au tout début de chaque opération de fabrication, avant qu'il ne lance la production — c'est le moment idéal pour valider les réglages machine.",
      tip: "Distinguez bien « début » (avant de produire) et « fin » d'opération (contrôle du résultat) : ils n'ont pas le même rôle.",
    },
    "ctrl-pf-click-add": {
      title: "Ajouter un contrôle",
      body: "Cliquez sur le bouton pour créer un nouveau contrôle dans le contexte Démarrage d'une opération. Comme pour le Lait, vous pouvez en empiler plusieurs : réglage du four, propreté du poste, conformité de la matière en ligne, etc.",
      tip: "Regroupez sur le démarrage tous les points à vérifier d'un seul coup d'œil avant le lancement.",
    },
    "ctrl-pf-select-type": {
      title: "Type : Choix multiple (QCM)",
      body: "Choisissez le type « Choix multiple » (QCM). Il propose à l'opérateur plusieurs réponses prédéfinies parmi lesquelles il sélectionne celle observée. Une étoile ★ désigne la bonne réponse attendue — toute autre sélection est signalée comme non conforme. C'est parfait pour un réglage qui n'a que quelques positions possibles, comme la vitesse du tapis du four.",
      tip: "Le QCM évite les saisies libres ambiguës : l'opérateur choisit, il ne tape pas.",
    },
    "ctrl-pf-fill-denomination": {
      title: "Dénomination",
      body: "Saisissez « Reglage vitesse four » — ce contrôle vérifiera que le tapis du four est réglé sur la bonne vitesse avant de démarrer la cuisson. Comme pour tout contrôle, ce libellé apparaîtra sur l'écran de l'opérateur et dans l'historique qualité du lot.",
      tip: "Nommez le contrôle par ce qu'il vérifie concrètement, pas par le numéro de la machine.",
    },
    "ctrl-pf-fill-description": {
      title: "Mode opératoire",
      body: "Décrivez la consigne : « Vérifier le réglage de la vitesse du tapis du four avant de démarrer la cuisson ». Ce texte rappelle à l'opérateur quoi regarder et où, juste avant qu'il ne choisisse parmi les réponses du QCM. Une consigne claire évite les sélections faites au hasard.",
      tip: "Indiquez où lire le réglage (afficheur, position de la molette) pour que la réponse soit fiable.",
    },
    "ctrl-pf-fill-choice-1": {
      title: "Première réponse",
      body: "Saisissez « Lent (8 min) » dans le champ de texte. C'est l'une des positions possibles du tapis : trop lente pour ce biscuit, elle donnerait une cuisson excessive. Proposer les mauvais réglages comme choix permet justement de détecter une erreur.",
      tip: "Listez les réponses comme elles apparaissent physiquement sur la machine, pour que l'opérateur les reconnaisse au premier coup d'œil.",
    },
    "ctrl-pf-add-choice-1": {
      title: "Ajouter le choix",
      body: "Cliquez sur le bouton + vert à droite du champ pour ajouter « Lent (8 min) » à la liste des réponses proposées. Tant que vous n'avez pas validé, la réponse n'est pas enregistrée dans le QCM.",
      tip: "Vous pouvez réordonner ou supprimer une réponse tant que le contrôle n'est pas enregistré.",
    },
    "ctrl-pf-fill-choice-2": {
      title: "Deuxième réponse",
      body: "Saisissez « Standard (6 min) » dans le champ. C'est le réglage nominal pour les biscuits sablés — ce sera la bonne réponse, celle que nous marquerons d'une étoile plus loin. C'est la position qui garantit une cuisson uniforme et la texture attendue.",
      tip: "Une seule réponse sera la bonne ; les autres servent de pièges réalistes pour vérifier la vigilance de l'opérateur.",
    },
    "ctrl-pf-add-choice-2": {
      title: "Ajouter le choix",
      body: "Cliquez sur le bouton + pour ajouter « Standard (6 min) » à la liste des réponses. Vous avez maintenant deux choix ; il en reste un à saisir.",
      tip: "Trois réponses bien choisies suffisent souvent : trop de choix noie l'information utile.",
    },
    "ctrl-pf-fill-choice-3": {
      title: "Troisième réponse",
      body: "Saisissez « Rapide (4 min) » dans le champ. Ce réglage n'est pas adapté aux biscuits sablés : trop rapide, le tapis sortirait des biscuits insuffisamment cuits. Le proposer permet de couvrir toutes les positions réelles de la machine.",
      tip: "Couvrez tous les réglages physiquement possibles : un opérateur qui ne trouve pas sa réponse risque d'en cocher une au hasard.",
    },
    "ctrl-pf-add-choice-3": {
      title: "Ajouter le choix",
      body: "Cliquez sur le bouton + pour ajouter « Rapide (4 min) » à la liste. Vos trois réponses possibles sont maintenant en place ; il ne reste plus qu'à désigner laquelle est la bonne.",
      tip: "Relisez vos trois réponses : elles doivent toutes correspondre à un réglage réellement disponible sur la machine.",
    },
    "ctrl-pf-set-correct": {
      title: "Définir la bonne réponse",
      body: "Cliquez sur l'étoile ★ à côté de « Standard (6 min) » pour la définir comme la bonne réponse. L'opérateur devra sélectionner ce réglage pour que le contrôle soit conforme : s'il coche « Lent » ou « Rapide », le contrôle remonte automatiquement en non-conformité et le démarrage est signalé.",
      tip: "L'étoile ★ indique la réponse attendue. Toute autre sélection sera signalée comme non conforme dans le suivi qualité.",
    },
    "ctrl-pf-save": {
      title: "Enregistrer",
      body: "Cliquez sur Enregistrer pour créer le contrôle à choix multiple. Il sera désormais proposé à l'opérateur au démarrage de chaque opération de cuisson des Biscuits sablés du Moulin, et sa réponse sera tracée dans l'historique qualité.",
      tip: "Vérifiez qu'une étoile ★ est bien posée sur la bonne réponse avant d'enregistrer, sinon aucun choix ne sera jugé conforme.",
    },
    "ctrl-outro": {
      title: "Vos contrôles qualité sont en place",
      body: "Vos contrôles qualité sont en place !\n• Le contrôle quantitatif sur le Lait sera proposé à chaque réception de lot.\n• Le contrôle à choix multiple (réglage four) sera proposé à l'opérateur au démarrage de chaque opération sur les Biscuits.\nChaque contrôle réalisé est tracé : vous gardez une preuve de conformité, lot par lot, exploitable en cas d'audit ou de réclamation.",
      tip: "Vous pouvez ajouter autant de contrôles que nécessaire sur chaque article, pour chaque étape du flux.",
    },
    // ===== RÉGLAGES PRÉ-PRODUCTION =====
    "preprod-intro": {
      title: "Réglages avant production",
      body: "Avant de lancer votre première production, il faut définir comment chaque matière première sera consommée. C'est ce réglage qui rendra vos coûts et votre traçabilité fiables : une Farine bien paramétrée remonte le bon coût matière jusqu'au prix de revient du biscuit. Commençons par la Farine de blé T65, que nous passerons en mode « Pied de chaîne » (PDC) pour un suivi précis des quantités mises sur la ligne.",
      tip: "Le mode PDC est idéal pour les matières premières utilisées en grande quantité, où il faut connaître la quantité exacte mise en ligne.",
    },
    "preprod-click-farine": {
      title: "Ouvrir la fiche Farine",
      body: "Cliquez sur la carte « Farine de blé T65 » pour ouvrir sa fiche article. C'est ici que se règlent toutes les caractéristiques de cette matière première, dont son mode de consommation en production.",
      tip: "Le code MP-FAR-001 vous aide à repérer rapidement la matière première dans une liste qui peut compter des centaines d'articles.",
    },
    "preprod-edit-farine": {
      title: "Passer en édition",
      body: "Cliquez sur Modifier pour pouvoir changer les paramètres de l'article. Tant que vous n'êtes pas en édition, la fiche est en lecture seule afin d'éviter toute modification accidentelle d'une spécification utilisée en production.",
      tip: "Vos modifications créent une nouvelle version de spécification ; l'ancienne reste consultable dans l'historique.",
    },
    "preprod-scroll-conso": {
      title: "Section Consommation",
      body: "Voici la section « Mode de consommation ». Elle détermine comment l'opérateur déclarera l'utilisation de cette matière première en production, et donc comment le stock sera décrémenté. Trois modes existent : Automatique (théorique, calculé d'après la recette), Déclaration manuelle, et Pied de chaîne (PDC).",
      tip: "Le mode choisi influe directement sur la précision de votre coût matière et de votre traçabilité aval.",
    },
    "preprod-select-pdc": {
      title: "Mode Pied de chaîne",
      body: "Sélectionnez « Suivi précis (PDC) ». Avec ce mode, l'opérateur déclarera la quantité exacte de Farine mise à disposition sur la ligne, puis ce qui revient en stock. Le système en déduit la consommation réelle — idéal pour une matière dosée au sac comme la farine.",
      tip: "PDC = l'opérateur déclare ce qu'il met en ligne. La consommation est calculée par différence avec le retour en stock.",
    },
    "preprod-save-farine": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour sauvegarder le mode PDC sur la Farine. À ce stade la spécification est enregistrée en brouillon ; il restera à l'activer pour qu'elle soit utilisée en production.",
      tip: "Enregistrer ne suffit pas : tant que la version n'est pas activée, la production utilise l'ancienne spécification.",
    },
    "preprod-publish-farine": {
      title: "Utiliser cette version",
      body: "Cliquez sur « Utiliser cette version » en haut de la page pour activer la spécification de la Farine. Comme votre activité est configurée « Sans Validation », la spécification passe directement en cours d'utilisation, sans circuit d'approbation.",
      tip: "En mode « Avec Validation », cette action déclencherait une demande d'approbation avant activation.",
    },
    "preprod-confirm-farine": {
      title: "Confirmer l'activation",
      body: "Confirmez pour activer cette version de la spécification. Une fois confirmée, c'est cette version qui sera utilisée par tous les OF lancés à partir de maintenant.",
      tip: null,
    },
    "preprod-pdc-done": {
      title: "Farine configurée",
      body: "La Farine est maintenant en mode Pied de chaîne (PDC) : ses quantités seront suivies au plus près en production. Passons au Sucre, que nous mettrons en mode « Déclaration de consommation », mieux adapté à un ingrédient pesé à la main.",
      tip: null,
    },
    "preprod-conso-intro": {
      title: "Déclaration de consommation",
      body: "Passons au Sucre en poudre. Dans le mode « Déclaration de consommation », l'opérateur saisit directement la quantité réellement consommée pendant la production. C'est adapté aux ingrédients dosés manuellement, comme le sucre pesé à chaque fournée.",
      tip: null,
    },
    "preprod-open-menu-conso": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu de navigation pour retourner à la liste des articles et sélectionner le Sucre.",
      tip: null,
    },
    "preprod-open-section-conso": {
      title: "Section Articles",
      body: "Repérez l'entrée « Articles » dans le menu : c'est le catalogue qui regroupe vos matières premières, vos produits finis et vos consommables.",
      tip: null,
    },
    "preprod-nav-articles-conso": {
      title: "Accéder aux Articles",
      body: "Cliquez sur « Articles » pour revenir à la liste et y retrouver le Sucre en poudre.",
      tip: null,
    },
    "preprod-click-sucre": {
      title: "Ouvrir la fiche Sucre",
      body: "Cliquez sur la carte « Sucre en poudre » (MP-SUC-003) pour ouvrir sa fiche et accéder à son mode de consommation.",
      tip: null,
    },
    "preprod-edit-sucre": {
      title: "Passer en édition",
      body: "Cliquez sur Modifier pour activer l'édition de la fiche du Sucre.",
      tip: null,
    },
    "preprod-select-volee": {
      title: "Mode Déclaration de consommation",
      body: "Sélectionnez « Déclaration consos ». L'opérateur saisira manuellement la quantité de Sucre réellement utilisée à chaque opération, ce qui ajuste le coût matière au plus juste fournée par fournée.",
      tip: "Ce mode convient aux ingrédients ajoutés manuellement (pesée, dosage) où la quantité exacte varie d'une production à l'autre.",
    },
    "preprod-save-sucre": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour sauvegarder le mode de consommation du Sucre en brouillon.",
      tip: null,
    },
    "preprod-publish-sucre": {
      title: "Utiliser cette version",
      body: "Cliquez sur « Utiliser cette version » pour activer la spécification du Sucre afin qu'elle soit prise en compte par la production.",
      tip: null,
    },
    "preprod-confirm-sucre": {
      title: "Confirmer",
      body: "Confirmez l'activation de la spécification du Sucre.",
      tip: null,
    },
    "preprod-conso-done": {
      title: "Sucre configuré",
      body: "Le Sucre est en mode Déclaration de consommation : sa quantité sera saisie à la main à chaque fournée. Passons maintenant à la DDM (Date de Durabilité Minimale) sur les Biscuits, indispensable pour étiqueter vos produits finis.",
      tip: null,
    },
    "preprod-ddm-intro": {
      title: "Date de durabilité (DDM)",
      body: "Passons aux Biscuits sablés du Moulin. Chaque produit fini doit avoir une DDM configurée : c'est elle qui permet à JustUp de calculer automatiquement la date limite à apposer sur l'étiquette dès la fabrication, sans saisie manuelle.",
      tip: "DDM (« à consommer de préférence avant ») pour les produits secs comme les biscuits ; DLC (« à consommer jusqu'au ») pour les produits périssables.",
    },
    "preprod-open-menu-ddm": {
      title: "Ouvrir le menu",
      body: "Ouvrons le menu de navigation pour retourner à la liste des articles.",
      tip: null,
    },
    "preprod-open-section-ddm": {
      title: "Section Articles",
      body: "Repérez « Articles » dans le menu pour rouvrir le catalogue.",
      tip: null,
    },
    "preprod-nav-articles-ddm": {
      title: "Accéder aux Articles",
      body: "Cliquez sur « Articles » pour revenir à la liste et y sélectionner les Biscuits.",
      tip: null,
    },
    "preprod-click-biscuits": {
      title: "Ouvrir la fiche Biscuits",
      body: "Cliquez sur la carte « Biscuits sablés du Moulin » (PF-BIS-001), votre produit fini, pour ouvrir sa fiche et configurer sa DDM.",
      tip: null,
    },
    "preprod-edit-biscuits": {
      title: "Passer en édition",
      body: "Cliquez sur Modifier pour activer l'édition de la fiche des Biscuits.",
      tip: null,
    },
    "preprod-publish-biscuits": {
      title: "Utiliser cette version",
      body: "Cliquez sur « Utiliser cette version » pour activer la spécification des Biscuits. L'article sera alors prêt à être produit avec sa DDM calculée automatiquement.",
      tip: null,
    },
    "preprod-confirm-biscuits": {
      title: "Confirmer",
      body: "Confirmez l'activation : la spécification des Biscuits devient la version en cours, utilisée par tous les futurs OF.",
      tip: null,
    },
    "preprod-scroll-ddm": {
      title: "Section Dates limites",
      body: "Voici la section « Dates limites ». Elle permet de configurer la DDM (ou DLC) de l'article, qui sera calculée automatiquement à chaque fabrication. Plusieurs champs sont disponibles — nous allons les renseigner un par un.",
      tip: null,
    },
    "preprod-fill-dluo": {
      title: "Durée de conservation",
      body: "Ce champ indique la durée de conservation, exprimée dans l'échelle choisie juste avant (Mois). Saisissez « 6 » : vos biscuits sablés auront une DDM de 6 mois à compter de la date de fabrication.",
      tip: "Cette valeur sert de référence ; chaque lot fabriqué reprendra automatiquement cette durée pour calculer sa propre date limite.",
    },
    "preprod-select-echelle": {
      title: "Échelle de durée",
      body: "Ce champ détermine l'échelle de la durée : Jours, Mois ou Années. C'est lui qui conditionne quel champ « durée » s'affiche ensuite. Sélectionnez « Mois » : la DDM des biscuits sablés sera exprimée en mois.",
      tip: "Choisissez l'échelle avant de saisir la valeur : changer d'échelle peut réinitialiser le champ durée.",
    },
    "preprod-select-type-periode": {
      title: "Type de période",
      body: "Ce champ apparaît quand l'échelle est en Mois ou Années. « Net » ajoute exactement la durée (15/03 + 6 mois = 15/09) ; « Fin de période » arrondit à la fin du mois (15/03 + 6 mois = 30/09). Sélectionnez « Fin de période », pratique pour des biscuits étiquetés au mois.",
      tip: "« Fin de période » simplifie la lecture client : une DDM affichée « 09/2026 » plutôt qu'une date précise au jour.",
    },
    "preprod-select-format": {
      title: "Format d'affichage",
      body: "Ce champ définit comment la date sera imprimée sur les étiquettes et documents. Sélectionnez « JJ/MM/AA » (ex: 15/09/26), un format compact et lisible pour les sachets de biscuits.",
      tip: "Choisissez le format selon vos étiquettes : un format court gagne de la place sur de petits emballages.",
    },
    "preprod-info-ddm-lot": {
      title: "DDM comme numéro de lot",
      body: "Si vous activez cette option, la DDM sera automatiquement utilisée comme numéro de lot pour cet article. C'est pratique quand vos lots sont identifiés par leur date de péremption (ex: « 09/2026 »). Pour ce tuto, vous pouvez la laisser telle quelle.",
      tip: "Évitez cette option si plusieurs fournées d'une même journée partagent la même DDM : leurs lots deviendraient indistincts.",
    },
    "preprod-save-biscuits": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour sauvegarder la DDM des Biscuits en brouillon.",
      tip: null,
    },
    "preprod-ddm-done": {
      title: "Réglages terminés !",
      body: "Tous les réglages pré-production sont en place :\n\n- Farine en mode Pied de chaîne (PDC)\n- Sucre en mode Déclaration de consommation\n- Biscuits avec une DDM de 6 mois\n\nComme la validation des spécifications est désactivée (« Sans Validation »), vos articles sont directement prêts à produire.",
      tip: "Prochaine étape : créer votre premier Ordre de Fabrication (OF) pour lancer la production des Biscuits.",
    },
    "preprod-valid-intro": {
      title: "Validation de la spécification",
      body: "La spécification est actuellement « En rédaction ». Pour pouvoir lancer une production, elle doit passer par le circuit de validation :\n1. Demander la validation (fin de rédaction)\n2. Valider\n3. Approuver",
      tip: "Ce circuit en 3 étapes garantit une revue avant la mise en production. Dans JustUp, chaque étape peut être attribuée à un rôle différent (rédacteur, valideur, approbateur).",
    },
    "preprod-click-demande-valid": {
      title: "Demander la validation",
      body: "Cliquez sur « Demander validation » pour signaler que la rédaction de la spécification est terminée.",
      tip: null,
    },
    "preprod-confirm-demande": {
      title: "Confirmer",
      body: "Confirmez la fin de rédaction. La spécification passera à l'état « Rédigée ».",
      tip: null,
    },
    "preprod-click-validate": {
      title: "Valider",
      body: "La spécification est « Rédigée ». Cliquez sur « Valider » pour passer à l'étape suivante.",
      tip: null,
    },
    "preprod-confirm-validate": {
      title: "Confirmer la validation",
      body: "Confirmez la validation. La spécification passera à l'état « Validée ».",
      tip: null,
    },
    "preprod-click-approuve": {
      title: "Approuver",
      body: "Dernière étape : cliquez sur « Approuver » pour finaliser la spécification.",
      tip: null,
    },
    "preprod-confirm-approuve": {
      title: "Confirmer l'approbation",
      body: "Confirmez l'approbation. La spécification sera « Approuvée » et l'article sera prêt à produire.",
      tip: null,
    },
    "preprod-valid-done": {
      title: "Spécification approuvée !",
      body: "La spécification des Biscuits sablés du Moulin est maintenant approuvée.\nL'article est prêt pour la production : nomenclature, procédés, contrôles et paramètres sont tous en place.",
      tip: "Vous pouvez maintenant créer un Ordre de Fabrication (OF) pour lancer la production de cet article.",
    },
    // ===== LIGNES DE PRODUCTION =====
    "ligne-intro": {
      title: "Lignes de production",
      body: "Les lignes de production représentent vos équipements de fabrication : pétrin, four, conditionnement. Chaque ligne porte sa cadence, ses paramètres techniques et ses horaires d'ouverture. C'est sur une ligne que tournent vos ordres de fabrication (OF). Nous allons en créer une pour fabriquer nos biscuits sablés du Moulin.",
      tip: "Une ligne bien paramétrée alimente directement le planning : JustUp saura quand et combien de biscuits vous pouvez produire.",
    },
    "ligne-empty-list": {
      title: "Aucune ligne",
      body: "Votre espace est vide pour l'instant. Tant qu'aucune ligne n'existe, vous ne pourrez ni planifier ni lancer d'OF. Créons notre première ligne de production pour la Boulangerie du Moulin.",
      tip: "Prérequis : au moins une adresse doit avoir été créée dans le paramétrage administratif, car la ligne y est rattachée.",
    },
    "ligne-click-add": {
      title: "Créer une ligne",
      body: "Cliquez sur le bouton « + » pour ouvrir le formulaire de création. Vous y saisirez le nom de la ligne, son site et son premier paramétrage technique.",
      tip: null,
    },
    "ligne-dialog-intro": {
      title: "Formulaire de création",
      body: "Ce formulaire crée la ligne et son premier paramétrage technique en une seule étape. Le paramétrage relie la ligne à une famille technique (ce qu'elle sait fabriquer) avec sa cadence et ses temps. Passons en revue chaque champ.",
      tip: null,
    },
    "ligne-fill-denomination": {
      title: "Nom de la ligne",
      body: "Saisissez « Ligne Biscuits » — c'est la ligne sur laquelle seront fabriqués nos biscuits sablés du Moulin. Ce nom apparaîtra dans le planning et sur les OF, choisissez-le parlant pour vos équipes.",
      tip: "Préférez un nom clair lié à l'équipement (« Four 1 », « Conditionnement ») plutôt qu'un code interne.",
    },
    "ligne-fill-adresse": {
      title: "Adresse de la ligne",
      body: "L'adresse détermine le site physique de la ligne. Elle impacte les stocks : la farine et le sucre seront débités de ce site, et les biscuits finis y seront créés à la clôture de l'OF. Sélectionnez l'adresse de la Boulangerie du Moulin.",
      tip: "Les adresses sont celles créées dans le paramétrage administratif.",
    },
    "ligne-fill-nb-of": {
      title: "Nombre max d'OFs en parallèle",
      body: "Ce champ détermine combien d'OFs peuvent tourner simultanément sur cette ligne. À 1, l'équipe doit clôturer l'OF de biscuits en cours avant d'en démarrer un nouveau — c'est le réglage le plus simple pour une petite production.",
      tip: "Intéressant pour les lignes à double flux : mettez 2 pour lancer un OF pendant qu'un autre se termine.",
    },
    "ligne-fill-famille-tech": {
      title: "Famille technique",
      body: "Ce champ crée directement le premier paramétrage de la ligne. Sélectionnez « Biscuits » — la famille technique créée dans le paramétrage activité. C'est ce lien qui indique à JustUp que cette ligne sait fabriquer des biscuits, et qui la rendra proposable au planning pour ces produits.",
      tip: "Une même ligne peut porter plusieurs familles techniques, chacune avec sa propre cadence.",
    },
    "ligne-fill-cadence": {
      title: "Cadence nominale",
      body: "Saisissez « 50 » unités/heure — c'est la cadence théorique de la ligne pour la famille Biscuits. Elle sert à estimer la durée prévue de l'OF dans la planification (ex : 500 biscuits ≈ 10 h), et de référence à la clôture pour comparer avec la productivité réelle.",
      tip: "Calez la cadence sur une moyenne réaliste : trop optimiste, votre planning sous-estimera les durées.",
    },
    "ligne-fill-nb-ouvriers": {
      title: "Nombre d'ouvriers",
      body: "Saisissez le nombre d'opérateurs habituellement nécessaires pour faire tourner la ligne sur ce paramétrage — par exemple « 2 » pour la fabrication des biscuits. Cette information sert à la planification des équipes et au coût main-d'œuvre de l'OF.",
      tip: null,
    },
    "ligne-fill-calage-nettoyage": {
      title: "Temps de calage et nettoyage",
      body: "Ce sont des coûts fixes en temps (en minutes) : le calage pour préparer le four et la pâte avant production, le nettoyage après le lot de biscuits. Par exemple 30 min de calage et 20 min de nettoyage. Ils sont pris en compte dans les statistiques de fin d'OF et la comparaison entre productivité réelle et heures saisies.",
      tip: "Ne les négligez pas : sur de petites séries, ces temps fixes pèsent lourd dans le coût unitaire du biscuit.",
    },
    "ligne-save": {
      title: "Enregistrer la ligne",
      body: "Cliquez sur Enregistrer pour créer la ligne avec son paramétrage technique. La « Ligne Biscuits » apparaîtra alors dans la liste, prête à recevoir ses horaires et à être planifiée.",
      tip: null,
    },
    "ligne-card-click": {
      title: "Ouvrir la fiche",
      body: "Cliquez sur la carte de la ligne pour accéder à sa fiche détaillée. C'est là que vous gérez ses infos générales, ses horaires d'ouverture et ses paramètres techniques.",
      tip: null,
    },
    "ligne-infos-intro": {
      title: "Informations générales",
      body: "L'onglet « Infos générales » affiche le nom, l'adresse et la photo de la ligne. Ajouter une photo de l'équipement aide les opérateurs à identifier la bonne ligne d'un coup d'œil. Vous pouvez modifier ces informations à tout moment.",
      tip: null,
    },
    "ligne-horaires-tab": {
      title: "Onglet Planning",
      body: "Cliquez sur l'onglet « Planning » pour accéder aux horaires d'ouverture de la ligne. Ces horaires définissent les plages où la ligne peut produire.",
      tip: null,
    },
    "ligne-horaires-intro": {
      title: "Horaires d'ouverture",
      body: "Définissez ici les créneaux d'ouverture pour chaque jour de la semaine. Le planning des OFs ne proposera que les créneaux disponibles : un OF de biscuits ne sera jamais placé un dimanche si la ligne est fermée. Paramétrons le lundi en commençant par ajouter un créneau.",
      tip: null,
    },
    "ligne-horaires-add-lundi": {
      title: "Ajouter un créneau le lundi",
      body: "Cliquez sur le « + » du lundi pour définir un créneau d'ouverture. Vous pourrez ajouter plusieurs créneaux par jour, par exemple pour gérer une coupure du midi.",
      tip: null,
    },
    "ligne-horaires-fill-de": {
      title: "Heure de début",
      body: "Saisissez « 09:00 » comme heure de début du créneau — l'heure à laquelle la production de biscuits peut démarrer le lundi.",
      tip: null,
    },
    "ligne-horaires-fill-a": {
      title: "Heure de fin",
      body: "Saisissez « 17:00 » comme heure de fin. Le créneau couvre ainsi 8 heures d'ouverture, soit la capacité de production maximale de la ligne ce jour-là.",
      tip: null,
    },
    "ligne-horaires-validate": {
      title: "Valider le créneau",
      body: "Cliquez sur Valider pour ajouter ce créneau 09:00–17:00 au lundi. Il s'affichera dans la liste des créneaux du jour.",
      tip: null,
    },
    "ligne-horaires-copie": {
      title: "Copier sur les autres jours",
      body: "En cliquant sur Suivant, les créneaux du lundi seront automatiquement copiés sur mardi à vendredi — pratique quand la semaine est régulière. En temps normal, vous le faites manuellement via « Copier un autre jour » lors de l'ajout d'un créneau.",
      tip: "Gardez le week-end fermé si la boulangerie ne produit pas : les OFs ne pourront pas y être placés.",
    },
    "ligne-horaires-save": {
      title: "Enregistrer les horaires",
      body: "Cliquez sur Enregistrer pour sauvegarder les horaires de la ligne. Le planning des OFs s'appuiera désormais sur ces plages d'ouverture.",
      tip: null,
    },
    "ligne-params-tab": {
      title: "Onglet Paramètres",
      body: "Cliquez sur l'onglet « Paramètres » pour voir le paramétrage technique de la ligne : familles techniques, cadences, temps de calage et nettoyage.",
      tip: null,
    },
    "ligne-params-intro": {
      title: "Paramètres techniques",
      body: "Voici le paramétrage que nous venons de créer : la famille Biscuits avec sa cadence de 50 unités/heure. Vous pouvez ajouter d'autres familles techniques ici pour que la ligne gère plusieurs types de produits avec des cadences différentes — par exemple des sablés et des madeleines sur le même four.",
      tip: "Affinez ces paramètres dans le temps à partir des écarts constatés à la clôture des OFs.",
    },
    "ligne-outro": {
      title: "Ligne configurée !",
      body: "Votre ligne « Ligne Biscuits » est prête : famille technique, cadence et horaires d'ouverture sont en place. Lors de la planification, JustUp proposera automatiquement cette ligne pour les OFs de biscuits et calculera leurs durées à partir de sa cadence.",
      tip: "Le paramétrage est terminé ! Vous pouvez maintenant passer au catalogue produit.",
    },
    // ===== COMMANDES FOURNISSEURS =====
    "cmd-intro": {
      title: "Commandes fournisseurs",
      body: "Les commandes fournisseurs servent à approvisionner vos matières premières : ici, le sucre, la farine ou le beurre nécessaires aux Biscuits sablés du Moulin. Une commande bien tracée garantit que vous saurez toujours quel lot de matière a servi à quelle fabrication. Ce tutoriel vous guide de la création jusqu'à la confirmation d'une commande.",
      tip: "Le cycle complet : rédaction → confirmation → livraison → réception → solde.",
    },
    "cmd-overview": {
      title: "Vue d'ensemble",
      body: "La liste affiche toutes vos commandes avec leur numéro, le fournisseur, la date, l'état et le montant. Chaque commande passe par plusieurs états au fil de son cycle de vie, ce qui vous permet de suivre en un coup d'œil ce qui est en attente de livraison ou déjà reçu.",
      tip: "Filtrez par état (en rédaction, confirmée, livrée...) pour retrouver rapidement une commande.",
    },
    "cmd-list-display": {
      title: "Liste des commandes",
      body: "Les commandes sont triées par date de création. Chaque carte affiche un résumé avec le fournisseur, le nombre de lignes et le montant total.",
      tip: null,
    },
    "cmd-card-display": {
      title: "Carte d'une commande",
      body: "Chaque carte résume une commande : le fournisseur, le numéro, la date de livraison prévue et l'état courant. Cliquez sur une carte pour ouvrir la fiche complète, voir le détail des lignes (sucre, farine…) et les documents associés.",
      tip: "Le badge d'état colore la carte : repérez d'abord les commandes en attente de livraison.",
    },
    "cmd-etats": {
      title: "États d'une commande",
      body: "Le badge à droite indique l'état : « En rédaction » (brouillon modifiable), « En attente de livraison » (confirmée et figée), puis « Terminée » une fois livrée et soldée. Cet enchaînement vous évite de modifier par erreur une commande déjà envoyée au fournisseur.",
      tip: "Utilisez les filtres d'état pour ne voir que les commandes qui nécessitent une action.",
    },
    "cmd-add-btn": {
      title: "Ajouter une commande",
      body: "Ce bouton ouvre le formulaire de création. Vous y choisissez le fournisseur (par exemple Moulin de Provence pour le sucre) et l'adresse de livraison, puis vous ajoutez les lignes d'articles à commander. C'est le point de départ de tout réapprovisionnement.",
      tip: null,
    },
    // --- Paramétrage article fourni (achat) ---
    "af-achat-intro": {
      title: "Paramétrage des prix fournisseur",
      body: "Avant de commander, il faut indiquer à JustUp combien vous coûte chaque matière. On va créer un « article fourni » pour le Sucre cristal chez Moulin de Provence : ce prix d'achat remonte ensuite la nomenclature jusqu'au coût de revient du Biscuit sablé du Moulin.",
      tip: "Les prix fournisseur sont gérés dans l'onglet Commercial de la fiche tiers.",
    },
    "af-achat-onglet": {
      title: "L'onglet Commercial",
      body: "Cet onglet centralise les conditions commerciales négociées avec ce fournisseur. Il contient deux sections : « Articles fournis » (les prix d'achat et de vente convenus) et « Remises » (les remises globales). C'est ici que vivent les tarifs que JustUp réutilisera dans toutes vos commandes.",
      tip: "Chaque article peut avoir plusieurs paliers de prix selon la quantité commandée.",
    },
    "af-achat-section": {
      title: "Articles fournis",
      body: "Cette section liste les articles que vous achetez à ce fournisseur avec leurs prix négociés. Tant qu'elle est vide, aucun tarif n'est connu et les lignes de commande devront être saisies à la main. Ajoutons le Sucre cristal pour automatiser le prix.",
      tip: null,
    },
    "af-achat-add": {
      title: "Ajouter un article fourni",
      body: "Cliquez sur ce bouton pour ouvrir le formulaire de saisie d'un nouvel article fourni. Vous y associerez un article de votre catalogue (le Sucre cristal) à son prix d'achat chez ce fournisseur.",
      tip: null,
    },
    "af-achat-dialog": {
      title: "Formulaire article fourni",
      body: "Ce dialog permet de configurer un article avec son prix d'achat. Vous allez renseigner l'article, la référence fournisseur, l'unité de gestion, le coefficient de conversion et le prix. Ces informations rendent vos futures commandes plus rapides et fiables.",
      tip: null,
    },
    "af-achat-toggle": {
      title: "Type de prix : Achat",
      body: "Le toggle est sur « Vente » par défaut. Basculez-le sur « Achat » puisqu'on paramètre ici le prix auquel vous achetez le Sucre, et non celui auquel vous le revendriez. Ce choix détermine où le tarif sera utilisé dans JustUp.",
      tip: "Sélectionnez « Achat » dans le toggle mis en surbrillance.",
    },
    "af-achat-article": {
      title: "Sélection de l'article",
      body: "Cherchez et sélectionnez « Sucre cristal » dans la liste déroulante. C'est l'article de votre catalogue auquel ce prix d'achat sera rattaché, et qu'on retrouvera ensuite dans la nomenclature du biscuit.",
      tip: "Tapez « Sucre » pour filtrer la liste, puis cliquez sur « Sucre cristal (MP-SUC-003) ».",
    },
    "af-achat-reference": {
      title: "Référence fournisseur",
      body: "Saisissez la référence que Moulin de Provence utilise pour cet article dans son propre catalogue. Elle apparaîtra sur le bon de commande pour que le fournisseur identifie immédiatement le produit demandé.",
      tip: "Saisissez : PROV-SUC-001",
    },
    "af-achat-unite": {
      title: "Unité de gestion",
      body: "L'unité de gestion est celle dans laquelle vous commandez au fournisseur : le sucre se livre par sac de 25 kg, pas au kilo. Elle peut donc différer de l'unité de l'article (kg) utilisée en stock et dans la nomenclature.",
      tip: "Saisissez : sac 25kg",
    },
    "af-achat-coefficient": {
      title: "Coefficient de conversion",
      body: "Le coefficient convertit l'unité de gestion vers l'unité article : ici 1 sac = 25 kg de Sucre. Grâce à lui, commander 10 sacs entrera automatiquement 250 kg en stock, sans calcul manuel de votre part.",
      tip: "Saisissez : 25",
    },
    "af-achat-tva-select": {
      title: "Taux de TVA",
      body: "Choisissez le taux de TVA de cet achat. Les produits alimentaires comme le sucre relèvent généralement du taux réduit (5,5 %), ce qui se répercutera sur le montant TTC de la commande. Vous pouvez aussi choisir « Personnalisé » pour saisir un taux libre.",
      tip: "Astuce : créez vos taux par défaut dans les paramètres pour les retrouver ici en un clic.",
    },
    "af-achat-tva": {
      title: "TVA personnalisée",
      body: "Saisissez le taux de TVA applicable au Sucre cristal. Le sucre alimentaire est soumis au taux réduit de 5,5%.",
      tip: "Saisissez : 5.5",
    },
    "af-achat-prix": {
      title: "Prix d'achat HT",
      body: "Saisissez le prix d'achat hors taxes pour un sac de 25 kg de Sucre cristal. Le prix s'exprime dans l'unité de gestion (le sac), pas au kilo. C'est ce montant qui alimentera le coût de revient de vos biscuits.",
      tip: "Saisissez : 18 (soit 18 €/sac de 25 kg = 0,72 €/kg).",
    },
    "af-achat-save": {
      title: "Enregistrer",
      body: "Cliquez sur Enregistrer. Ce tarif sera désormais proposé automatiquement chaque fois que vous ajouterez du Sucre cristal dans une commande à Moulin de Provence, sans avoir à le ressaisir.",
      tip: "L'article apparaîtra dans la section Articles fournis de l'onglet Commercial.",
    },
    // --- Section 3 : Création de commande ---
    "cmd-create-intro": {
      title: "Créer une commande",
      body: "Maintenant que le tarif du Sucre est paramétré chez Moulin de Provence, passons une vraie commande. Nous allons la créer, y ajouter une ligne et la préparer pour envoi au fournisseur.",
      tip: null,
    },
    "cmd-create-btn": {
      title: "Ajouter une commande",
      body: "Cliquez sur « Ajouter une commande » pour ouvrir le formulaire de création. C'est la première étape concrète de votre réapprovisionnement en sucre.",
      tip: null,
    },
    "cmd-maker-dialog": {
      title: "Nouvelle commande",
      body: "Ce dialog vous demande deux informations essentielles : le fournisseur et l'adresse de livraison. La commande sera créée en mode brouillon, donc librement modifiable avant confirmation.",
      tip: null,
    },
    "cmd-maker-tiers": {
      title: "Sélectionner le fournisseur",
      body: "Cherchez et sélectionnez « Moulin de Provence » dans la liste. C'est chez ce fournisseur que vous avez paramétré le prix du Sucre, donc le tarif sera repris automatiquement sur les lignes.",
      tip: "Tapez « Moulin » pour filtrer la liste.",
    },
    "cmd-maker-adresse": {
      title: "Adresse de livraison",
      body: "Sélectionnez l'adresse de votre entrepôt où la livraison sera réceptionnée. L'adresse par défaut est généralement pré-sélectionnée. C'est elle qui guidera le transporteur du fournisseur.",
      tip: "Cette adresse apparaîtra sur le bon de commande envoyé au fournisseur.",
    },
    "cmd-maker-save": {
      title: "Créer la commande",
      body: "Cliquez sur Enregistrer pour créer la commande. Vous serez redirigé vers la fiche commande où vous ajouterez les lignes (le sucre à commander). La commande naît en état « En rédaction ».",
      tip: "En état « En rédaction », vous pouvez tout modifier librement avant de confirmer.",
    },
    // --- Section 4 : Fiche commande ---
    "cmd-fiche-intro": {
      title: "Fiche commande",
      body: "Vous êtes sur la fiche de la commande. À gauche figurent les lignes commandées ; à droite, le fournisseur, l'adresse de livraison, la date et les actions disponibles. C'est votre espace de travail jusqu'à l'envoi.",
      tip: "L'historique en bas retrace tout le cycle de vie de la commande.",
    },
    "cmd-etat": {
      title: "État de la commande",
      body: "Le badge d'état indique « En rédaction ». Tant que la commande est dans cet état, vous pouvez librement ajouter, modifier ou supprimer des lignes. Une fois prête, vous la confirmerez pour la figer et l'envoyer au fournisseur.",
      tip: null,
    },
    "cmd-add-ligne": {
      title: "Ajouter une ligne",
      body: "Cliquez sur « + Ajouter une ligne de commande » pour ouvrir le formulaire de saisie. Chaque ligne correspond à un article commandé — ici, le Sucre cristal dont vous avez besoin pour vos prochaines fournées.",
      tip: null,
    },
    "cmd-ligne-dialog": {
      title: "Formulaire de ligne",
      body: "Ce formulaire permet de saisir une ligne de commande. Sélectionnez l'article, entrez la quantité et le prix se remplit automatiquement depuis le tarif que vous avez paramétré. Vous évitez ainsi toute erreur de saisie de prix.",
      tip: null,
    },
    "cmd-ligne-article": {
      title: "Sélectionner l'article",
      body: "Cherchez et sélectionnez « Sucre cristal » dans la liste. Le tarif d'achat (18 €/sac de 25 kg) que vous avez paramétré chez Moulin de Provence sera appliqué automatiquement à la ligne.",
      tip: "Tapez « Sucre » pour filtrer la liste, puis cliquez sur « Sucre cristal ».",
    },
    "cmd-ligne-quantite": {
      title: "Quantité à commander",
      body: "Saisissez la quantité souhaitée en unité d'achat (sac de 25 kg). Le montant total se calcule automatiquement à partir du prix unitaire. Estimez vos besoins en fonction des fournées de biscuits prévues.",
      tip: "Saisissez par exemple : 10 (soit 10 sacs = 250 kg de Sucre cristal, montant : 180 € HT).",
    },
    "cmd-ligne-prix": {
      title: "Prix unitaire",
      body: "Le prix est rempli automatiquement depuis le tarif négocié : 18 €/sac HT. Si une promotion ponctuelle du fournisseur s'applique, activez le toggle « Prix manuel » pour saisir un autre montant sans modifier le tarif de référence.",
      tip: "Les remises éventuelles du fournisseur sont aussi appliquées automatiquement.",
    },
    "cmd-ligne-save": {
      title: "Enregistrer la ligne",
      body: "Cliquez sur Enregistrer pour ajouter la ligne à la commande. Elle apparaîtra dans le tableau avec son montant calculé, et les totaux de la commande se mettront à jour aussitôt.",
      tip: null,
    },
    "cmd-totaux": {
      title: "Totaux de la commande",
      body: "La section totaux affiche le montant total HT, le détail de la TVA par taux et le montant TTC. Ces montants sont recalculés automatiquement à chaque ajout ou modification de ligne, ce qui vous donne le coût réel de l'approvisionnement avant envoi.",
      tip: null,
    },
    "cmd-pdf": {
      title: "Bon de commande PDF",
      body: "Ce bouton génère un PDF du bon de commande prêt à envoyer au fournisseur. Il reprend toutes les lignes, les prix, les conditions et votre adresse de livraison. C'est le document officiel qui engage la commande.",
      tip: "Conservez le PDF : il sert de référence à comparer au bon de livraison à la réception.",
    },
    "cmd-send-fournisseur": {
      title: "Envoyer au fournisseur",
      body: "Ce bouton ouvre un formulaire d'envoi par email avec le bon de commande en PDF joint. Moulin de Provence reçoit la commande directement dans sa boîte mail, ce qui accélère le traitement et garde une trace de l'échange.",
      tip: "L'envoi par email est optionnel : vous pouvez aussi transmettre le PDF manuellement.",
    },
    "cmd-confirm": {
      title: "Confirmer la commande",
      body: "Ce bouton confirme la commande et la passe en « Attente de livraison ». C'est l'étape obligatoire pour valider la commande, que vous l'ayez envoyée par mail ou non. Une fois confirmée, elle est figée et attend la livraison du fournisseur.",
      tip: "Le cycle se poursuit : le fournisseur livre → vous réceptionnez via un déchargement.",
    },
    "cmd-outro": {
      title: "La commande est prête à être envoyée",
      body: "La commande fournisseur est créée, chiffrée et prête à partir chez Moulin de Provence. À la livraison, vous créerez un déchargement pour réceptionner les sacs de sucre et les mettre en stock avec leur lot.",
      tip: "Le cycle complet : commande → livraison → réception → contrôle → mise en stock.",
    },

    // ===== RÉCEPTION FOURNISSEUR =====
    "recep-intro": {
      title: "La réception, porte d'entrée du stock",
      body: "La réception permet de contrôler et d'enregistrer les livraisons fournisseur : c'est l'étape qui transforme une commande en lots réels disponibles en stock. Pour la Boulangerie du Moulin, c'est ici que la farine, le sucre et le beurre commandés deviennent des matières utilisables pour fabriquer les Biscuits sablés du Moulin. Sans réception, aucune matière n'est disponible pour la production.",
      tip: "Chaque livraison suit le même fil : déchargement, contrôle des quantités, création des lots, puis mise en stock.",
    },
    "recep-overview": {
      title: "Workflow de réception",
      body: "Le processus se décompose en deux phases : le déchargement (déclaration de l'arrivée de la livraison et du bon de livraison) puis la réception proprement dite (contrôle des quantités et création des lots). Cette séparation vous permet d'enregistrer d'abord ce qui arrive au quai, puis de détailler matière par matière.",
      tip: "Vous pouvez réceptionner partiellement une commande : si le fournisseur ne livre que la moitié du sucre, vous réceptionnez ce qui est arrivé et complétez plus tard.",
    },
    "recep-click-commande": {
      title: "Ouvrir la commande",
      body: "Cliquez sur la commande que vous venez de créer au module précédent pour l'ouvrir. C'est sur cette commande fournisseur (par exemple votre commande de farine, sucre et beurre) que nous allons déclarer la réception de la livraison.",
      tip: "La réception part toujours d'une commande : c'est elle qui porte les articles attendus et les quantités prévues.",
    },
    "recep-workflow": {
      title: "Cycle de vie",
      body: "Un déchargement passe par trois états : Créé → En réception → Réceptionné. Une fois réceptionné, les lots sont créés et automatiquement mis en stock, prêts à entrer dans la fabrication. Suivre cet état vous indique d'un coup d'œil où en est chaque livraison.",
      tip: "Si une matière arrive abîmée ou non conforme (sac de farine éventré, beurre hors température), vous pouvez déclarer un écart de conformité à la réception.",
    },
    "recep-click-dech": {
      title: "Créer un déchargement",
      body: "Cliquez sur « Créer un déchargement » pour ouvrir le formulaire. Vous allez déclarer l'arrivée physique de la livraison pour cette commande, c'est-à-dire l'instant où le camion du fournisseur se présente au quai de la boulangerie.",
      tip: "Un déchargement = une livraison. Si le fournisseur livre en plusieurs camions, créez un déchargement par arrivée.",
    },
    "recep-dialog-intro": {
      title: "Formulaire de déchargement",
      body: "Le déchargement se fait en deux étapes successives :\n1. Bon de livraison — numéro de BL et documents joints\n2. Produits reçus — quantités réellement livrées par article.\nCe découpage sépare l'administratif (le document) du physique (la marchandise).",
      tip: "Pensez à joindre une photo ou un scan du BL : c'est précieux en cas de litige avec le fournisseur.",
    },
    "recep-fill-bl": {
      title: "Numéro de BL",
      body: "Saisissez le numéro du bon de livraison fourni par le transporteur (par exemple BL-2026-0042). Ce numéro fait le lien entre l'enregistrement dans JustUp et le document papier physique qui accompagne la marchandise, ce qui garantit la traçabilité administrative de la livraison.",
      tip: "Ce numéro figure en haut du document accompagnant les palettes de farine, sucre ou beurre.",
    },
    "recep-save-step1": {
      title: "Passer aux produits reçus",
      body: "Cliquez sur « Enregistrer et continuer » pour valider le bon de livraison et passer à la deuxième étape : la saisie des quantités réellement livrées, article par article.",
      tip: "Séparer le BL des quantités permet d'enregistrer vite l'arrivée du camion, puis de détailler la marchandise à tête reposée.",
    },
    "recep-fill-quantite": {
      title: "Quantités conformes à la commande",
      body: "Cliquez sur ce bouton pour pré-remplir d'un coup les quantités livrées avec les quantités commandées. C'est le cas le plus fréquent : le fournisseur livre exactement ce qui a été commandé. Vous pourrez ensuite ajuster ligne par ligne si une matière manque.",
      tip: "Si la quantité réellement livrée diffère de la commande (par ex. 48 kg de beurre au lieu de 50), corrigez le champ : un écart sera signalé automatiquement.",
    },
    "recep-receive-article1": {
      title: "Réceptionner le premier article",
      body: "Cliquez sur « Réceptionner » pour ouvrir le formulaire de réception de ce premier article (par exemple la farine). Vous allez l'associer à un lot fournisseur existant, déjà connu de la boulangerie.",
      tip: null,
    },
    "recep-lot-existant": {
      title: "Sélectionner un lot existant",
      body: "Le sélecteur « Lot fournisseur » propose les lots déjà enregistrés pour cet article. Sélectionnez le lot existant (ex: FAR-2026-001) dans la liste déroulante ; la quantité est pré-remplie avec la quantité déchargée. Ce lot va tracer cette farine de la réception jusqu'au biscuit fini.",
      tip: "Chaque lot est une unité de traçabilité : en cas de rappel sur un sac de farine, vous retrouvez instantanément quels OF et quels biscuits l'ont consommé.",
    },
    "recep-save-reception1": {
      title: "Enregistrer la réception",
      body: "Cliquez sur « Enregistrer » pour valider la réception de cet article avec le lot sélectionné. La quantité de farine entre alors officiellement en stock, rattachée à son lot fournisseur.",
      tip: null,
    },
    "recep-receive-article2": {
      title: "Réceptionner le deuxième article",
      body: "Cliquez sur « Réceptionner » pour ouvrir le formulaire du deuxième article : le beurre. Le principe est le même que pour la farine — chaque article de la livraison reçoit son lot fournisseur.",
      tip: null,
    },
    "recep-lot-creation": {
      title: "Renseigner le lot du beurre",
      body: "Sélectionnez le lot du beurre (BEU-2026-001) dans le sélecteur « Lot fournisseur ». Si le lot indiqué sur l'emballage n'existait pas encore dans JustUp, il suffirait de taper son numéro puis de cliquer sur « Créer un lot » pour le créer à la volée.",
      tip: "Reportez toujours exactement le numéro figurant sur l'étiquette ou le bon de livraison du fournisseur : c'est lui qui garantit la traçabilité ascendante en cas de contrôle sanitaire.",
    },
    "recep-save-reception2": {
      title: "Enregistrer la réception",
      body: "Cliquez sur « Enregistrer » pour valider la réception avec le nouveau lot que vous venez de créer. Ce lot est désormais connu de JustUp et réutilisable lors des prochaines livraisons.",
      tip: null,
    },
    "recep-finalize": {
      title: "Finaliser le déchargement",
      body: "Tous les articles de la livraison sont réceptionnés. Cliquez sur « Enregistrer le déchargement » pour terminer : les lots de farine, sucre et beurre sont alors disponibles en stock et leur prix d'achat est figé, prêt à remonter la nomenclature jusqu'au coût du biscuit.",
      tip: null,
    },
    "recep-outro": {
      title: "Les matières sont en stock",
      body: "Déchargement, bon de livraison, lot existant ou nouveau lot : la réception est bouclée. La farine et le beurre sont en stock, tracés par lot et prêts pour la production des Biscuits sablés du Moulin.",
      tip: "Prochaine étape : lancez un ordre de fabrication qui consommera ces lots pour produire vos biscuits finis.",
    },

    // ===== ORDRES DE FABRICATION =====
    "of-intro": {
      title: "L'ordre de fabrication, moteur de la production",
      body: "Un ordre de fabrication (OF) lance la production d'un article en une quantité donnée sur une ligne précise — par exemple fabriquer 500 paquets de Biscuits sablés du Moulin sur la ligne Biscuits. La quantité est un objectif déclaratif qui sert de repère pour la production. Dès le démarrage de la première opération, un lot de produit fini est créé automatiquement et devient traçable.",
      tip: "L'OF regroupe tout le nécessaire pour produire : l'article, la quantité cible, la ligne, la nomenclature (la recette des Biscuits sablés) et le process (les étapes de fabrication).",
    },
    "of-overview": {
      title: "Liste des OF",
      body: "Chaque OF apparaît sous forme de carte : l'article, la quantité, la ligne et l'état se lisent en un coup d'œil. Ici par exemple, les madeleines du matin sont terminées, les cookies sont en cours de production et un OF de biscuits attend encore sa planification. Les filtres en haut permettent de trier par état, ligne ou période, et le champ de recherche retrouve un OF par article, numéro de lot ou numéro d'OF.",
      tip: "Au quotidien, cette liste est votre vue d'ensemble : un coup d'œil suffit pour voir ce qui tourne aujourd'hui sur chaque ligne et ce qui arrive cette semaine.",
    },
    "of-card-display": {
      title: "État de l'OF",
      body: "Cet OF a été pré-créé pour le tutoriel. La chips d'état indique sa progression dans le cycle de vie.\nChaque OF est représenté par une carte avec l'article, la quantité, la ligne et le statut courant.",
      tip: "Les couleurs de statut permettent d'identifier rapidement l'avancement de chaque OF.",
    },
    "of-lifecycle": {
      title: "Cycle de vie d'un OF",
      body: "Un OF traverse plusieurs états : En attente de planification, En attente de production, En production, En attente de réintégration, puis En attente de validation avant d'être Terminé. Chaque changement d'état est tracé avec l'auteur et la date, ce qui donne un historique complet de chaque fabrication. L'étape de validation dépend de votre paramétrage (simple, double ou sans validation).",
      tip: "Un OF peut être annulé tant qu'il n'a pas démarré (pas encore en production) ; une fois lancé, il suit le cycle jusqu'à la clôture.",
    },
    "of-add-btn": {
      title: "Créer un OF",
      body: "Ce bouton ouvre le formulaire de création d'un nouvel ordre de fabrication. C'est le point de départ pour lancer une production, par exemple un nouveau lot de Biscuits sablés du Moulin.",
      tip: "Vous créerez un OF chaque fois que vous voulez produire un article : un OF = un lot de produit fini.",
    },
    "of-click-add": {
      title: "Nouveau OF",
      body: "Cliquez pour ouvrir le formulaire de création. Vous allez y sélectionner l'article à produire, la quantité et la ligne, puis configurer la planification de l'OF.",
      tip: null,
    },
    "of-dialog-intro": {
      title: "Formulaire de création",
      body: "Ce formulaire définit les paramètres essentiels de l'OF : l'article à produire, la quantité, la ligne de production et son paramétrage. C'est à partir de ces informations que JustUp calculera les besoins matière et la durée de fabrication.",
      tip: "Tout part de l'article : son choix charge automatiquement la recette et les étapes, vous n'avez plus qu'à préciser combien et quand.",
    },
    "of-select-article": {
      title: "Article à produire",
      body: "Sélectionnez l'article fini ou semi-fini à produire — ici les Biscuits sablés du Moulin. Sa nomenclature (farine, beurre, sucre…) et son process sont chargés automatiquement, ce qui permet de calculer les besoins en matières premières et le coût matière prévisionnel.",
      tip: "Seuls les articles ayant une nomenclature et un process peuvent être produits : c'est ce qui rend la recette et les étapes exécutables en atelier.",
    },
    "of-fill-quantite": {
      title: "Quantité à produire",
      body: "Saisissez la quantité objectif, par exemple 500 paquets de Biscuits sablés. Cette quantité sert à planifier l'OF, estimer sa durée et calculer les besoins matière depuis la nomenclature. Les statistiques de fin d'OF, elles, utiliseront les quantités réellement produites et déclarées en atelier.",
      tip: "La quantité peut être ajustée à tout moment tant que l'OF n'est pas terminé : utile si vous décidez d'allonger ou de réduire la série.",
    },
    "of-select-ligne": {
      title: "Ligne de production",
      body: "Ici la ligne a été sélectionnée automatiquement (la Ligne Biscuits) car c'était la seule compatible avec la famille technique de l'article. C'est la ligne qui détermine la cadence et donc la durée de fabrication. S'il existait plusieurs lignes compatibles, vous choisiriez celle où produire.",
      tip: "La liste ne propose que les lignes dont un paramétrage correspond à la famille technique de l'article (ici « Biscuits ») : pas de risque de planifier sur un four à pain par erreur.",
    },
    "of-select-param": {
      title: "Paramétrage de ligne",
      body: "Le paramétrage définit la cadence (paquets/heure), le nombre d'opérateurs, le temps de calage et de nettoyage. C'est lui qui pilote le calcul de la durée de l'OF. Ici la Ligne Biscuits n'a qu'un seul paramétrage, il est donc auto-sélectionné.",
      tip: "Vous pouvez créer plusieurs paramétrages pour une même famille technique (ex: cadence lente / rapide) afin de modéliser des régimes de production différents.",
    },
    "of-planif-section": {
      title: "Planifier l'OF",
      body: "Cliquez sur « Planifier l'OF » pour ouvrir les options de planification.",
      tip: null,
    },
    "of-planif-modes": {
      title: "Modes de planification",
      body: "Trois modes sont disponibles : Sans planif (l'OF est créé en attente, à placer plus tard sur le Gantt), Automatique (JustUp trouve le prochain créneau libre sur la ligne) et Date fixe (vous choisissez le jour et l'heure de démarrage). Le mode choisi détermine quand la production des Biscuits sablés commencera.",
      tip: "La durée de l'OF est calculée automatiquement à partir de la quantité et de la cadence du paramétrage : 500 paquets à cadence donnée = un créneau de durée connue.",
    },
    "of-planif-date-fixe": {
      title: "Mode Date fixe",
      body: "Cliquez sur « Date fixe » pour choisir précisément quand démarrer la production.\nLe planning de la ligne s'affichera avec les créneaux d'ouverture (basés sur les horaires que vous avez configurés).",
      tip: null,
    },
    "of-planif-preview": {
      title: "Planning de la ligne",
      body: "Voici le planning de la Ligne Biscuits sur les prochains jours : les zones claires sont les créneaux d'ouverture, les zones hachurées les fermetures — nuits et week-ends. Les cases vertes marquées d'un plus sont les créneaux encore libres : c'est là que nous allons positionner la production.",
      tip: "La durée du bloc violet est calculée automatiquement (quantité ÷ cadence) en tenant compte des horaires de la ligne : il s'étale donc sur les seules plages d'ouverture.",
    },
    "of-planif-pick": {
      title: "Choisir un créneau",
      body: "Cliquons sur un créneau libre pour planifier la production. La date de démarrage se cale automatiquement sur le créneau choisi, et le mode passe en Date fixe.",
      tip: "Le mode Automatique peut aussi choisir pour vous le prochain créneau libre de la ligne.",
    },
    "of-planif-ghost": {
      title: "Votre créneau est posé",
      body: "Le bloc violet représente votre production posée sur le planning : environ dix heures, calées sur les horaires d'ouverture de la ligne. Avant d'enregistrer, vous pouvez encore le faire glisser pour ajuster l'heure de démarrage.",
      tip: "La durée du bloc est calculée automatiquement : la quantité à produire divisée par la cadence du paramétrage.",
    },
    "of-open-advanced": {
      title: "Paramètres avancés",
      body: "Cliquez sur « Plus de paramètres » pour découvrir les options avancées de l'OF.",
      tip: null,
    },
    "of-toggle-bilan": {
      title: "Bilan matière intermédiaire",
      body: "Si vous l'activez, les opérateurs devront déclarer les quantités restantes de chaque composant à la fin de chaque opération de fabrication. Cela donne le suivi le plus fin possible des consommations réelles (farine, beurre, sucre…) au cours de la production, et affine le coût matière de l'OF.",
      tip: "Très utile pour les articles à fort coût matière, ou pour les composants invisibles dans les contrôles qualité (pH, Brix…). Exemple : le sorbate — le seul moyen de vérifier qu'il est bien dans le produit, c'est de constater qu'il n'en reste plus dans les composants disponibles.",
    },
    "of-toggle-prep": {
      title: "Préparation des opérations",
      body: "Si vous l'activez, les opérations de fabrication sont pré-créées dès la création de l'OF : vous définissez à l'avance leur nombre et la quantité par opération. Nous ne l'activons pas pour ce premier OF afin de rester simple.",
      tip: "Par défaut, les opérations sont créées au fil de l'eau par l'opérateur pendant la production : pratique quand le découpage des séries n'est pas connu à l'avance.",
    },
    "of-save": {
      title: "Enregistrer l'OF",
      body: "Cliquez sur Enregistrer pour créer l'OF. Il apparaîtra dans la liste, prêt à être planifié sur le Gantt ou lancé en production selon le mode choisi.",
      tip: null,
    },
    "of-created": {
      title: "Votre OF est créé",
      body: "Votre premier ordre de fabrication apparaît en tête de liste, déjà planifié : il est en attente de production, avec ses dates de début et de fin posées sur le créneau choisi. La carte affiche l'article, la quantité et l'état courant, pour un suivi en un coup d'œil.",
      tip: "La couleur de la chips d'état vous dit immédiatement où en est l'OF dans son cycle de vie.",
    },
    "of-cascade": {
      title: "Création automatique d'OFs",
      body: "En production réelle, vous créerez plusieurs OFs pour planifier votre semaine ou votre mois (différents formats de biscuits, plusieurs séries…). Pour la démonstration, nous allons en ajouter quelques-uns automatiquement afin de remplir votre planning et rendre la timeline parlante.",
      tip: null,
    },
    "of-list-full": {
      title: "Vos ordres de fabrication",
      body: "Voilà ! Votre carnet de production se remplit : certains OFs sont en attente de planification, d'autres déjà placés sur la ligne. La timeline en haut vous donne une vue d'ensemble de la charge à venir, atelier par atelier.",
      tip: "Servez-vous des filtres pour isoler rapidement, par exemple, tous les OFs de la Ligne Biscuits de la semaine.",
    },
    "of-edit-btn": {
      title: "Modifier l'OF",
      body: "Cliquez pour passer en mode édition. Vous pouvez modifier la quantité, la ligne ou les paramètres tant que l'OF n'est pas lancé.",
      tip: null,
    },
    "of-spec-link": {
      title: "Lien spécification",
      body: "L'OF est lié à la spécification (nomenclature + process) de l'article. Toute modification de la spec se répercute sur les futurs OF.",
      tip: "Vous pouvez consulter la nomenclature et le process directement depuis l'OF.",
    },
    "of-material-needs": {
      title: "Besoins matière",
      body: "La liste des matières premières nécessaires est calculée automatiquement depuis la nomenclature, en fonction de la quantité à produire.",
      tip: "Vérifiez la disponibilité stock avant de lancer l'OF. Les alertes apparaissent si un composant est insuffisant.",
    },
    "of-states": {
      title: "Suivi des états",
      body: "L'historique des changements d'état est tracé avec l'utilisateur et la date. Cela permet un suivi complet de la vie de l'OF.",
      tip: null,
    },
    "of-outro": {
      title: "Récapitulatif des OF",
      body: "Votre ordre de fabrication est créé et configuré, de l'article à la planification. L'étape suivante est le Gantt, pour positionner précisément vos OF sur les lignes et définir quand produire.",
      tip: "Un OF bien configuré est la base d'une production efficace : article, quantité et ligne correctement définis se répercutent ensuite sur les besoins matière, le planning et les coûts.",
    },

    // ===== PLANIFICATION =====
    "planif-intro": {
      title: "Organiser la semaine de production",
      body: "Le module de planification organise vos OF sur les lignes de production via un diagramme de Gantt interactif. Pour la Boulangerie du Moulin, c'est ici que l'OF des « Biscuits sablés du Moulin » trouve sa place dans la semaine, sur la bonne ligne et au bon créneau. Bien planifier, c'est éviter les temps morts entre deux fournées et tenir la date promise au client.",
      tip: "Planifiez en début de semaine pour lisser la charge de vos lignes et sécuriser vos délais de livraison.",
    },
    "planif-overview": {
      title: "Vue Gantt",
      body: "Le Gantt affiche vos lignes de production en ordonnée et le temps en abscisse. Chaque barre est un OF planifié : pour la boulangerie, vous repérez d'un coup d'œil quand la ligne « Four à sablés » produit les biscuits et quand elle est libre. C'est votre tableau de bord pour visualiser la charge réelle de l'atelier.",
      tip: "Zoomez pour ajuster un créneau à l'heure près, dézoomez pour une vision d'ensemble de la semaine.",
    },
    "planif-ligne-header": {
      title: "En-tête de ligne",
      body: "Chaque ligne de production apparaît avec son nom et sa cadence. Pour la boulangerie, vous retrouvez ici votre ligne « Four à sablés » et sa cadence horaire, qui sert de base à tous les calculs de durée. Le bouton « Planifier » ouvre la liste des OF prêts à être affectés à cette ligne.",
      tip: "La cadence affichée vient des paramètres techniques de la ligne : c'est elle qui dicte la longueur des barres.",
    },
    "planif-gantt-row": {
      title: "Barre de Gantt",
      body: "Chaque barre représente un OF planifié. Sa longueur correspond à la durée estimée de production, calculée depuis la cadence de la ligne : un OF de 5 000 biscuits sur une ligne à 1 000 unités/h occupe environ 5 heures. La barre vous montre donc concrètement combien de temps la ligne sera mobilisée.",
      tip: "La couleur de la barre indique le statut de l'OF : brouillon, planifié, en cours ou terminé.",
    },
    "planif-filters": {
      title: "Filtres de planification",
      body: "Cette barre regroupe les filtres : sélection des lignes, familles techniques, options d'affichage (horaires, fermetures, lignes inactives) et la portée du prévisionnel. Si la boulangerie possède plusieurs ateliers, filtrez par exemple sur la famille « Biscuiterie » pour n'afficher que les lignes concernées par les sablés.",
      tip: "Utilisez les filtres pour vous concentrer sur les lignes ou familles qui vous intéressent et alléger l'affichage.",
    },
    "planif-scale": {
      title: "Échelle de temps",
      body: "Ce sélecteur contrôle l'échelle du Gantt : 1 jour, 2 jours, 7 jours ou 14 jours. À la boulangerie, la vue 2 jours sert à caler précisément les fournées du jour, tandis que la vue 7 jours donne la photo de toute la semaine de production de biscuits.",
      tip: "La vue 2j est idéale pour la planification quotidienne, la vue 7j pour une vision hebdomadaire.",
    },
    "planif-click-7j": {
      title: "Passer en vue semaine",
      body: "Cliquez sur « 7j » pour afficher une semaine complète. Vous verrez d'un seul regard tous les OF planifiés et les créneaux d'ouverture de la ligne « Four à sablés » sur 7 jours, idéal pour vérifier que la charge est bien répartie du lundi au vendredi.",
      tip: null,
    },
    "planif-view-week": {
      title: "Vue hebdomadaire",
      body: "Vous voyez maintenant le planning complet de la semaine. Les barres représentent vos OF de sablés, positionnés dans les créneaux d'ouverture de la ligne (lundi-vendredi, 9h-17h). Les zones vertes sont les heures d'ouverture, les zones hachurées les fermetures où aucune production n'est possible.",
      tip: "Utilisez cette vue pour vérifier la charge de vos lignes et anticiper les pics de production.",
    },
    "planif-click-planify": {
      title: "Planifier un OF",
      body: "Cliquez sur le bouton + de la ligne pour ouvrir la liste des OF en attente de planification. C'est l'étape qui fait passer l'OF des « Biscuits sablés du Moulin » du statut « à planifier » à une place concrète dans votre semaine de production.",
      tip: "Seuls les OF compatibles avec la famille technique de cette ligne apparaîtront dans la liste.",
    },
    "planif-dialog-intro": {
      title: "Sélection des OF",
      body: "Ce dialogue liste les OF en attente de planification pour cette ligne. Sélectionnez celui que vous voulez placer sur le Gantt, par exemple l'OF de production des sablés pour la commande client de la semaine. Vous gardez ainsi la main sur l'ordre de passage en atelier.",
      tip: "Commencez par les OF dont la date de livraison est la plus proche pour sécuriser vos engagements.",
    },
    "planif-of-row": {
      title: "OF disponible",
      body: "Chaque OF affiche l'article, le numéro et la quantité à produire, par exemple 5 000 « Biscuits sablés du Moulin ». Cliquez sur « Planifier » pour l'affecter à la ligne : JustUp calcule alors automatiquement la durée du créneau à partir de cette quantité et de la cadence de la ligne.",
      tip: "La durée du créneau est recalculée automatiquement : pas besoin de saisir une heure de fin à la main.",
    },
    "planif-click-planify-of": {
      title: "Affecter l'OF",
      body: "Cliquez sur « Planifier » pour affecter cet OF à la ligne. Il se positionne au prochain créneau disponible, en respectant les horaires d'ouverture et les OF déjà placés. Votre fournée de sablés a maintenant une place réservée dans le planning.",
      tip: "Si le créneau ne vous convient pas, vous pourrez ensuite déplacer la barre directement sur le Gantt.",
    },
    "planif-cascade": {
      title: "Remplir la semaine",
      body: "En production réelle, vous planifierez plusieurs OF d'affilée pour optimiser votre semaine et enchaîner les fournées sans temps mort. Pour la démonstration, nous allons en ajouter automatiquement afin de vous montrer à quoi ressemble un planning chargé de la boulangerie.",
      tip: "Enchaîner des OF de la même famille limite les changements de réglage et de nettoyage de ligne.",
    },
    "planif-start-btn": {
      title: "Et ensuite ? Le démarrage",
      body: "Le Gantt prépare la file d'attente, mais le lancement effectif se fait dans le Suivi de production : chaque matin, l'équipe d'atelier y retrouve les OF planifiés du jour et démarre la fournée de sablés depuis son poste. C'est l'objet du tutoriel « Production ».",
      tip: "Le démarrage suit l'ordre du Gantt : c'est toujours le prochain OF planifié qui part en production.",
    },
    "planif-drag-intro": {
      title: "Déplacer un OF",
      body: "Glissez-déposez une barre pour repositionner un OF sur la timeline. Le Gantt recalcule automatiquement la file d'attente : si vous avancez la fournée de sablés au lundi matin, les OF suivants se réorganisent en conséquence. Pratique pour répondre à une commande urgente.",
      tip: "Le déplacement respecte les horaires d'ouverture : un OF ne peut pas se caler sur un créneau fermé.",
    },
    "planif-drag-interlignes": {
      title: "Déplacement entre lignes",
      body: "Vous pouvez glisser un OF d'une ligne vers une autre. Le Gantt simule en temps réel la position sur la ligne cible et recalcule la durée selon sa cadence. Si la boulangerie a deux fours à sablés de cadences différentes, basculer l'OF sur le four le plus rapide raccourcit la barre.",
      tip: "La durée peut changer d'une ligne à l'autre : chaque ligne a sa propre cadence, définie dans ses paramètres techniques.",
    },
    "planif-ligne-incompatible": {
      title: "Ligne incompatible",
      body: "Si vous tentez de déplacer un OF sur une ligne dont la famille technique ne correspond pas, le drop est bloqué. Vous ne pourrez pas placer une fournée de sablés sur une ligne dédiée à une autre famille (ex: viennoiserie) : seules les lignes paramétrées pour la bonne famille d'articles acceptent l'OF.",
      tip: "Ce contrôle s'appuie sur le paramétrage de ligne du tutoriel précédent : chaque ligne déclare les familles techniques qu'elle peut produire.",
    },
    "planif-duration": {
      title: "Durée de production",
      body: "La durée d'un OF est calculée depuis la quantité à produire et la cadence de la ligne, puis affichée directement sur la barre du Gantt. Produire 10 000 sablés au lieu de 5 000 double la longueur de la barre : vous visualisez immédiatement l'impact d'une commande plus grosse sur l'occupation du four.",
      tip: "Modifier la cadence dans les paramètres de ligne impacte les durées de tous les OF de cette ligne.",
    },
    "planif-conflicts": {
      title: "Gestion des conflits",
      body: "Si deux OF se chevauchent sur une même ligne, un conflit est signalé. Déplacez l'un des OF pour résoudre le problème.",
      tip: "Les conflits apparaissent en rouge sur le Gantt pour une identification rapide.",
    },
    "planif-horaires-fixes": {
      title: "Horaires d'ouverture",
      body: "Les lignes ont des horaires d'ouverture fixes (ex: 6h-14h pour l'équipe du matin). La planification ne positionne les OF que sur ces créneaux : une fournée de sablés ne pourra jamais démarrer en pleine nuit si la ligne est fermée. C'est le garde-fou qui rend le planning réaliste.",
      tip: "Modifiez les horaires d'ouverture dans la configuration de chaque ligne de production pour coller à vos équipes.",
    },
    "planif-outro": {
      title: "Planification terminée",
      body: "Vous savez planifier vos OF sur les lignes de production, déplacer les fournées et lire la charge de votre semaine. La prochaine étape est le lancement et le suivi de la production : transformer ce planning en biscuits réellement fabriqués.",
      tip: "Une bonne planification optimise vos ressources et réduit les temps d'attente entre productions.",
    },

    // ===== PRODUCTION =====
    "prod-intro": {
      title: "L'atelier, en temps réel",
      body: "Le module de production permet de réaliser vos OF en temps réel : créer les opérations de fabrication, exécuter les étapes du process, saisir les contrôles qualité et déclarer les consommations matière. À la Boulangerie du Moulin, c'est ici que la fabrication des Biscuits sablés du Moulin prend vie, du mélange de la farine jusqu'au sachet fini. Tout ce qui se passe ici alimente la traçabilité et le calcul du coût de revient.",
      tip: "C'est l'écran de travail quotidien de l'opérateur. Chaque OF y est suivi de bout en bout, sans ressaisie.",
    },
    "prod-select-of": {
      title: "Sélectionner un OF",
      body: "Cliquez sur l'OF que vous souhaitez lancer en production. Sa carte affiche l'article à fabriquer (Biscuits sablés du Moulin), la quantité cible (par ex. 250 biscuits) et l'état actuel. C'est votre point de départ : tout le déroulé de la fabrication s'appuie sur cet OF.",
      tip: "La couleur de l'état vous indique d'un coup d'œil les OF prêts à lancer.",
    },
    "prod-of-overview": {
      title: "Vue d'ensemble de l'OF",
      body: "Vous êtes sur la fiche de production de l'OF. C'est votre tableau de bord pour fabriquer les Biscuits sablés du Moulin. Vous allez y enchaîner quatre temps :\n\n1. Préparer le pied de chaîne (matières premières)\n2. Créer une opération de fabrication\n3. Exécuter les étapes du process\n4. Réaliser les contrôles qualité",
      tip: "Un OF peut contenir plusieurs opérations de fabrication successives, par exemple pour fractionner une grosse quantité en plusieurs fournées.",
    },
    "prod-pdc-intro": {
      title: "Préparer le pied de chaîne",
      body: "Ce bouton ouvre la page du pied de chaîne (PDC), première étape obligatoire avant de fabriquer. L'opérateur y approvisionne son poste en matières premières depuis le stock : farine, sucre, beurre, œufs. Sans PDC renseigné, la production ne pourra pas démarrer et les consommations ne seront pas tracées.",
      tip: "Le PDC liste tous les articles de la nomenclature avec la quantité nécessaire, calculée automatiquement à partir de la recette et de la quantité de l'OF.",
    },
    "prod-pdc-what": {
      title: "Qu'est-ce que le PDC ?",
      body: "Le pied de chaîne est l'inventaire des matières disponibles en bord de ligne. Quand vous « mettez en PDC » un lot, vous transférez du stock magasin vers le poste de travail. La quantité ainsi placée sera ensuite consommée pendant la production des biscuits.",
      tip: "C'est un mouvement de stock tracé : on sait précisément combien de chaque lot (ex. lot de farine FAR-2026-001) a été sorti du magasin.",
    },
    "prod-pdc-click-farine": {
      title: "Ouvrir la mise en PDC",
      body: "Cliquez sur le petit stylo à droite de la ligne Farine de blé T65 pour ouvrir le formulaire de mise en pied de chaîne. Les badges « PDC » et « Traça » signalent que cet article doit être approvisionné en bord de ligne et suivi en traçabilité, condition pour relier le lot de farine au biscuit fini.",
      tip: "La consommation théorique (0.4 kg pour 250 biscuits) est calculée automatiquement depuis la nomenclature.",
    },
    "prod-pdc-select-lot": {
      title: "1. Sélectionner le lot",
      body: "Dans le sélecteur de lot, choisissez le lot FAR-2026-001. C'est le lot de farine disponible en stock (500 kg, DDM 16/05/2027). Tapez « FAR » dans le champ de recherche pour le retrouver rapidement. C'est ce lot précis qui sera consommé et tracé jusqu'au biscuit.",
      tip: "Le système propose les lots en FIFO. La DDM (Date de Durabilité Minimale) est affichée pour éviter d'engager un lot périmé.",
    },
    "prod-pdc-quantite": {
      title: "2. Saisir la quantité",
      body: "Indiquez la quantité de farine à sortir du magasin pour la mettre au pied de chaîne, par exemple 100 kg pour cette production de 250 biscuits. Le stock disponible du lot est affiché à côté du champ pour vous éviter de demander plus que ce qu'il reste.",
      tip: "La quantité doit être inférieure ou égale au stock disponible du lot sélectionné.",
    },
    "prod-pdc-add": {
      title: "3. Ajouter le mouvement",
      body: "Cliquez sur le bouton « + » pour ajouter ce mouvement à la liste. Vous pouvez en empiler plusieurs si un seul lot ne suffit pas, par exemple compléter les 100 kg de FAR-2026-001 avec un second lot de farine.",
      tip: "Le mouvement n'est pas encore enregistré : il reste en attente tant que vous n'avez pas validé l'ensemble.",
    },
    "prod-pdc-save": {
      title: "4. Enregistrer",
      body: "Cliquez sur « Enregistrer » pour valider tous les mouvements. Le stock est alors transféré du magasin vers le pied de chaîne et la colonne « Mis en pied de chaîne » se met à jour dans le tableau. La farine est désormais réservée à cette production.",
      tip: "Répétez l'opération pour chaque matière première portant le badge PDC (sucre, beurre, œufs).",
    },
    "prod-back-to-of": {
      title: "Retour à l'OF",
      body: "Le pied de chaîne est préparé : vos matières premières sont en bord de ligne. Cliquez sur l'OF pour revenir à sa fiche de production et créer l'opération de fabrication qui va lancer concrètement la fournée.",
      tip: "Tant que vous n'avez pas créé l'opération, aucune étape de process ne peut démarrer.",
    },
    "prod-create-ope": {
      title: "Créer une opération",
      body: "Cliquez sur « Créer la première opé. de fab. » pour créer l'opération. Elle regroupe pour un cycle de production les étapes du process, les contrôles qualité et la traçabilité du lot fabriqué. C'est l'unité de fabrication concrète des Biscuits sablés du Moulin.",
      tip: "Vous pouvez créer plusieurs opérations successives sur un même OF, une par fournée par exemple.",
    },
    "prod-ope-overview": {
      title: "L'opération de fabrication",
      body: "L'opération est créée en état « En attente ». Le stepper affiche les étapes du process à réaliser dans l'ordre, du mélange sec au conditionnement. Avant de démarrer, vous devez désigner le lot héritier, c'est-à-dire le lot de biscuits qui sera produit.",
      tip: "Rien n'est consommé tant que l'opération n'est pas démarrée : vous pouvez encore ajuster le PDC si besoin.",
    },
    "prod-lot-pf-choix": {
      title: "Numéro de lot du produit fini",
      body: "Au démarrage, JustUp attribue un numéro de lot au produit fini. Si aucun lot n'est hérité d'un composant et qu'il existe déjà des lots de ce produit, une fenêtre vous propose deux options : créer un nouveau lot (numéro automatique) ou reproduire un lot existant (même numéro) pour poursuivre une même série de fabrication.",
      tip: "« Reproduire » réutilise le numéro d'un lot déjà produit — pratique pour regrouper plusieurs OF sous un même lot de fabrication.",
    },
    "prod-lot-heritier": {
      title: "Choisir le lot héritier",
      body: "Sélectionnez le lot de produit fini qui sera fabriqué. C'est le « lot héritier » : il héritera de la traçabilité de toutes les matières premières consommées (le lot de farine FAR-2026-001, le sucre, le beurre…). Vous pouvez choisir un lot existant ou en créer un nouveau.",
      tip: "Le numéro de lot sera attribué au produit fini (Biscuits sablés du Moulin) et figurera sur l'étiquette client.",
    },
    "prod-lot-heritier-confirm": {
      title: "Confirmer le lot",
      body: "Cliquez sur « Confirmer » pour valider votre choix de lot héritier. Le lien de traçabilité est alors scellé entre ce lot de biscuits et les matières premières, et les étapes du process deviennent accessibles.",
      tip: "Une fois confirmé, le lot héritier identifie cette fournée dans toute l'application, jusqu'à la livraison.",
    },
    "prod-aside-lot": {
      title: "Fiche produit",
      body: "Le panneau de droite affiche les informations du lot héritier : numéro de lot, DLC/DDM, quantité prévue (250 biscuits) et avancement de la production. Ces informations restent visibles tout au long de l'opération pour garder l'opérateur centré sur ce qu'il fabrique.",
      tip: "Le numéro de lot affiché ici est celui qui sera tracé jusqu'au client final.",
    },
    "prod-start-ope": {
      title: "Démarrer l'opération",
      body: "Cliquez sur « Démarrer l'opé » pour lancer la production. L'opération passe en état « En cours », le minuteur se déclenche et les étapes du process deviennent accessibles une par une. C'est le top départ réel de la fournée.",
      tip: "Le démarrage vérifie que toutes les matières avec PDC ont bien du stock disponible au pied de chaîne : si la farine manque, il vous le signale.",
    },
    "prod-stepper-overview": {
      title: "Le stepper de production",
      body: "Le stepper affiche toutes les étapes du process dans l'ordre :\n\n1. Mélange sec → 2. Incorporation beurre → 3. Ajout œufs et lait → 4. Repos de la pâte → 5. Façonnage → 6. Cuisson → 7. Refroidissement → 8. Conditionnement\n\nChaque étape peut avoir des contrôles qualité associés.",
      tip: "Les étapes se valident une par une. Certaines ont un timer intégré.",
    },
    "prod-step-melange": {
      title: "Mélange sec",
      body: "Voici l'étape active du process. Vous y voyez le nom et la description de l'étape, le minuteur (5 min) et les contrôles à réaliser (Aspect du mélange, Homogénéité pâte). Pour chaque contrôle, cliquez sur « Saisir le contrôle » afin de l'ouvrir et le renseigner avant de valider l'étape.",
      tip: "Le bouton « Valider » en bas ne devient actif qu'une fois tous les contrôles de l'étape réalisés.",
    },
    "prod-step-cuisson": {
      title: "Cuisson",
      body: "L'étape de cuisson (175°C, 20 minutes) est un point critique pour la sécurité alimentaire des biscuits. Des contrôles récurrents de température (CCP) y sont configurés toutes les 15 min : ils garantissent que le four reste dans la bonne plage pendant toute la fournée.",
      tip: "Les CCP sont des points de contrôle obligatoires. Un contrôle hors tolérance déclenche une alerte et une consigne corrective.",
    },
    "prod-start-controles": {
      title: "Démarrer les contrôles",
      body: "Cliquez sur « Démarrer les contrôles récurrents » pour lancer le suivi de température de la cuisson. Une grille temporelle apparaît avec les créneaux de contrôle à respecter, espacés selon la fréquence configurée (toutes les 15 min).",
      tip: "Le chronomètre se lance : chaque contrôle doit être réalisé dans sa fenêtre de tolérance, sous peine d'être signalé en retard.",
    },
    "prod-ctrl-recurrents": {
      title: "Grille de contrôles récurrents",
      body: "La grille affiche les créneaux de contrôle dans le temps. La cellule violette qui clignote est le contrôle à réaliser maintenant ; les pointillés autour indiquent la fenêtre de tolérance pendant laquelle vous pouvez le saisir. C'est la vue de pilotage de la cuisson.",
      tip: "En production réelle, l'opérateur saisit la température du four à chaque créneau. Un retard est signalé visuellement pour ne rien oublier.",
    },
    "prod-ctrl-doable": {
      title: "Saisir la température",
      body: "Cliquez sur la cellule violette pour ouvrir le formulaire de saisie de température. C'est le créneau actif : son relevé est attendu maintenant pour garantir que le four est bien à la bonne température.",
      tip: "Une fois saisie, la cellule passera au vert si la valeur est conforme, au rouge sinon.",
    },
    "prod-ctrl-temp-input": {
      title: "Saisir 175",
      body: "Saisissez la valeur 175 dans le champ de température. Le nominal de cuisson est 175°C, avec des limites de tolérance entre 170 et 180°C : une valeur dans cette plage prouve que la fournée a cuit dans les bonnes conditions.",
      tip: "La valeur doit être comprise entre les limites basse et haute pour être conforme.",
    },
    "prod-ctrl-temp-save": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour valider la mesure de température. Le relevé est horodaté et rattaché au lot de biscuits en cours : il fait foi en cas de contrôle sanitaire ou d'audit qualité.",
      tip: "Un résultat hors tolérance déclenche une alerte CCP et affiche la consigne corrective à appliquer immédiatement.",
    },
    "prod-ctrl-autofill": {
      title: "Contrôles suivants",
      body: "Pour la suite du tutoriel, des saisies de température supplémentaires seront ajoutées automatiquement dans la matrice afin de simuler le suivi complet de la cuisson. En conditions réelles, c'est l'opérateur qui relève chaque créneau.",
      tip: null,
    },
    "prod-ctrl-graph": {
      title: "Graphique d'évolution",
      body: "Cliquez sur le bouton graphique (📈) à côté du nom du contrôle de température pour visualiser l'évolution des mesures de la cuisson. Le graphique transforme la liste de relevés en une courbe lisible d'un coup d'œil.",
      tip: "Ce bouton est disponible pour tous les contrôles quantitatifs, pas seulement la température.",
    },
    "prod-ctrl-graph-view": {
      title: "Visualisation graphique",
      body: "Le graphique affiche tous les enregistrements de température dans le temps, avec la moyenne mobile, les limites haute et basse (170-180°C) et le nominal (175°C). C'est un outil puissant pour repérer une dérive du four avant qu'elle ne fasse rater la fournée.",
      tip: "Cette vue est disponible pour tout contrôle quantitatif dans l'application : pesées, dosages, pH, etc.",
    },
    "prod-ctrl-intro": {
      title: "Saisir le contrôle",
      body: "Cliquez sur « Saisir le contrôle » pour ouvrir le formulaire de saisie du premier contrôle de l'étape (Aspect du mélange). C'est ici que l'opérateur consigne ce qu'il observe sur la ligne, ce qui constitue la preuve qualité de la fournée.",
      tip: "Réalisez tous les contrôles de l'étape avant de cliquer « Valider » pour passer à la suivante.",
    },
    "prod-ctrl-conforme": {
      title: "Cocher Conforme",
      body: "Cliquez sur le bouton vert (✓) pour indiquer que le contrôle Aspect du mélange est conforme. La réponse est consignée et horodatée, et rattachée à l'opérateur qui l'a saisie.",
      tip: "En production réelle, un résultat Non Conforme déclenche une consigne corrective avant de pouvoir continuer.",
    },
    "prod-ctrl-save": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour valider la saisie du contrôle Aspect du mélange. Le contrôle est alors marqué comme réalisé sur l'étape, et la liste se met à jour.",
      tip: "Tant que vous n'enregistrez pas, la saisie reste en brouillon et n'est pas comptée.",
    },
    "prod-ctrl-homogeneite": {
      title: "Deuxième contrôle",
      body: "Cliquez sur « Saisir le contrôle » pour le contrôle Homogénéité pâte. C'est le second contrôle de l'étape Mélange sec : il vérifie que la pâte est uniforme avant de passer à la suite.",
      tip: "Une fois ce contrôle réalisé, l'étape aura tous ses contrôles complets et pourra être validée.",
    },
    "prod-ctrl-conforme-2": {
      title: "Cocher Conforme",
      body: "Même principe que pour le contrôle précédent : cliquez sur (✓) Conforme pour valider l'Homogénéité pâte. La pâte est jugée uniforme et prête pour l'étape suivante.",
      tip: "Chaque réponse conforme est tracée : en cas de réclamation client, vous pourrez prouver que le contrôle a été fait.",
    },
    "prod-ctrl-save-2": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer ». Les deux contrôles de l'étape Mélange sec (Aspect du mélange et Homogénéité pâte) seront alors conformes et complets.",
      tip: "Quand tous les contrôles d'une étape sont conformes, le bouton « Valider » en bas de l'étape devient accessible.",
    },
    "prod-validate-step": {
      title: "Valider l'étape",
      body: "Tous les contrôles sont conformes. Le bouton vert « Valider » en bas de l'étape permet de terminer l'étape de process. Cliquez dessus pour clôturer le Mélange sec et passer à la suite de la fabrication.",
      tip: "Le stepper marque alors l'étape en vert (✓) et avance automatiquement à l'étape suivante.",
    },
    "prod-auto-advance": {
      title: "Avancement des étapes",
      body: "En production réelle, chaque étape du process (Incorporation beurre, Ajout œufs et lait, Repos, Façonnage…) est exécutée par l'opérateur avec ses propres contrôles qualité. Pour le tutoriel, nous passons directement à l'étape Cuisson afin de découvrir les contrôles récurrents (CCP).",
      tip: "Le stepper montre la progression : les étapes validées passent au vert, l'étape en cours est en bleu.",
    },
    "prod-ctrl-first": {
      title: "Premier contrôle température",
      body: "Saisissez la température mesurée du four. Le système vérifie qu'elle est dans la plage 170-180°C et indique si le résultat est conforme.",
      tip: "En cas de non-conformité, une consigne corrective s'affiche pour guider l'opérateur.",
    },
    "prod-step-conditionnement": {
      title: "Conditionnement",
      body: "Dernière étape : le conditionnement en sachets de 250g. Des contrôles libératoires sont réalisés : poids des sachets et conformité de l'étiquetage.",
      tip: "Les contrôles libératoires valident que le produit fini est conforme avant mise en stock.",
    },
    "prod-ctrl-poids": {
      title: "Contrôle poids sachet",
      body: "Contrôle statistique sur 3 échantillons : pesez 3 sachets et saisissez les poids. Le système vérifie que la moyenne est dans la tolérance (245-255g).",
      tip: "Le contrôle statistique 3 échantillons est plus fiable qu'une seule mesure.",
    },
    "prod-ctrl-check-cell": {
      title: "Consulter un contrôle",
      body: "Cliquez sur une cellule verte pour consulter la saisie correspondante. Chaque mesure est horodatée et liée à l'opérateur qui l'a réalisée : vous reconstituez ainsi l'historique complet de la cuisson, créneau par créneau.",
      tip: "Les cellules grises sont les créneaux futurs, encore en attente de saisie.",
    },
    "prod-ctrl-close-dialog": {
      title: "Fermer",
      body: "Vous voyez le détail de la mesure enregistrée (valeur, date, opérateur). Fermez le popup pour revenir à la grille et continuer le suivi de la cuisson.",
      tip: null,
    },
    "prod-launch-create-ope": {
      title: "Créer la première opération",
      body: "Cliquez sur « Créer 1ʳᵉ opé. de fab. ». Le nom « Opé. 1 » est déjà pré-rempli. L'opération regroupe, pour un cycle de production, les étapes du procédé, les contrôles qualité et la traçabilité du lot fabriqué.",
      tip: "Une opération = un cycle. Vous pourrez en créer d'autres plus tard sur le même OF.",
    },
    "prod-launch-start-ope": {
      title: "Démarrer la production",
      body: "Cliquez sur « Démarrer l'opé. » : l'OF passe en production (état « En production »), l'opération devient active et son chronomètre démarre. C'est le vrai top départ de la fabrication.",
      tip: "S'il existe déjà un lot de produit fini, on vous proposera d'en créer un nouveau ou d'en reproduire un — par défaut, un nouveau numéro de lot est attribué.",
    },
    "prod-finish-steps": {
      title: "Fin des étapes",
      body: "Les étapes Refroidissement et Conditionnement de vos Biscuits sablés du Moulin sont maintenant terminées automatiquement. Cela vous permet de vous concentrer sur l'essentiel : la traçabilité des matières et la clôture de l'opération. Ces données alimenteront ensuite le bilan matière et le coût réel du lot fabriqué.",
      tip: "En production réelle, chaque étape porte ses propres contrôles (poids des sachets, conformité de l'étiquetage, température de cuisson).",
    },
    "prod-traca-intro": {
      title: "Traçabilité et consommations",
      body: "Ce bouton ouvre le récapitulatif de traçabilité de votre lot de biscuits. Il liste toutes les matières premières de la nomenclature (farine, beurre, sucre, œufs, lait) avec leur statut. Les articles portant le badge « Traça » doivent avoir un lot déclaré : c'est cette saisie qui permettra, en cas de rappel, de remonter du biscuit jusqu'au sac de farine fournisseur.",
      tip: "La traçabilité est obligatoire pour la sécurité alimentaire. En cas de non-conformité, vous retrouvez instantanément tous les lots clients et fournisseurs concernés.",
    },
    "prod-traca-open": {
      title: "Ouvrir la traçabilité",
      body: "Cliquez sur le bouton pour ouvrir le dialog de saisie de traçabilité et de consommation. C'est ici que vous associez chaque matière première consommée à son lot précis.",
      tip: "Vous pouvez rouvrir cette saisie à tout moment tant que l'opération n'est pas terminée.",
    },
    "prod-traca-lots": {
      title: "Saisie de traçabilité",
      body: "Voici la liste des matières premières du biscuit, chacune avec son mode de suivi :\n\n- Traça : traçabilité obligatoire, vous déclarez le lot utilisé\n- PDC : l'article passe par le pied de chaîne (sortie préalable du stock magasin)\n- Auto : la consommation est calculée automatiquement selon la quantité produite, sur le lot unique\n- Consos : suivi des quantités réellement consommées\n\nLa Farine et le Lait ont le badge « Traça » : cliquez « Sélectionner » sur la ligne Farine pour déclarer son lot.",
      tip: "Les articles « Traça » nécessitent une saisie manuelle du lot. Les articles « Auto » sont déduits automatiquement, sans intervention.",
    },
    "prod-traca-select-farine": {
      title: "Sélectionner la Farine",
      body: "Cliquez sur « Sélectionner » sur la ligne Farine de blé T65 pour déclarer le lot consommé. C'est la matière première principale du sablé : son lot et son prix d'achat remonteront jusqu'au coût du biscuit.",
      tip: "La farine étant un article PDC, son lot a déjà été sorti du stock magasin lors de la préparation du pied de chaîne.",
    },
    "prod-traca-add-farine": {
      title: "Ajouter un changement de lot",
      body: "Cliquez sur « + Ajouter » pour créer une nouvelle déclaration de traçabilité pour la farine. Vous pouvez ajouter plusieurs lignes si plusieurs lots de farine ont été utilisés sur la même fournée.",
      tip: "Un changement de lot en cours de fabrication ? Ajoutez simplement une seconde ligne avec le nouveau lot.",
    },
    "prod-traca-form-farine": {
      title: "Sélectionner le lot",
      body: "Sélectionnez le lot FAR-2026-001 dans le sélecteur de lot. Pour un article PDC comme la farine, seuls les lots présents au pied de chaîne sont proposés : c'est ce qui garantit que vous tracez bien le sac de farine réellement descendu en atelier.",
      tip: "Si un lot attendu n'apparaît pas, vérifiez qu'il a bien été mis en pied de chaîne lors de la préparation.",
    },
    "prod-traca-form-farine-qty": {
      title: "Quantité consommée",
      body: "Pour un article PDC, la quantité consommée est optionnelle : elle sera calculée automatiquement lors de la réintégration du pied de chaîne, à la clôture de l'OF.\n\nSi vous saisissez une quantité, deux options apparaissent :\n- Prélever sur le PDC : dans la limite du stock disponible au pied de chaîne\n- Prélever sur le stock général : génère un mouvement de mise en pied de chaîne\n\nPour ce tutoriel, laissez la quantité vide et cliquez « Enregistrer ».",
      tip: "Pour les articles avec le badge « Consos » (comme le Lait), la quantité, elle, est obligatoire.",
    },
    "prod-traca-save-farine": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour valider la déclaration de traçabilité de la farine. Le lien entre le lot FAR-2026-001 et votre lot de biscuits est désormais établi.",
      tip: "Une fois enregistré, le lot apparaît dans le récapitulatif avec son statut à jour.",
    },
    "prod-traca-auto": {
      title: "Traçabilité automatique",
      body: "La traçabilité du Beurre, du Sucre et des Œufs est complétée automatiquement pour le tutoriel (ce sont des articles « Auto », déduits selon la quantité produite).\n\nMaintenant, déclarons le Lait, qui porte le badge « Consos » : pour cet article, la quantité réellement consommée devra être saisie.",
      tip: "Le badge « Consos » oblige l'opérateur à déclarer la quantité consommée pour chaque lot, afin d'affiner le bilan matière.",
    },
    "prod-traca-select-lait": {
      title: "Sélectionner le Lait",
      body: "Cliquez sur « Sélectionner » sur la ligne Lait entier pasteurisé pour ouvrir la déclaration de son lot.",
      tip: "Le lait utilise le stock général : tous ses lots disponibles vous seront proposés, pas seulement ceux du pied de chaîne.",
    },
    "prod-traca-add-lait": {
      title: "Ajouter",
      body: "Cliquez sur « + Ajouter » pour déclarer le lot de lait consommé et saisir sa quantité.",
      tip: null,
    },
    "prod-traca-form-lait-lot": {
      title: "Sélectionner le lot",
      body: "Tapez LAI dans le champ de recherche puis sélectionnez le lot LAI-2026-001. Contrairement à la farine (PDC), le lait utilise le stock général : tous les lots de l'article sont proposés.",
      tip: "La recherche par préfixe (LAI) filtre instantanément la liste : pratique quand vous gérez des dizaines de lots.",
    },
    "prod-traca-form-lait-qty": {
      title: "Quantité consommée",
      body: "Pour un article avec le badge « Consos », la quantité consommée est obligatoire. Saisissez 0.05 litres dans le champ « Quantité consommée » qui apparaît après avoir sélectionné le lot. Cette valeur sera confrontée à la quantité théorique de la nomenclature pour mesurer l'écart.",
      tip: "La quantité sera comparée à la consommation théorique (0.05 L) dans le bilan matière : un écart révèle gaspillage ou erreur de dosage.",
    },
    "prod-traca-save-lait": {
      title: "Enregistrer",
      body: "Cliquez sur « Enregistrer » pour valider la déclaration du lait. Toutes les matières premières « Traça » et « Consos » de votre biscuit sont désormais tracées.",
      tip: null,
    },
    "prod-traca-close": {
      title: "Fermer",
      body: "Fermez le dialog pour continuer vers la fin de l'opération. Vos déclarations de traçabilité sont déjà enregistrées : rien ne sera perdu.",
      tip: null,
    },
    "prod-end-ope-nav-nb": {
      title: "Infos de fin d'opé",
      body: "Cliquez sur cette étape pour déclarer la quantité produite.",
      tip: null,
    },
    "prod-end-ope-quantite": {
      title: "Quantité produite",
      body: "Deux cartes de saisie sont proposées :\n- « Quantité sur ligne » : le produit fini encore présent dans l'atelier (s'ajoute aux intégrations déjà faites)\n- « Produit sur cette opé » : ce que cette opération seule a fabriqué\n\nSaisissez 250 (biscuits) dans l'une des deux. C'est cette quantité réelle qui servira de base au coût unitaire du biscuit.",
      tip: "La quantité produite sera comparée au théorique dans le bilan matière, ce qui met en évidence le rendement réel de la fournée.",
    },
    "prod-end-ope-quantite-valid": {
      title: "Valider la quantité",
      body: "Cliquez sur « Valider » pour confirmer la quantité produite. Elle est alors figée et intégrée au suivi de l'opération.",
      tip: null,
    },
    "prod-end-ope-nav-eval": {
      title: "Évaluation",
      body: "Cliquez sur ce substep pour évaluer l'opération.",
      tip: null,
    },
    "prod-end-ope-score": {
      title: "Noter l'opération",
      body: "Attribuez 4 ou 5 étoiles à l'opération selon son bon déroulement. Si la note est inférieure à 4, un commentaire est obligatoire pour expliquer le problème rencontré (panne, écart de cuisson, matière non conforme).",
      tip: "Les évaluations sont visibles dans le dossier de production et permettent de suivre la qualité dans le temps.",
    },
    "prod-end-ope-score-valid": {
      title: "Valider l'évaluation",
      body: "Cliquez sur « Valider » pour confirmer l'évaluation et passer à la validation finale de l'opération.",
      tip: null,
    },
    "prod-end-ope-confirm": {
      title: "Terminer l'opération",
      body: "Cliquez sur la section « Validation » dans le stepper. Des avertissements peuvent apparaître (étapes non conformes, écart de quantité, etc.) mais ils ne sont pas bloquants. Cliquez sur « Terminer l'opé de fabrication » pour valider définitivement : les données de production, contrôles et traçabilité de votre fournée de biscuits sont alors figés.",
      tip: "L'OF passe ensuite en attente de bilan matière pour la clôture, où sera calculé le coût réel du lot.",
    },
    "prod-outro": {
      title: "Production réalisée",
      body: "Vous avez réalisé un cycle complet de production pour vos Biscuits sablés du Moulin :\n\n✓ Préparation du pied de chaîne\n✓ Création et démarrage de l'opération\n✓ Exécution des étapes de process\n✓ Contrôles qualité (CNC + CCP récurrents)\n✓ Traçabilité des lots\n\nL'étape suivante est la clôture de l'OF : bilan matière, réintégration du pied de chaîne et validation finale.",
      tip: "Chaque lot fabriqué est désormais traçable du sac de farine jusqu'au biscuit emballé.",
    },

    // ===== CLÔTURE OF =====
    "clot-intro": {
      title: "Clôture de production",
      body: "Une fois les Biscuits sablés du Moulin fabriqués, l'OF doit être clôturé. Cette étape comprend le bilan matière (farine, beurre, sucre réellement consommés), la réintégration des pieds de chaîne et la validation finale. Sans clôture, les lots produits restent bloqués et le coût réel du biscuit n'est pas calculé.",
      tip: "La clôture est obligatoire pour libérer les lots produits et comptabiliser les coûts réels qui remonteront jusqu'à la facture client.",
    },
    "clot-select-of": {
      title: "Sélectionner l'OF",
      body: "Cliquez sur l'OF des Biscuits sablés du Moulin dont l'opération de fabrication est terminée pour accéder à la clôture. C'est la porte d'entrée vers le bilan matière et la validation.",
      tip: "Repérez l'OF au statut « Terminé » : c'est celui prêt à être clôturé.",
    },
    "clot-attente-reinte": {
      title: "Attente réintégration PDC",
      body: "Ce bouton orange bascule l'OF dans un état d'attente : la ligne de fabrication est libérée pour la prochaine fournée, et la réintégration des consommations du pied de chaîne (la farine restante en cuve, par exemple) sera faite plus tard par un responsable. C'est utile quand l'équipe doit enchaîner rapidement sur une autre production.",
      tip: "L'OF reste en attente jusqu'à ce qu'un responsable réalise le bilan matière définitif.",
    },
    "clot-end-prod": {
      title: "Terminer la production",
      body: "Cliquez sur « Terminer la production » pour lancer la clôture immédiate : bilan matière, réintégration des pieds de chaîne et validation s'enchaînent. Choisissez cette option quand toutes les consommations sont connues et que vous voulez solder l'OF maintenant.",
      tip: null,
    },
    "clot-bilan-overview": {
      title: "Vue d'ensemble du bilan",
      body: "Le bilan matière compare les consommations théoriques (prévues par la nomenclature du biscuit) avec les consommations réelles (déclarées en production). Si la recette prévoit 100 kg de farine mais que 102 kg ont été utilisés, l'écart apparaît ici et impacte le coût réel du biscuit.",
      tip: "Ce bilan est essentiel pour le suivi des coûts et l'amélioration continue de vos recettes.",
    },
    "clot-theo-vs-reel": {
      title: "Théorique vs Réel",
      body: "Les colonnes « Conso. théorique » et « Conso. réelle » comparent le calcul issu de la nomenclature (recette × quantité de biscuits produits) avec ce que l'opérateur a réellement déclaré (changements de lot, pesées). La chips à droite indique l'écart et permet de saisir ou corriger la consommation.",
      tip: "La farine (PDC) affiche « A saisir » tant que sa consommation réelle n'a pas été déclarée dans ce bilan.",
    },
    "clot-section-theorique": {
      title: "Articles en consommation théorique",
      body: "Cliquez pour ouvrir la section des articles Auto. Ces matières (beurre, sucre, œufs) n'ont pas besoin de déclaration manuelle : leur consommation est calculée automatiquement depuis la nomenclature × quantité produite.",
      tip: "Si vous suspectez un écart, vous pouvez basculer un article de « théorique » à « manuel » pour le déclarer précisément.",
    },
    "clot-section-manuel": {
      title: "Articles en consommation manuelle",
      body: "Ouvrez la section « Articles en consommation manuelle ». Ce sont les matières tracées par lot — comme la farine de blé — pour lesquelles vous devez déclarer la quantité restante en fin de fournée. C'est cette saisie qui établit la consommation réelle.",
      tip: "Les matières sans traçabilité (sucre, sel) sont calculées automatiquement dans la section théorique.",
    },
    "clot-ecarts": {
      title: "Analyse des écarts",
      body: "Les écarts sont affichés en pourcentage et en valeur absolue. Identifiez les matières avec les plus gros écarts pour corriger vos process : un écart de +5 % sur la farine peut signaler un mauvais réglage de la trémie ou une recette à recalibrer.",
      tip: "Les écarts récurrents doivent être remontés pour ajuster les nomenclatures et fiabiliser le coût du biscuit.",
    },
    "clot-conso-open-farine": {
      title: "Ouvrir la saisie des consommations",
      body: "Cliquez sur la chips rouge « Écart important » de la Farine de blé pour ouvrir l'aide à la saisie. Cet écart signale qu'aucune consommation réelle n'a encore été déclarée : la farine est tracée par lot, donc on doit indiquer ce qu'il reste.",
      tip: "Chaque matière tracée doit être saisie individuellement, lot par lot.",
    },
    "clot-conso-stepper": {
      title: "Lots à renseigner",
      body: "Le stepper en haut liste les différents lots de farine mis en pied de chaîne. Renseignez la quantité restante pour chacun : c'est la somme de ces consommations qui constitue le réel comparé au théorique.",
      tip: "S'il y a plusieurs lots de farine, passez de l'un à l'autre avec Précédent/Suivant.",
    },
    "clot-conso-flow": {
      title: "Les trois cartes",
      body: "Trois informations clés se complètent : « Entrée PDC » = la quantité de farine mise en pied de chaîne (fixe, par ex. 100 kg) ; « Quantité restante en fin de prod. » = ce qu'il reste (à saisir) ; « Consommation » = calculée automatiquement (Entrée − Restante).",
      tip: "La consommation ainsi obtenue sera comparée au théorique dans le bilan matière.",
    },
    "clot-conso-field": {
      title: "Saisir la quantité restante",
      body: "Saisissez la quantité de farine restante en fin de production. C'est ce que vous avez physiquement pesé ou mesuré en cuve. Le système en déduit la consommation réelle qui alimentera le coût du biscuit.",
      tip: "Saisissez 2 pour simuler un restant de 2 kg : 98 kg consommés sur 100 kg en PDC, soit ~2 % de pertes.",
    },
    "clot-conso-next": {
      title: "Passer au récap",
      body: "Cliquez sur Suivant pour afficher le récapitulatif, avec l'écart calculé entre la consommation réelle saisie et le théorique de la recette.",
      tip: null,
    },
    "clot-conso-recap": {
      title: "Récap des écarts",
      body: "Le récapitulatif montre l'écart en pourcentage et en valeur absolue pour la farine. Vérifiez les valeurs avant d'enregistrer : un écart inattendu vaut mieux corrigé maintenant que reporté dans le coût du biscuit.",
      tip: "Les écarts récurrents doivent être remontés pour ajuster les nomenclatures.",
    },
    "clot-conso-save": {
      title: "Enregistrer les consommations",
      body: "Enregistrez les consommations saisies. Le bilan matière est mis à jour avec les écarts calculés, et la consommation réelle de farine est figée pour le calcul du coût de revient.",
      tip: null,
    },
    "clot-validate-bilan": {
      title: "Valider le bilan",
      body: "Validez le bilan matière pour passer à l'étape de réintégration. Les écarts de la farine, du beurre et du sucre sont enregistrés et alimentent le coût réel de la fournée de biscuits.",
      tip: "Après validation, le bilan matière n'est plus modifiable : vérifiez les consommations avant de cliquer.",
    },
    // --- Section 2 : Stats & Validation ---
    "stat-intro": {
      title: "Validation de l'OF",
      body: "Ce popup récapitule les performances de l'OF des Biscuits sablés : écarts matière, coûts, productivité et non-conformités. C'est ici que vous validez définitivement la production avant de libérer les lots et de facturer.",
      tip: "Prenez le temps de vérifier les indicateurs avant de valider : c'est votre dernier contrôle.",
    },
    "stat-perf-cards": {
      title: "Indicateurs de performance",
      body: "Trois cartes résument la performance : Matière (écart entre consommation réelle et théorique des ingrédients), Main d'œuvre (coût et productivité des opérateurs), et Total (coût de revient global de la fournée). Ensemble, elles vous disent si la fournée a été rentable.",
      tip: "Le vert indique un écart acceptable, l'orange un dépassement à surveiller.",
    },
    "stat-bilan-table": {
      title: "Tableau bilan matière",
      body: "Ce tableau détaille la consommation de chaque matière première (farine, beurre, sucre, œufs) : théorique vs réelle, coût unitaire, coût théorique et coût réel. Les écarts sont visibles en un coup d'œil, ce qui permet d'expliquer le coût final du biscuit.",
      tip: "Cliquez sur un article pour accéder au détail des mouvements de lot.",
    },
    "stat-productivite-empty": {
      title: "Productivité — aucune donnée",
      body: "La section productivité est vide : aucune heure de main d'œuvre n'a encore été saisie pour cet OF. Sans heures, impossible de calculer le coût de main d'œuvre et donc le coût de revient complet du biscuit.",
      tip: "Ajoutons des heures pour compléter le bilan et obtenir un coût fiable.",
    },
    "stat-add-hours": {
      title: "Ajouter des heures",
      body: "Cliquez sur « Ajouter des heures de Main d'œuvre » pour déclarer le temps passé par les boulangers sur cette fournée. Ce sont ces heures qui transforment la productivité « sans donnée » en coût de main d'œuvre concret.",
      tip: "Les heures permettent de calculer le coût de main d'œuvre et la productivité réelle de l'équipe.",
    },
    // --- Section 3 : Saisie heures ---
    "hours-intro": {
      title: "Saisie des heures",
      body: "Ce dialog permet de déclarer rapidement les heures travaillées par un boulanger sur cet OF. Sélectionnez l'opérateur, la date et la durée. Ces données alimentent le coût de main d'œuvre du biscuit.",
      tip: "En production réelle, chaque opérateur déclare ses heures quotidiennement via son badge ou son poste.",
    },
    "hours-field-operator": {
      title: "Choisir l'opérateur",
      body: "Sélectionnez l'opérateur qui a réalisé le travail — ici Pierre. Chaque heure saisie est rattachée à une personne : c'est ce qui permet d'analyser les coûts de main-d'œuvre par opérateur et par OF.",
      tip: "Une heure sans opérateur apparaîtrait comme « Opérateur inconnu » dans les analyses.",
    },
    "hours-field-duree": {
      title: "Saisir la durée",
      body: "Saisissez la durée travaillée par le boulanger sur cet OF. Pour notre exemple, l'opérateur a passé 6 heures sur la fournée de Biscuits sablés du Moulin. Cette durée × le taux horaire donne le coût de main d'œuvre.",
      tip: "Saisissez 06:00 pour simuler 6 heures de travail.",
    },
    "hours-save": {
      title: "Enregistrer",
      body: "Enregistrez la saisie. Les heures seront associées à l'OF et le bilan de productivité sera recalculé automatiquement, faisant apparaître le coût de main d'œuvre réel du biscuit.",
      tip: null,
    },
    "hours-productivite": {
      title: "Productivité mise à jour",
      body: "La section productivité est désormais remplie avec les heures saisies. Vous voyez les heures théoriques vs réelles, la productivité et les coûts associés : c'est l'écart entre les deux qui révèle si la fournée a été efficace.",
      tip: "Ajustez la cadence et le nombre d'opérateurs via le bouton Éditer si les heures théoriques sont mal calibrées.",
    },
    "hours-validate": {
      title: "Valider l'OF",
      body: "Cliquez sur Valider l'OF pour confirmer la production. L'OF passe en statut Validé, les lots de Biscuits sablés produits sont libérés et leur coût de revient (matière + main d'œuvre) est figé pour la facturation.",
      tip: "Le cycle complet est bouclé : de la commande à la production, puis la clôture et l'expédition.",
    },

    // ===== COMMANDES CLIENTS =====
    "cc-intro": {
      title: "Le point de départ de vos ventes",
      body: "Les commandes clients sont le point de départ de tout votre processus de vente : c'est ici qu'une demande de votre client devient un engagement à produire et livrer. Chez la Boulangerie du Moulin, une commande de 100 kg de « Biscuits sablés du Moulin » va déclencher la préparation, l'expédition puis la facturation. Tout le chiffre d'affaires de l'entreprise transite par cet écran.",
      tip: "Le cycle de vente : commande, expédition, livraison, puis facturation.",
    },
    "cc-list-overview": {
      title: "Liste des commandes",
      body: "Cette vue affiche toutes vos commandes clients avec leur état, le client, la date de livraison et l'avancement sur trois axes (expédition, facturation, préparation). C'est votre tableau de bord commercial quotidien : vous y repérez en un coup d'œil les commandes à préparer pour demain ou celles encore à facturer. Filtrez par état ou par axe pour gérer vos priorités.",
      tip: "Filtrez sur « En cours de préparation » pour voir uniquement les commandes à expédier rapidement.",
    },
    "cc-status": {
      title: "États de commande",
      body: "Chaque card affiche l'état principal (En rédaction, En attente de confirmation, En cours de traitement, En cours de préparation, Terminée) ainsi que des badges d'avancement : expédition, facturation et préparation. Cela vous permet de savoir, sans ouvrir la commande, si la commande de biscuits de la Boulangerie Martin est déjà expédiée ou s'il reste une facture à émettre.",
      tip: "Les indicateurs de couleur facilitent le suivi visuel : un coup d'œil suffit pour prioriser.",
    },
    "cc-add-btn": {
      title: "Nouvelle commande",
      body: "Ce bouton ouvre le formulaire de création d'une nouvelle commande client. C'est le point d'entrée chaque fois qu'un client passe commande, par exemple quand la Boulangerie Martin vous demande 100 kg de biscuits sablés. Vous y choisirez le client, les adresses et la date de livraison avant d'ajouter les articles.",
      tip: null,
    },
    "cc-workflow": {
      title: "Cycle de vie",
      body: "Une commande client passe par 5 états : En rédaction → En attente de confirmation → En cours de traitement → En cours de préparation → Terminée. En parallèle, 3 axes de suivi évoluent indépendamment : expédition (non/partielle/totale), facturation (non/partielle/totale) et préparation (à préparer/brouillon/tout engagé/partielle/prête). Cela reflète la réalité : vos biscuits peuvent être expédiés avant que la facture ne soit émise.",
      tip: "Ces axes sont indépendants : une commande peut être expédiée partiellement mais pas encore facturée.",
    },
    "cc-click-add": {
      title: "Créer la commande",
      body: "Cliquez pour ouvrir le formulaire. Vous allez sélectionner le client et les paramètres de livraison.",
      tip: null,
    },
    "cc-form-intro": {
      title: "Formulaire de commande",
      body: "Ce formulaire capture les informations principales : client, adresse de livraison, adresse de facturation et entrepôt de départ.",
      tip: null,
    },
    "cc-select-client": {
      title: "Sélectionner le client",
      body: "Choisissez le client parmi vos tiers de type Client. Ses conditions commerciales (remises, délais) seront appliquées automatiquement.",
      tip: "Les remises négociées avec le client s'appliquent automatiquement sur les lignes.",
    },
    "cc-select-adresse": {
      title: "Adresse de livraison",
      body: "Sélectionnez l'adresse de livraison parmi les adresses enregistrées du client. C'est le lieu où les marchandises seront expédiées.",
      tip: null,
    },
    "cc-select-entrepot": {
      title: "Entrepôt de départ",
      body: "Choisissez l'entrepôt depuis lequel les articles seront expédiés. Le stock disponible sera filtré selon cet entrepôt.",
      tip: "Si vous avez plusieurs entrepôts, choisissez celui le plus proche du client.",
    },
    "cc-save": {
      title: "Enregistrer la commande",
      body: "Validez pour créer la commande en statut Brouillon. Vous pourrez ensuite ajouter les lignes d'articles.",
      tip: null,
    },
    // cc-add-ligne, cc-ligne-article, cc-ligne-quantite, cc-ligne-prix → defined below (section fiche-commande-client)
    "cc-recap-financier": {
      title: "Récapitulatif financier",
      body: "Le panneau récapitulatif affiche le total HT, les remises, la TVA ventilée par taux et le total TTC. Il se met à jour à chaque modification de ligne, ce qui vous donne en temps réel le montant exact de la commande. Pour 100 kg de biscuits à 12,50 €, vous voyez immédiatement le HT, la TVA appliquée et le TTC que paiera la Boulangerie Martin.",
      tip: "Vérifiez la ventilation de TVA si vous vendez des produits à taux différents.",
    },
    "cc-send": {
      title: "Envoyer la commande",
      body: "Une fois toutes les lignes ajoutées, envoyez la commande au client. Elle passe en statut Envoyée et peut être préparée pour l'expédition.",
      tip: "Après l'envoi, la commande ne peut plus être modifiée. Créez un avoir si besoin.",
    },
    "cc-click-card": {
      title: "Ouvrir une commande",
      body: "Après la création, JustUp ouvre directement la fiche complète de la commande. C'est l'espace de travail détaillé où vous gérez les lignes d'articles, suivez la préparation et les livraisons, et déclenchez les actions (proforma, confirmation, facturation). Toute la gestion concrète de la commande de la Boulangerie Martin se fait depuis cette fiche.",
      tip: "Plus tard, un clic sur la carte de la commande dans la liste rouvrira cette fiche à tout moment.",
    },
    "cc-fiche-overview": {
      title: "Fiche commande client",
      body: "La fiche se compose de trois zones : le tableau des lignes commandées (article, quantité, prix, remises), le récapitulatif financier (HT, TVA, TTC, remises) et l'aside latéral avec le client, les adresses, le N° de commande client et les actions. C'est votre vue à 360° sur la commande, de la saisie commerciale jusqu'à l'expédition.",
      tip: "Les onglets Préparation et Livraisons s'utilisent quand la commande est prête à expédier.",
    },
    "cc-lignes-table": {
      title: "Lignes de commande",
      body: "Chaque ligne contient un article avec sa quantité, son prix unitaire (tarif négocié ou catalogue) et la TVA. Les remises par ligne sont affichées en vert.",
      tip: "Le bouton + ajoute un article. Le prix est automatiquement calculé depuis les tarifs négociés avec le client.",
    },
    "cc-maker-tiers": {
      title: "Sélectionner le client",
      body: "Recherchez et sélectionnez « Boulangerie Martin » dans la liste : seuls les tiers de type Client apparaissent ici. En choisissant le client, vous rattachez automatiquement ses conditions commerciales (remises négociées, délais de paiement) à la commande, ce qui évite toute ressaisie et garantit la cohérence avec votre tarif client.",
      tip: "Les adresses de facturation et de livraison du client seront pré-remplies automatiquement.",
    },
    "cc-maker-adresses": {
      title: "Adresses",
      body: "Sélectionnez l'adresse de facturation et l'adresse de livraison parmi celles enregistrées pour ce client ; elles sont pré-remplies par défaut s'il en possède. La distinction est importante : la livraison détermine où vos biscuits seront physiquement expédiés, tandis que la facturation indique le siège qui réglera la facture (parfois différent, par exemple un magasin livré et un siège facturé).",
      tip: "Vous pouvez créer une nouvelle adresse directement depuis le sélecteur si le client en a une nouvelle.",
    },
    "cc-maker-numero": {
      title: "Numéro de commande client",
      body: "Saisissez ici la référence de commande propre au client (ex: BM-2026-043). C'est le numéro que la Boulangerie Martin utilise pour identifier cette commande de son côté ; il est distinct de votre propre numéro JustUp. Le renseigner facilite le rapprochement comptable entre vos documents et le bon de commande du client.",
      tip: "Ce numéro apparaîtra sur les bons de livraison et les factures pour accélérer le rapprochement.",
    },
    "cc-maker-date": {
      title: "Date de livraison",
      body: "Indiquez la date de livraison prévue convenue avec le client. Elle pilote toute la planification en amont : JustUp en déduit la date d'expédition (selon votre délai de transport) et vous aide à planifier la production des biscuits pour qu'ils soient prêts à temps. Une date réaliste évite les retards en bout de chaîne.",
      tip: "Choisissez la date à laquelle le client doit recevoir la marchandise, pas celle de l'expédition.",
    },
    "cc-maker-save": {
      title: "Créer la commande",
      body: "Vérifiez le numéro de commande client si vous l'avez renseigné, puis cliquez sur Continuer. La section « Plus de paramètres » permet de choisir l'entrepôt de départ et le créneau horaire (optionnels). La commande sera alors créée en statut Brouillon, prête à recevoir les lignes d'articles.",
      tip: "Laissez l'entrepôt vide pour rester en mode global ; vous pourrez l'assigner plus tard sur la fiche.",
    },
    "cc-add-ligne": {
      title: "Ajouter une ligne",
      body: "Cliquez sur ce bouton pour ouvrir le formulaire d'ajout de ligne. Chaque ligne représente un article commandé : vous y choisissez l'article, la quantité et le prix unitaire. Pour la Boulangerie Martin, vous ajouterez ici une ligne « Biscuits sablés du Moulin » de 100 kg, qui alimentera ensuite le récapitulatif financier et la préparation.",
      tip: null,
    },
    "cc-ligne-article": {
      title: "Sélectionner l'article",
      body: "Sélectionnez « Biscuits sablés du Moulin » dans la liste : le tarif négocié (12,50 €/kg) sera appliqué automatiquement. L'onglet « Articles du tiers » affiche les articles ayant déjà un prix négocié avec ce client, tandis que « Tous les articles » permet de chercher dans le catalogue complet si besoin.",
      tip: "Le prix, l'unité et la TVA sont pré-remplis depuis le tarif client, sans ressaisie.",
    },
    "cc-ligne-all-articles": {
      title: "Tous les articles",
      body: "Si la liste « Articles du tiers » est vide (pas de prix négocié), cliquez sur « Tous les articles » pour accéder à l'ensemble du catalogue et sélectionner votre article.",
      tip: null,
    },
    "cc-ligne-article-fourni": {
      title: "Prix de l'article",
      body: "Ce sélecteur affiche les prix spécifiques paramétrés pour ce client. S'il est vide, cliquez sur « Ajouter un prix + » pour créer un tarif à la volée.\n\nVous définirez l'unité de vente, le coefficient, la TVA et le prix unitaire. Ce tarif sera enregistré et réutilisé automatiquement sur les prochaines commandes.",
      tip: "Cliquez sur « Ajouter un prix + » en bas du sélecteur.",
    },
    "cc-ligne-add-prix": {
      title: "Ajouter un prix",
      body: "Cliquez sur « Ajouter un prix + » pour créer un tarif de vente spécifique à ce client. Ce prix sera enregistré et réutilisé automatiquement sur les prochaines commandes.",
      tip: null,
    },
    "cc-af-dialog": {
      title: "Créer un prix spécifique",
      body: "Ce formulaire crée un tarif de vente pour cet article chez ce client. Le type « Vente » et le scope « Tiers » sont pré-sélectionnés. Renseignez l'unité de vente, le coefficient et le prix.",
      tip: "Ce prix sera réutilisé automatiquement sur les prochaines commandes de ce client.",
    },
    "cc-af-unite": {
      title: "Unité de vente",
      body: "L'unité dans laquelle le client commande (ex: carton, kg, pièce, barquette). Le coefficient indique combien d'unités de gestion (UG) contient une unité de vente.",
      tip: "Exemple : 1 carton = 12 pièces → unité « Carton », coefficient 12.",
    },
    "cc-af-coefficient": {
      title: "Coefficient de conversion",
      body: "Combien d'unités de gestion (stock interne) dans une unité de vente client. Si le client commande en KG et votre stock est en KG, mettez 1.",
      tip: null,
    },
    "cc-af-prix": {
      title: "Prix unitaire HT",
      body: "Le prix de vente HT par unité de vente. Vous pouvez définir des paliers de prix selon la quantité commandée via « Ajouter un prix ».",
      tip: null,
    },
    "cc-af-save": {
      title: "Enregistrer le prix",
      body: "Cliquez sur Enregistrer pour sauvegarder ce tarif. Il sera automatiquement appliqué sur la ligne de commande et réutilisé pour les futures commandes de ce client.",
      tip: null,
    },
    "cc-ligne-quantite": {
      title: "Quantité",
      body: "Saisissez la quantité commandée par le client, exprimée dans l'unité de vente (carton, kg, pièce...). Ici, la Boulangerie Martin commande 100 kg de biscuits sablés. Cette quantité détermine le total de la ligne et le volume à préparer puis à expédier ; elle doit donc correspondre exactement au besoin du client.",
      tip: "Si un multiple de vente est défini, des suggestions d'arrondi apparaissent sous le champ.",
    },
    "cc-ligne-pilotage-tip": {
      title: "Infos pilotage de la réf",
      body: "L'icône à côté de l'article ouvre au survol un résumé de pilotage : quantité déjà commandée toutes commandes confondues, stock éligible, et une projection Après qui recalcule le reste à réserver en incluant la ligne en cours de saisie. Vous savez avant de valider si le stock permettra de servir cette commande.",
      tip: "Le stock éligible ne compte que les lots dont la date limite tient jusqu'à la livraison, DDM mini comprise.",
    },
    "cc-ligne-date-livraison": {
      title: "Date de livraison de la ligne",
      body: "Chaque ligne peut porter sa propre date de livraison si elle diffère de celle de la commande — sinon elle en hérite automatiquement, comme indiqué sous le champ. Cette date sert de référence pour évaluer la contrainte DDM : plus la livraison est lointaine, plus les lots devront durer longtemps.",
      tip: "Laissez le champ vide pour hériter de la date de la commande.",
    },
    "cc-ligne-date-conso": {
      title: "Date prévue de consommation",
      body: "Encore plus précis : indiquez la date à laquelle le client prévoit de consommer ou revendre le produit. Cliquez sur Suivant — nous saisissons une livraison à J+7 et une consommation à environ 3 mois, et le système en déduit automatiquement la DDM mini exigée à la livraison.",
      tip: "Raisonner en date d'usage final évite de calculer la DDM mini de tête.",
    },
    "cc-ligne-ddm-mini": {
      title: "DDM mini à la livraison",
      body: "La DDM mini est le nombre de jours de durabilité que le produit doit encore avoir au moment de la livraison. Elle vient d'être calculée depuis la date de consommation prévue. Sans saisie, la valeur suit la cascade standard : client, puis groupe de clients, puis article. Cette contrainte guidera la sélection des lots en préparation.",
      tip: "Une valeur saisie ici prévaut sur la cascade standard, pour cette ligne uniquement.",
    },
    "cc-ligne-prix": {
      title: "Prix unitaire HT",
      body: "Le prix est calculé automatiquement depuis le tarif négocié avec le client (ici 12,50 €/kg) : pour 100 kg, la ligne atteint donc 1 250 € HT. Activez « Prix manuel » uniquement si vous devez exceptionnellement déroger au tarif. Laisser le prix automatique garantit que vos marges et conditions clients restent cohérentes.",
      tip: "Les remises (tiers, groupe, article) s'appliquent automatiquement sur le prix catalogue.",
    },
    "cc-ligne-save": {
      title: "Enregistrer la ligne",
      body: "Cliquez pour ajouter cette ligne à la commande. Le total HT, la TVA et le total TTC du récapitulatif financier se recalculent aussitôt. Vous pouvez ensuite ajouter d'autres lignes (par exemple un second produit pour la Boulangerie Martin) ou fermer le formulaire si la commande est complète.",
      tip: null,
    },
    "cc-confirmer": {
      title: "Confirmer la commande",
      body: "Une fois les lignes ajoutées, confirmez la commande pour la faire passer en traitement : elle devient un engagement ferme et entre dans le flux de préparation. Le client peut être notifié si vous envoyez la confirmation par mail. C'est l'étape qui transforme le brouillon en commande réelle à honorer.",
      tip: "Une commande confirmée ne peut plus être modifiée librement sans la rouvrir.",
    },
    "cc-tabs": {
      title: "Onglets de la commande",
      body: "L'onglet « Préparation » gère le picking des lots, la palettisation et l'expédition. L'onglet « Livraisons » affiche l'historique des bons de livraison et des palettes déjà expédiées. Ces onglets deviennent votre espace de travail une fois la commande confirmée : c'est là que les biscuits passent du stock au camion.",
      tip: "C'est depuis l'onglet Préparation que vous expédiez physiquement les marchandises au client.",
    },
    "cc-entrepot": {
      title: "Assigner un entrepôt",
      body: "Ce bouton permet d'associer un entrepôt de départ à la commande : la préparation ne pourra alors puiser que dans le stock de cet entrepôt. Sans entrepôt assigné, la commande reste en mode global, visible par tous les opérateurs et servie depuis n'importe quel entrepôt. Assigner un entrepôt est utile pour contrôler d'où partent les biscuits quand vous avez plusieurs sites.",
      tip: "Utile dès que vous avez plusieurs entrepôts et souhaitez maîtriser la source du stock.",
    },
    "cc-aside-actions": {
      title: "Documents et actions",
      body: "Depuis l'aside, vous générez la facture proforma (devis), la confirmation de commande, et vous pouvez les envoyer par email directement au client. Ces documents formalisent l'engagement commercial avec la Boulangerie Martin avant l'expédition. Le PDF reprend automatiquement toutes les lignes, prix, remises et conditions de la commande.",
      tip: "Le PDF est généré automatiquement avec toutes les lignes, prix et conditions à jour.",
    },
    "cc-facturation-btn": {
      title: "Facturation",
      body: "Ce bouton ouvre la liste des factures filtrées pour cette commande. Vous pourrez y créer, éditer et envoyer les factures, qu'elles soient partielles (une par livraison) ou totale (en une fois). C'est ici que la commande de la Boulangerie Martin se transforme en chiffre d'affaires encaissable.",
      tip: "Facturez partiellement si vous livrez la commande en plusieurs fois.",
    },
    "cc-livraison-btn": {
      title: "L'onglet Livraison",
      body: "C'est ici que la marchandise sort, quelle que soit la façon dont elle part : sur palette via un chargement, retirée par le client, ou facturée et gardée en stock (les biscuits restent chez vous, la propriété change de mains). Toute sortie passe par cet onglet — c'est ce qui garantit un seul bon de livraison par départ.",
      tip: "Le détail de chaque canal est couvert dans le tutoriel Expédition.",
    },
    "cc-lifecycle": {
      title: "Cycle de vie",
      body: "Une commande client passe par 5 états principaux :\n\n1. En rédaction → ajout des lignes, modifications libres\n2. En attente de confirmation → envoyée au client\n3. En cours de traitement → confirmée, prise en charge\n4. En cours de préparation → picking et palettisation\n5. Terminée → clôturée\n\nEn parallèle, 3 axes de suivi indiquent l'avancement, indépendamment de l'état :\n• Expédition : non expédiée → partielle → totale\n• Facturation : non facturée → partielle → totale\n• Préparation : à préparer → brouillon → tout engagé → partielle → prête",
      tip: "Ces axes sont indépendants : la commande de biscuits peut être expédiée mais pas encore facturée.",
    },
    "cc-expedition-intro": {
      title: "Et ensuite ?",
      body: "Une fois la commande confirmée, vous passez à la préparation de l'expédition : picking des lots de biscuits en stock, palettisation et chargement pour le transport. C'est l'étape qui fait sortir physiquement la marchandise et met à jour l'axe expédition de la commande.",
      tip: "L'expédition fait l'objet du tutoriel suivant, dans la continuité de cette commande.",
    },
    "cc-outro": {
      title: "De la commande à l'expédition",
      body: "Création, lignes, tarifs et remises, documents PDF, déclenchement de l'expédition et de la facturation : la commande client se gère de bout en bout. La prochaine étape est l'expédition des biscuits à la Boulangerie Martin.",
      tip: "Le cycle de vente continue : préparez les lots, palettisez et expédiez.",
    },

    // ===== EXPÉDITION =====
    // Section 1 : Paramétrage unités d'expédition
    "expe-ue-intro": {
      title: "Unités d'expédition",
      body: "Avant de préparer une expédition, vous configurez vos types d'unités : palettes, bacs, caisses. Chaque type porte un nom et une tare (poids de l'emballage vide) qui sera déduite automatiquement au moment de la pesée. Pour la Boulangerie du Moulin, nous allons créer une Palette Europe afin d'expédier les Biscuits sablés du Moulin.",
      tip: "Une même commande peut combiner plusieurs types d'unités différents (ex: palettes + bacs isothermes).",
    },
    "expe-ue-list": {
      title: "Types existants",
      body: "Cette section liste tous vos types d'unités d'expédition déjà configurés, réutilisables sur chaque commande. Pour l'instant aucun type n'est défini : nous allons en créer un ensemble, la Palette Europe, qui servira à toutes les expéditions de la boulangerie.",
      tip: "Configurez vos types une seule fois ici : ils seront ensuite proposés automatiquement lors de chaque palettisation.",
    },
    "expe-ue-add": {
      title: "Ajouter un type",
      body: "Cliquez pour ouvrir le formulaire de création d'un type d'unité d'expédition. Nous allons créer une Palette Europe avec une tare de 25 kg, le format standard pour palettiser les cartons de biscuits.",
      tip: "Créez un type par format physique réellement utilisé dans votre entrepôt, pas plus.",
    },
    "expe-ue-denomination": {
      title: "Nom de l'unité",
      body: "Saisissez le nom du type d'unité. Ce libellé apparaîtra à chaque palettisation et sur les documents d'expédition. Saisissez Palette Europe ; d'autres exemples courants : Demi-palette, Bac isotherme, Caisse carton.",
      tip: "Choisissez un nom parlant pour l'opérateur, c'est ce qu'il verra au moment de monter la palette.",
    },
    "expe-ue-tare": {
      title: "Tare (poids à vide)",
      body: "La tare est le poids de l'emballage vide, en kg. Pour une Palette Europe standard, saisissez 25 kg. Au moment de la pesée, ce poids est déduit automatiquement pour obtenir le poids net réel des biscuits expédiés, qui figurera sur le bon de livraison.",
      tip: "Une tare juste évite de facturer ou déclarer du poids d'emballage comme du produit.",
    },
    "expe-ue-article": {
      title: "Article lié (optionnel)",
      body: "Ce champ relie le type d'unité d'expédition à un article en stock (ex: Palette Europe 80×120). Quand un article est lié, chaque unité créée réserve automatiquement une palette dans le stock d'emballages ; si l'unité est annulée, le stock redevient disponible. Vous suivez ainsi précisément le nombre de palettes vides restantes.",
      tip: "Sans article lié, l'expédition fonctionne normalement mais le stock d'emballages n'est pas suivi.",
    },
    "expe-ue-save": {
      title: "Enregistrer",
      body: "Cliquez pour sauvegarder le type d'unité d'expédition. Une fois enregistré, il rejoint la liste des types existants et sera proposé immédiatement lors de la palettisation de la commande Boulangerie du Moulin.",
      tip: "Vous pourrez modifier la tare ou l'article lié plus tard sans avoir à recréer le type.",
    },
    "expe-ue-outro": {
      title: "Un format d'expédition réutilisable",
      body: "Votre Palette Europe est prête et réutilisable sur toutes vos commandes. Vous pourriez en créer d'autres (demi-palette, bac isotherme) de la même façon. Passons maintenant à la préparation concrète : nous allons ouvrir une commande client et la préparer pour expédition.",
      tip: "Le paramétrage des unités se fait une fois ; la préparation se répète à chaque commande.",
    },
    // Section 2 : Préparation commande
    "expe-retour-cc": {
      title: "Retour sur la commande",
      body: "Cliquez sur la commande client pour ouvrir sa fiche. C'est depuis cette fiche que vous piloterez toute l'expédition des Biscuits sablés du Moulin : choix des lots, palettisation et édition des documents.",
      tip: "La préparation se fait toujours depuis la fiche de la commande concernée, jamais depuis le stock global.",
    },
    "expe-tab-prepa": {
      title: "Onglet Préparation",
      body: "Cliquez sur l'onglet « Préparation de commande » pour accéder à la zone de picking et de palettisation. C'est l'espace de travail où l'opérateur affecte les lots aux lignes et constitue les palettes avant chargement.",
      tip: "Cet onglet n'apparaît que pour les commandes prêtes à être préparées (stock disponible).",
    },
    "expe-prepa-intro": {
      title: "Préparation d'expédition",
      body: "Cet onglet centralise toute la préparation : sélection des lots, affectation sur les unités d'expédition, et envoi.\n\nLe flux se déroule en 4 phases : Simulation → Engagement → Palettisation → Expédition.",
      tip: "L'opérateur peut sauter certaines phases selon le mode (avec UE, vrac ou direct).",
    },
    // Section 2 (kept) + Section 3
    "expe-intro": {
      title: "Bienvenue dans l'expédition",
      body: "L'expédition permet de préparer les commandes clients pour la livraison : sélection des lots, palettisation et génération des documents.",
      tip: "L'expédition fait le lien entre le stock et la livraison au client.",
    },
    "expe-progress": {
      title: "Lignes de commande",
      body: "Chaque ligne de commande affiche une barre de progression qui suit l'avancement de sa préparation. Les couleurs vous donnent l'état d'un coup d'œil : gris = pas démarré, orange = en cours, violet = en attente d'expédition, vert = expédié. Sur la commande de biscuits, vous voyez ainsi instantanément ce qu'il reste à préparer.",
      tip: "Cliquez sur une ligne pour aller directement à sa préparation.",
    },
    "expe-btn-auto-affecter": {
      title: "Auto-affecter",
      body: "Ce bouton propose automatiquement quels lots en stock affecter à chaque ligne, en priorisant les lots dont la DDM est la plus proche (FEFO) pour ne pas laisser dormir des biscuits près de péremption. C'est une simulation : aucun mouvement de stock réel tant que vous n'avez pas engagé la commande.",
      tip: "Vous pouvez ajuster manuellement les lots après l'auto-affectation si besoin.",
    },
    "expe-btn-engager": {
      title: "Engager la commande",
      body: "L'engagement transforme la simulation en mouvements physiques : les lots de biscuits sont déplacés vers la zone de préparation de la commande client et réservés. Tant que ce n'est pas engagé, le stock reste disponible pour d'autres commandes ; une fois engagé, il est verrouillé pour celle-ci.",
      tip: "Vous pouvez revenir en simulation tant que les lots ne sont pas posés sur une unité d'expédition.",
    },
    "expe-btn-picking": {
      title: "Picking",
      body: "Ce bouton génère un PDF de préparation (fiche de picking) listant les lots engagés à prélever en zone de préparation. C'est le document que l'opérateur emporte en entrepôt pour aller chercher physiquement les bonnes palettes de biscuits aux bons emplacements.",
      tip: "Le PDF est disponible dès qu'au moins un lot est engagé.",
    },
    "expe-tab-livraison": {
      title: "L'onglet Livraison",
      body: "Toute sortie de marchandise passe par cet onglet, et par lui seul. L'onglet Préparation sert à réserver et à monter les unités d'expédition ; c'est ici que la marchandise quitte réellement l'entrepôt et que le bon de livraison est émis.",
      tip: "Une seule porte de sortie, c'est ce qui garantit un seul bon de livraison par départ.",
    },
    "expe-canal-livraison": {
      title: "Choisir le canal de sortie",
      body: "Trois canaux, selon la façon dont la marchandise part. « Avec expédition » : les lots partent sur des unités d'expédition (palettes, bacs) via un chargement. « Livraison directe » : le client vient retirer, ou la marchandise est remise en main propre. « Facturer et garder en stock » : la propriété est transférée mais les biscuits restent chez vous.",
      tip: "Le canal se choisit par départ, pas une fois pour toutes : une même commande peut partir en plusieurs fois par des canaux différents.",
    },
    "expe-add-vrac": {
      title: "Ajouter les lots à remettre",
      body: "Sélectionnez les lots que le client emporte. Ils sont pris dans la zone de retrait alimentée par la préparation, ou directement dans le stock disponible. La quantité est ajustable : le client peut n'emporter qu'une partie de sa commande, le reste demeure à livrer.",
      tip: "Un lot déjà réservé pour cette commande garde son lien : il ne repart pas dans le stock libre.",
    },
    "expe-previsualiser-bl": {
      title: "Prévisualiser le bon de livraison",
      body: "Le bon provisoire montre exactement ce que le client va signer : les lots, les quantités, et les prestations prévues (livraison, montage) qui n'ont ni lot ni stock. Relisez-le avant de valider — c'est le document qui part avec la marchandise.",
      tip: "Un bon amputé de ses prestations est une réclamation garantie : la prévisualisation est là pour l'éviter.",
    },
    "expe-btn-expedier-direct": {
      title: "Livrer par retrait",
      body: "Ce bouton sort la marchandise sans palettisation ni chargement : un bon de livraison est émis directement à partir des lots choisis. C'est le geste du retrait client et de la remise en main propre. En contrepartie, il n'y a pas de suivi par unité d'expédition.",
      tip: "Le processus complet (palettisation → chargement → BL) est détaillé dans le tutoriel Livraison.",
    },
    "expe-modes": {
      title: "Avec expédition / Livraison directe",
      body: "Ce sélecteur bascule entre deux flux. « Avec expédition » : les lots passent par des unités d'expédition (palettes, bacs) avant le chargement, le mode standard pour livrer des biscuits sur palette. « Livraison directe » : expédition sans unité, pour une prestation ou une petite commande.",
      tip: "En agroalimentaire, le mode « Avec expédition » est le plus courant car il assure la traçabilité jusqu'à la palette.",
    },
    "expe-picking-intro": {
      title: "Zone de picking",
      body: "La zone de picking liste les lots disponibles en stock pour chaque article de la commande. Sélectionnez les lots à expédier.",
      tip: "Le système propose les lots en FIFO (premiers entrés, premiers sortis) par défaut.",
    },
    "expe-select-lot": {
      title: "Sélectionner un lot",
      body: "Choisissez le lot à expédier parmi les lots disponibles. Les informations du lot (DLUO, stock) sont affichées.",
      tip: null,
    },
    "expe-fill-quantite": {
      title: "Quantité à expédier",
      body: "Indiquez la quantité à prélever de ce lot. Elle ne peut pas dépasser le stock disponible du lot.",
      tip: "Vous pouvez répartir une ligne de commande sur plusieurs lots si nécessaire.",
    },
    "expe-link": {
      title: "Créer le lien d'expédition",
      body: "Cliquez pour créer le lien entre le lot et la ligne de commande. Le stock est réservé dans la zone d'expédition.",
      tip: null,
    },
    "expe-verify-link": {
      title: "Vérifier le lien",
      body: "Le lien d'expédition apparaît dans la section dédiée. Il montre le lot, la quantité et la ligne de commande associée.",
      tip: "Vous pouvez supprimer un lien d'expédition tant que l'unité d'expédition n'est pas validée.",
    },
    "expe-vrac-option": {
      title: "Option vrac",
      body: "Le mode vrac permet d'expédier sans palettisation. Les lots sont directement préparés pour le chargement.",
      tip: "Utilisez le mode vrac pour les petites commandes ou les produits non palettisables.",
    },
    "expe-add-palette": {
      title: "Section unités d'expédition",
      body: "En bas de la page, la section « Unités d'expédition » liste les palettes, bacs et autres unités créées pour cette commande. C'est ici que vous montez physiquement vos palettes de biscuits, en y posant les lots avant de les charger dans le camion.",
      tip: "Chaque unité d'expédition est identifiée par un code SSCC unique pour la traçabilité logistique.",
    },
    "expe-create-ue": {
      title: "Créer une unité d'expédition",
      body: "Cliquez sur ce bouton pour créer une nouvelle unité d'expédition. Un formulaire s'ouvre pour la configurer (dénomination, entrepôt, type). Cette première palette accueillera les Biscuits sablés du Moulin de la commande.",
      tip: "Créez autant d'unités que nécessaire : une grosse commande peut tenir sur plusieurs palettes.",
    },
    "expe-ue-form-denomination": {
      title: "Dénomination",
      body: "La dénomination est générée automatiquement à partir de la commande (ex: « Palette 1 / Boulangerie du Moulin / CC2600001 »). Elle identifie la palette sur les documents et les écrans. Vous pouvez la modifier, mais le format proposé suffit dans la plupart des cas.",
      tip: "Gardez la dénomination automatique pour rester cohérent avec vos autres palettes.",
    },
    "expe-ue-form-entrepot": {
      title: "Entrepôt de départ",
      body: "Sélectionnez l'entrepôt depuis lequel l'unité d'expédition sera préparée : c'est là que le stock de biscuits sera prélevé. Pour la Boulangerie du Moulin il n'y a qu'un seul entrepôt, donc il est sélectionné d'office.",
      tip: "Si la commande a déjà un entrepôt assigné, il est pré-sélectionné automatiquement.",
    },
    "expe-type-palette": {
      title: "Type d'unité d'expédition",
      body: "Sélectionnez le type configuré au paramétrage : choisissez Palette Europe. Le type détermine la tare (25 kg) déduite à la pesée et, si un article est lié, la consommation du stock d'emballages. C'est ce qui relie cette palette concrète au type que vous avez créé en début de tutoriel.",
      tip: "Si un type manque dans la liste, créez-le d'abord dans Paramétrage > Unités d'expédition.",
    },
    "expe-ue-form-save": {
      title: "Enregistrer l'unité d'expédition",
      body: "Cliquez pour créer l'unité d'expédition. Elle est ajoutée à la commande en statut « En préparation » et reçoit son code SSCC. Vous pourrez ensuite y associer les lots de biscuits engagés pour la remplir avant le chargement.",
      tip: "Une unité « En préparation » reste modifiable ; elle se verrouille une fois validée pour expédition.",
    },
    "expe-sscc": {
      title: "Code SSCC",
      body: "Le code SSCC (Serial Shipping Container Code) est généré automatiquement. C'est un identifiant unique à 18 chiffres au standard GS1.",
      tip: "Le SSCC permet le suivi de l'unité d'expédition tout au long de la chaîne logistique.",
    },
    "expe-assign-lot": {
      title: "Assigner les lots",
      body: "Associez les lots préparés à l'unité d'expédition. Chaque lot garde sa traçabilité complète.",
      tip: null,
    },
    "expe-fiche-palette": {
      title: "Fiche d'expédition",
      body: "Générez la fiche PDF avec le QR code SSCC, la liste des lots et les détails de chaque article.",
      tip: "Collez la fiche sur l'unité d'expédition pour faciliter l'identification au chargement.",
    },
    "expe-palettes-list": {
      title: "Liste des unités d'expédition",
      body: "Visualisez toutes les unités d'expédition créées pour cette commande. Chacune affiche son SSCC et les lots assignés.",
      tip: null,
    },
    "expe-outro": {
      title: "Les palettes sont prêtes à charger",
      body: "Picking des lots, engagement du stock, création des unités d'expédition, édition des documents : l'expédition est préparée de bout en bout. Vos palettes de Biscuits sablés du Moulin sont prêtes ; la prochaine étape est de générer le bon de livraison.",
      tip: "Les unités d'expédition étant prêtes au chargement, enchaînez avec le tutoriel Livraison pour créer le BL.",
    },

    // ===== LIVRAISON =====
    // ===== PRÉPARATION EXPÉDITION =====
    "prepa-pilot-intro": {
      title: "Piloter la préparation",
      body: "Bienvenue dans le pilotage de la préparation. Cette vue liste tous les produits ayant des commandes à servir dans l'horizon choisi, avec pour chacun le besoin total, le stock éligible et le reste à réserver. C'est ici que commence l'aide à la préparation : l'application arbitre les lots selon leur DDM et les contraintes de chaque commande.",
      tip: "Réglez l'horizon (14 jours par défaut) et filtrez par client, groupe ou état de couverture.",
    },
    "prepa-pilot-card": {
      title: "La carte produit",
      body: "Chaque carte résume un produit : la quantité à réserver est mise en avant, avec en dessous le total commandé, le déjà réservé et le stock éligible. Nos biscuits affichent 350 kg commandés par 2 clients — rien n'est encore réservé.",
      tip: "Les cartes sont triées par urgence d'action : ce qui reste à réserver apparaît en haut.",
    },
    "prepa-pilot-eligible": {
      title: "Stock éligible vs stock total",
      body: "Le stock éligible ne retient que les lots réellement utilisables : date limite qui tient jusqu'à la livraison (DDM mini comprise), entrepôt autorisé, lot libre. Un stock physique élevé peut cacher un stock éligible insuffisant — c'est exactement ce que cette vue révèle.",
      tip: "Ici, un lot trop court en rayon n'est éligible pour aucune des 2 commandes : 80 kg du stock physique ne comptent pas.",
    },
    "prepa-pilot-open-grid": {
      title: "Ouvrir la grille produit",
      body: "Cliquez sur la carte pour ouvrir la grille de pilotage du produit : c'est là que se joue la répartition des lots entre les commandes.",
      tip: "La grille est aussi accessible depuis l'onglet Préparation de chaque fiche commande.",
    },
    "prepa-grille-intro": {
      title: "La grille lots × commandes",
      body: "Voici la grille d'arbitrage : une ligne par lot, une colonne par commande client. Chaque cellule représente la quantité d'un lot affectée à une commande. L'objectif : servir chaque client avec le lot « juste-assez » — le lot le plus court qui respecte sa contrainte DDM — pour préserver les lots longs aux clients exigeants et limiter les pertes.",
      tip: "Les lots sont triés par date limite croissante (FEFO : premier expiré, premier sorti).",
    },
    "prepa-grille-lots": {
      title: "Les lots et leur date limite",
      body: "Chaque lot affiche son numéro, sa DDM et le nombre de jours restants. Le lot BIS-2026-001 expire dans environ 6 mois. Un lot trop court pour toutes les commandes est masqué par défaut — le bouton « Voir les lots hors contrainte » les révèle.",
      tip: "Code couleur des jours restants : vert au-delà de 30 jours, orange en dessous, rouge si la date est dépassée.",
    },
    "prepa-grille-cc": {
      title: "Les commandes et leur contrainte",
      body: "Chaque colonne porte une commande : le client, la date de livraison et la DDM mini contractuelle en jours. La Boulangerie Martin exige 30 jours de DDM à la livraison, le Supermarché FraisMalin 90 jours : ils ne pourront pas recevoir les mêmes lots.",
      tip: "La DDM mini suit une cascade : ligne de commande, client, groupe de clients, article — le badge indique la source.",
    },
    "prepa-grille-aside": {
      title: "La synthèse de couverture",
      body: "Le panneau latéral se lit de haut en bas : le besoin total, ce qui est déjà couvert (réservé physiquement ou pré-réservé en simulation), puis ce qui reste à combler avec le stock éligible ou la production à venir.",
      tip: "Pré-réserver = simulation modifiable. Réserver = le stock part physiquement en zone de préparation.",
    },
    "prepa-grille-auto": {
      title: "Pré-réservation Auto",
      body: "Cliquez sur le bouton : l'algorithme répartit les lots entre les commandes en respectant chaque contrainte DDM, avec la stratégie « juste-assez ». Le résultat reste une simulation — rien ne bouge physiquement tant que vous ne réservez pas.",
      tip: "Dans les options avancées, changez de stratégie : durabilité décroissante ou ordre chronologique des livraisons.",
    },
    "prepa-grille-resultat": {
      title: "Le résultat de l'arbitrage",
      body: "Les pré-réservations apparaissent en violet : le lot de 6 mois sert la Boulangerie Martin (30 j exigés) et complète FraisMalin, le lot long de 12 mois couvre le reste des 90 jours exigés. Le lot court de 80 kg n'a été donné à personne : il ne tenait aucune contrainte.",
      tip: "Vous pouvez corriger manuellement chaque cellule — la saisie est bornée au stock restant du lot.",
    },
    "prepa-grille-legende": {
      title: "Lire les couleurs",
      body: "La légende récapitule les statuts : violet pré-réservé, vert réservé physiquement, orange lot trop court par rapport au contrat (forçage motivé possible), rouge lot périmé, gris entrepôt non autorisé, et « date manquante » quand la commande n'a pas de date de livraison.",
      tip: "Forcer un lot trop court exige un motif tracé : demande client, accord qualité, lot unique…",
    },
    "prepa-grille-reserver": {
      title: "Réserver les lots",
      body: "La simulation vous convient ? Cliquez sur « Réserver toutes » : les pré-réservations de toutes les commandes deviennent des réservations physiques.",
      tip: "Vous pouvez aussi réserver commande par commande, via le bouton de chaque colonne.",
    },
    "prepa-grille-reserver-confirm": {
      title: "Confirmer la réservation",
      body: "Confirmez : le stock est transféré physiquement dans la zone de préparation de chaque commande. Les colonnes passent en « Réservée » avec un cadenas — pour modifier ensuite, il faudra d'abord libérer la ligne.",
      tip: "La réservation reste réversible tant que rien n'est parti sur palette.",
    },
    "prepa-grille-outro": {
      title: "Prêt à palettiser",
      body: "Les lots des deux commandes sont réservés en zone de préparation. Direction la fiche de la commande de la Boulangerie Martin pour l'étape suivante : poser ces lots sur une palette.",
      tip: "L'onglet Préparation de chaque commande reprend les mêmes informations, côté commande.",
    },
    "prep-ue-intro": {
      title: "Préparer l'unité d'expédition",
      body: "Une Palette Europe a été créée pour la commande de la Boulangerie Martin. Il faut maintenant y associer les lots de Biscuits sablés du Moulin réservés à l'étape précédente. Cette préparation garantit que chaque palette qui part de l'entrepôt contient exactement les bons lots, tracés du four au client.",
      tip: "Chaque lot ajouté à l'unité est déplacé de la zone de préparation vers la palette : votre stock disponible diminue d'autant en temps réel.",
    },
    "prep-ue-card": {
      title: "Votre unité d'expédition",
      body: "Voici la carte de l'unité d'expédition que vous venez de créer. Elle récapitule son type (Palette Europe), l'entrepôt de départ, le code SSCC qui l'identifie de façon unique, le poids actuel et les articles qu'elle contient. C'est votre tableau de bord pour suivre l'avancement de la préparation.",
      tip: "Le statut « En attente de préparation » signifie qu'aucun lot n'y est encore associé : le poids affiché est donc à zéro.",
    },
    "prep-ue-btn-prepare": {
      title: "Préparer l'unité",
      body: "Cliquez sur le bouton « + Préparer » en bas de la carte (ou via le menu ⋮) pour ouvrir le sélecteur de lots. Vous pourrez y choisir précisément quels lots de biscuits placer sur cette palette et en quelle quantité, sans risque d'erreur de prélèvement.",
      tip: "Le sélecteur n'affiche que les lots réellement disponibles en stock dans l'entrepôt de départ de l'unité.",
    },
    "prep-ue-lots": {
      title: "Cliquer sur la ligne de commande",
      body: "Cliquez sur la ligne « Biscuits sablés du Moulin » pour ouvrir le sélecteur de lots de cet article. C'est ici que vous choisissez quels lots prélever et en quelle quantité pour honorer la ligne de commande.",
      tip: "Une ligne par article commandé : vous préparez chaque référence séparément pour bien tracer ce qui part.",
    },
    "prep-ue-select-lot": {
      title: "Sélectionner un lot",
      body: "Dans le sélecteur, choisissez le lot à prélever parmi les lots disponibles en stock. Chaque lot affiche son numéro, sa date limite (DLUO/DLC) et la quantité disponible, pour vous permettre d'expédier en priorité les lots les plus anciens.",
      tip: "Les lots sont triés par date limite croissante (FEFO : le plus proche de la péremption en premier) afin de limiter les pertes.",
    },
    "prep-ue-quantite": {
      title: "Quantité à prélever",
      body: "Saisissez la quantité de biscuits à placer sur l'unité d'expédition. Utilisez les boutons + / − ou saisissez directement la valeur ; le stock restant du lot s'ajuste en temps réel. Ici nous prélevons 240 unités pour compléter la commande.",
      tip: "La quantité ne peut pas dépasser le stock disponible du lot : si besoin, complétez avec un second lot.",
    },
    "prep-ue-confirm": {
      title: "Ajouter le lot",
      body: "Cliquez sur « Ajouter » pour associer le lot à l'unité d'expédition. Un mouvement de stock est créé : le lot quitte l'entrepôt et est posé sur la palette, ce qui met à jour à la fois le stock et le poids de l'unité.",
      tip: "Vous pouvez ajouter plusieurs lots différents sur la même unité d'expédition pour atteindre la quantité commandée.",
    },
    "prep-ue-poids": {
      title: "Quantité préparée",
      body: "L'indicateur compare la quantité préparée à la quantité commandée pour vous dire d'un coup d'œil si la ligne est complète. Le poids brut de l'unité est recalculé après chaque ajout de lot (poids net des biscuits + tare de la palette), donnée reprise ensuite sur le bon de livraison.",
      tip: "Vous pouvez ajuster le poids manuellement via l'icône balance sur la carte palette si vous pesez réellement la palette.",
    },
    "prep-ue-statut": {
      title: "Déclarer prête",
      body: "Quand tous les lots sont associés et la quantité atteinte, déclarez l'unité d'expédition « Prête » via le menu d'actions. Elle pourra alors être ajoutée à un chargement et le statut affiché sur la carte passe au vert pour signaler qu'elle est bonne à partir.",
      tip: "Le passage en « Prête » est irréversible tant que le chargement n'est pas annulé : vérifiez bien la quantité avant de valider.",
    },
    "prep-ue-outro": {
      title: "La palette est constituée",
      body: "Votre palette est préparée avec les lots de Biscuits sablés du Moulin de la commande. La prochaine étape consiste à créer un chargement et à y associer cette unité pour l'expédier vers le client, puis générer le bon de livraison.",
      tip: "Le tutoriel suivant vous guide dans la création du chargement et du bon de livraison.",
    },

    "bl-intro": {
      title: "Bienvenue dans les livraisons",
      body: "Vos palettes de Biscuits sablés du Moulin sont préparées et prêtes au départ. La page Expéditions & BL centralise tout le flux de sortie de marchandise vers vos clients. Le processus se déroule en trois temps : créer un chargement, y rattacher les unités d'expédition prêtes, puis valider le départ. Cette dernière étape déclenche les sorties de stock et génère automatiquement le bon de livraison qui accompagnera vos biscuits jusqu'au client.",
      tip: "L'onglet « Expéditions » affiche les chargements en cours, l'onglet « Bons de livraison » regroupe les BL générés.",
    },
    "bl-goto-tab": {
      title: "Onglet Bons de livraison",
      body: "Le bon de livraison généré lors du chargement est consultable dans l'onglet « Bons de livraison ». Cliquez pour l'ouvrir. Cet onglet centralise tous vos BL, indépendamment du chargement, pour le suivi commercial et la facturation.",
      tip: "Le BL reste consultable ici même après facturation : c'est votre historique de sorties.",
    },
    "bl-list-overview": {
      title: "Bons de livraison générés",
      body: "Après la validation du chargement, les bons de livraison sont générés automatiquement. Cette vue les affiche avec leur statut, la commande associée, la date, le poids et le lien vers la facture. Vous pouvez filtrer par état (préparation, prêt, expédié non facturé, facturé) pour piloter votre facturation.",
      tip: "Vous pouvez imprimer un BL en PDF ou l'envoyer par email au client directement depuis cette liste.",
    },
    "bl-click-add": {
      title: "Créer un BL",
      body: "Cliquez pour créer un nouveau bon de livraison. Il sera lié à une commande client et ses palettes.",
      tip: null,
    },
    "bl-form-intro": {
      title: "Formulaire BL",
      body: "Le formulaire reprend automatiquement les informations de la commande : client, adresse de livraison et lignes d'articles.",
      tip: null,
    },
    "bl-select-commande": {
      title: "Commande associée",
      body: "Sélectionnez la commande client pour ce BL. Les lignes et palettes préparées seront automatiquement proposées.",
      tip: "Un BL peut couvrir une partie de la commande (livraison partielle).",
    },
    "bl-save": {
      title: "Enregistrer le BL",
      body: "Validez pour créer le BL en brouillon. Vous pourrez ensuite ajouter les palettes à livrer.",
      tip: null,
    },
    "bl-add-palettes": {
      title: "Ajouter des palettes",
      body: "Associez les palettes préparées au BL. Seules les palettes de la commande non encore assignées à un BL sont proposées.",
      tip: null,
    },
    "bl-pdf": {
      title: "Générer le PDF",
      body: "Générez le bon de livraison au format PDF : il contient la liste des articles, les quantités, les palettes et leurs références SSCC. Ce document accompagne physiquement la livraison de biscuits et sert de preuve de réception lorsque le client le signe.",
      tip: "Le PDF est envoyable directement au client par email depuis la liste des BL.",
    },
    "charg-intro": {
      title: "Charger le camion",
      body: "Le chargement est prêt. L'étape suivante est le départ effectif du camion : vérifier les unités d'expédition, signer la lettre de voiture et valider. Cette validation est irréversible — elle déclenche les mouvements de sortie de stock de vos biscuits et génère automatiquement le bon de livraison final.",
      tip: "Le départ se déroule en 3 étapes : contrôles qualité (optionnel) → scan des UE → lettre de voiture et signatures.",
    },
    "charg-list": {
      title: "Liste des chargements",
      body: "Cette vue liste vos chargements avec leur statut, leur transporteur et leur date de départ. Un chargement suit un cycle de vie clair : En préparation → Prêt → Chargé. Tant qu'il est En préparation, vous pouvez ajouter ou retirer des palettes ; une fois Chargé, les sorties de stock sont définitives.",
      tip: "Filtrez par statut pour repérer rapidement les chargements prêts à partir aujourd'hui.",
    },
    "charg-click-add": {
      title: "Créer un chargement",
      body: "Cliquez pour ouvrir le formulaire d'un nouveau chargement. Vous y choisirez la date de départ, le transporteur et l'entrepôt source d'où partent vos palettes de biscuits. Le chargement est l'unité logistique qui regroupera les bons de livraison destinés à un même camion.",
      tip: null,
    },
    "charg-form": {
      title: "Formulaire de chargement",
      body: "Le formulaire vous permet de choisir une date de départ (avec des raccourcis pratiques : aujourd'hui, demain, après-demain), le transporteur et l'entrepôt source. L'entrepôt source indique d'où partent les palettes — utile si votre boulangerie dispose de plusieurs sites de stockage.",
      tip: "Après la création, un sélecteur vous proposera directement les unités d'expédition prêtes à charger depuis cet entrepôt.",
    },
    "charg-transporteur": {
      title: "Transporteur",
      body: "Sélectionnez le transporteur parmi vos tiers de type Transporteur, par exemple « Transports Rapides SARL ». Ses coordonnées seront automatiquement reprises sur la lettre de voiture et les documents de transport. C'est lui qui acheminera physiquement vos biscuits jusqu'à l'adresse de livraison du client.",
      tip: "Si le transporteur n'existe pas encore, créez-le d'abord comme tiers de type Transporteur dans le module Tiers.",
    },
    "charg-add-bl": {
      title: "Créer et ajouter des unités d'expédition",
      body: "Cliquez pour créer le chargement. Un sélecteur s'ouvre ensuite avec les unités d'expédition prêtes — vos palettes de biscuits préparées — que vous pourrez rattacher au camion. Le bon de livraison sera généré automatiquement à partir des palettes rattachées.",
      tip: null,
    },
    "charg-select-ue": {
      title: "Choisir l'unité d'expédition",
      body: "Le sélecteur affiche les palettes prêtes au départ depuis l'entrepôt. Sélectionnez la « Palette Europe 1 » de Biscuits sablés du Moulin préparée pour la commande client — elle est identifiée de façon unique par son code SSCC. Ce code garantit la traçabilité de la palette de bout en bout.",
      tip: "Vous pouvez aussi scanner le code SSCC avec un lecteur code-barres ou la caméra pour aller plus vite.",
    },
    "charg-save": {
      title: "Rattacher l'unité au chargement",
      body: "Cliquez sur « Ajouter » pour rattacher la palette au chargement. Un bon de livraison est automatiquement créé et numéroté, regroupant les palettes destinées au même client à la même adresse. Vous pouvez rattacher plusieurs palettes au même camion avant de partir.",
      tip: "Regroupez les palettes par destination pour optimiser les tournées et le coût de transport.",
    },
    "charg-validate-btn": {
      title: "Scanner les unités d'expédition",
      body: "L'étape 2 du départ vérifie que toutes les unités d'expédition sont physiquement présentes sur le quai avant que le camion ne parte. Scannez les codes SSCC de chaque palette avec un lecteur code-barres ou la caméra, ou validez-les manuellement. Cela évite d'oublier une palette de biscuits ou d'en charger une de trop.",
      tip: "Toutes les UE doivent être scannées ou validées pour pouvoir poursuivre vers l'étape suivante.",
    },
    "charg-confirm": {
      title: "Lettre de voiture et signatures",
      body: "L'étape 3 génère un récapitulatif du chargement (nombre d'unités d'expédition, poids brut, transporteur). Vous pouvez ajouter des observations ou réserves, joindre des documents et recueillir les signatures de l'opérateur et du chauffeur. Une fois validé, le départ devient définitif.",
      tip: "La signature de l'opérateur est obligatoire ; celle du chauffeur est optionnelle mais recommandée en cas de litige.",
    },
    "charg-mouvements": {
      title: "Mouvements de stock",
      body: "Une fois le départ validé, des mouvements de sortie sont générés automatiquement pour chaque lot de biscuits chargé. Le stock de la zone d'expédition est décrémenté en conséquence : ce que vous avez expédié n'apparaît plus comme disponible. La quantité réelle expédiée alimente ainsi votre suivi de stock et vos coûts.",
      tip: "Ces mouvements sont la base de la comptabilité analytique et du suivi de stock par lot.",
    },
    "charg-status": {
      title: "Statut du chargement",
      body: "Le chargement passe en statut Chargé une fois le départ validé. Les bons de livraison associés sont mis à jour et la commande client de Biscuits sablés du Moulin progresse vers le statut Livrée. Le cycle commercial est désormais prêt à être facturé.",
      tip: "Un chargement Chargé est en lecture seule : pour corriger une erreur, il faut passer par une annulation et un avoir.",
    },
    "charg-outro": {
      title: "La marchandise est partie",
      body: "Bon de livraison, palettes, chargement, sortie de stock : le cycle de livraison est bouclé. Vos Biscuits sablés du Moulin roulent vers le client, traçables jusqu'à la palette grâce au code SSCC. Il ne reste plus qu'à transformer ces livraisons en chiffre d'affaires.",
      tip: "Le cycle se poursuit avec la facturation : les BL validés peuvent désormais être facturés en un clic.",
    },
    // === FACTURATION ===
    "fact-intro": {
      title: "Bienvenue dans la facturation",
      body: "Le module Factures transforme vos livraisons en documents financiers. Pour la Boulangerie du Moulin, chaque palette de Biscuits sablés livrée à un client devient une facture en quelques clics. Le processus est balisé : sélectionner un BL en attente, créer la facture, la figer (émettre), puis enregistrer le paiement.",
      tip: "Les factures sont liées aux BL : chaque BL validé peut être facturé en un clic, sans ressaisir les lignes.",
    },
    "fact-list-overview": {
      title: "Liste des factures",
      body: "Ce tableau regroupe toutes vos factures et avoirs avec leur statut, montant TTC et date d'échéance. Pour la boulangerie, vous y retrouvez d'un coup d'œil ce qui est émis, réglé ou en retard. Cliquez sur une ligne pour ouvrir le détail d'une facture.",
      tip: "Utilisez les filtres pour retrouver rapidement une facture par état, par client (ex: une épicerie fine) ou sur une période donnée.",
    },
    "fact-kpi": {
      title: "Indicateurs clés",
      body: "Les KPI affichent en haut le montant total en attente de paiement et celui des factures dont l'échéance est dépassée. Pour la Boulangerie du Moulin, c'est le tableau de bord de la trésorerie : vous voyez immédiatement combien d'argent vos clients vous doivent encore.",
      tip: "Cliquez sur une facture en retard listée dans le KPI pour ouvrir directement son détail et la relancer.",
    },
    "fact-pending-bl": {
      title: "BL en attente de facturation",
      body: "Cet onglet liste les bons de livraison validés qui n'ont pas encore été facturés. Concrètement, dès qu'une livraison de Biscuits sablés est partie chez un client, son BL atterrit ici en attente d'être transformé en facture. Cliquez sur un BL pour le préparer à la facturation.",
      tip: "Un BL ne peut être facturé qu'une seule fois. Une fois lié à une facture, il disparaît automatiquement de cette liste.",
    },
    "fact-create-from-bl": {
      title: "Créer une facture depuis un BL",
      body: "Cliquez ici pour générer automatiquement une facture à partir du BL sélectionné. Les lignes (vos Biscuits sablés, quantités et prix), le client et l'adresse de facturation sont repris tels quels depuis la livraison. Vous gagnez du temps et évitez les erreurs de ressaisie.",
      tip: "C'est le moyen le plus rapide de facturer : toutes les informations sont héritées du BL et donc de la commande client d'origine.",
    },
    "fact-builder-open": {
      title: "Formulaire de facture",
      body: "Ce formulaire permet de créer ou modifier une facture. Vous y renseignez le client, la date de facturation, l'échéance et le RIB sur lequel vous attendez le règlement. Pour la boulangerie, c'est l'écran central où la facture prend sa forme avant émission.",
      tip: "La date d'échéance se calcule automatiquement selon les conditions de paiement du client (ex: 30 jours fin de mois).",
    },
    "fact-select-tiers": {
      title: "Sélectionner le tiers",
      body: "Choisissez le client à facturer. Ses coordonnées, ses conditions de paiement et son RIB seront automatiquement utilisés sur la facture. Pour la Boulangerie du Moulin, ce sera par exemple l'épicerie fine ou le café qui vous a commandé des Biscuits sablés.",
      tip: "Les conditions de paiement du client déterminent l'échéance : assurez-vous qu'elles sont bien renseignées dans sa fiche tiers.",
    },
    "fact-dates": {
      title: "Dates de facturation",
      body: "La date de facturation est la date officielle du document. L'échéance, calculée automatiquement à partir des conditions du client (ex: 30 jours), peut être ajustée manuellement si besoin. C'est elle qui détermine à partir de quand une facture de Biscuits sablés est considérée en retard.",
      tip: "Les mentions légales (pénalités de retard, indemnité forfaitaire de 40 €, escompte) s'affichent automatiquement sur la facture émise.",
    },
    "fact-remises-pied": {
      title: "Remises de pied de facture",
      body: "Cette section permet d'ajouter des remises globales sur la facture, en pourcentage ou en montant fixe. Elles s'appliquent après le sous-total des lignes. Par exemple, une remise commerciale de 5 % pour un client fidèle qui commande des Biscuits sablés toutes les semaines.",
      tip: "Les remises de ligne sont reprises des commandes ; les remises de pied sont propres à la facture et s'ajoutent par-dessus.",
    },
    "fact-add-remise": {
      title: "Ajouter une remise",
      body: "Cliquez pour ajouter une remise de pied. Vous pouvez en ajouter plusieurs avec un libellé, un type (% ou €) et une valeur.",
      tip: null,
    },
    "fact-save": {
      title: "Enregistrer la facture",
      body: "Sauvegardez la facture en statut En rédaction (brouillon). À ce stade, rien n'est définitif : vous pouvez encore ajouter ou retirer des BL, corriger les lignes de Biscuits sablés et ajuster les remises avant de l'émettre officiellement.",
      tip: "Tant que la facture est en rédaction, elle n'a pas de numéro officiel et reste librement modifiable.",
    },
    "fact-detail-overview": {
      title: "Détail et totaux",
      body: "Le panneau de détail affiche les totaux HT, TVA et TTC ainsi que les remises appliquées. Pour une facture de Biscuits sablés, vous vérifiez ici que le total correspond bien à la livraison avant d'émettre. Le montant restant dû apparaît une fois la facture émise et les paiements affectés.",
      tip: "Les totaux se recalculent automatiquement dès que vous modifiez une ligne, une remise ou un taux de TVA.",
    },
    "fact-figer": {
      title: "Émettre la facture",
      body: "Cliquez sur le bouton pour émettre la facture. L'émission la fige de façon définitive : elle passe en statut Émise, reçoit un numéro chronologique officiel et ne peut plus être modifiée. C'est l'acte qui rend votre facture de Biscuits sablés juridiquement valable et opposable au client.",
      tip: "Vérifiez bien les lignes et les remises avant d'émettre : une fois figée, seule la création d'un avoir permet de la corriger.",
    },
    "fact-figer-confirm": {
      title: "Confirmer l'émission",
      body: "Confirmez : la facture reçoit son numéro chronologique et passe en statut Émise. Les actions changent alors sur la fiche — l'envoi par email devient disponible, la modification ne l'est plus.",
      tip: "Ce garde-fou évite d'émettre une facture incomplète par erreur.",
    },
    "fact-pdf": {
      title: "Générer le PDF",
      body: "Téléchargez la facture émise au format PDF pour l'archiver dans votre comptabilité ou l'envoyer manuellement au client. Le PDF reprend vos coordonnées, le logo de la Boulangerie du Moulin, les lignes de Biscuits sablés et les mentions légales obligatoires.",
      tip: "Conservez systématiquement le PDF de chaque facture émise : c'est votre justificatif comptable et fiscal.",
    },
    "fact-send": {
      title: "Envoyer par email",
      body: "Envoyez la facture directement par email au client, sans passer par votre boîte mail. Vous pouvez personnaliser le message et les destinataires, par exemple ajouter le service comptabilité de l'épicerie en copie pour accélérer le règlement de vos Biscuits sablés.",
      tip: "L'email utilise un template HTML avec le PDF de la facture automatiquement joint en pièce jointe.",
    },
    "fact-transactions": {
      title: "Transactions et paiements",
      body: "L'onglet Transactions liste les encaissements reçus (CB, virement). En affectant un paiement à une facture, vous suivez précisément le solde restant dû. Quand l'épicerie règle ses Biscuits sablés par virement, vous pointez le montant sur la facture concernée.",
      tip: "Une facture passe automatiquement en Partiellement réglée puis Réglée à mesure que vous lui affectez des paiements.",
    },
    "fact-avoir": {
      title: "Créer un avoir",
      body: "Pour corriger une facture déjà émise (erreur de quantité, retour de marchandise), créez un avoir. Il reprend le client et permet de saisir des quantités de réintégration : si un client retourne un lot de Biscuits sablés non vendus, l'avoir peut le réinjecter dans votre stock.",
      tip: "L'avoir suit son propre cycle : Partiellement imputé puis Imputé puis Remboursé selon son affectation.",
    },
    "fact-outro": {
      title: "Le cycle de facturation, de bout en bout",
      body: "Vous avez parcouru le cycle complet : créer une facture depuis un BL, l'émettre, l'envoyer, encaisser et gérer les avoirs. Le circuit commercial est bouclé, de la commande de Biscuits sablés jusqu'à l'encaissement.",
      tip: "Consultez régulièrement les KPI de trésorerie pour relancer à temps les factures dont l'échéance approche.",
    },
    // === TRANSFERTS ===
    "transf-intro": {
      title: "Bienvenue dans les transferts",
      body: "Les transferts inter-entrepôts permettent de déplacer du stock d'un de vos sites à un autre, sans passer par une vente. Pour la Boulangerie du Moulin, c'est par exemple envoyer de la farine de votre entrepôt principal vers un atelier secondaire. Chaque transfert suit un cycle complet : création, préparation, expédition puis réception sur le site d'arrivée.",
      tip: "Un transfert crée des mouvements de stock traçables entre les zones de départ et d'arrivée : vos quantités restent justes des deux côtés.",
    },
    "transf-list-overview": {
      title: "La liste des transferts",
      body: "Tous vos transferts sont listés ici. Chaque ligne indique l'origine, la destination, le numéro et l'état d'avancement. Vous suivez d'un coup d'œil quels lots de farine ou de biscuits sont encore en transit entre vos sites.",
      tip: "Filtrez par état pour retrouver vite les transferts en attente d'expédition ou de réception.",
    },
    "transf-card": {
      title: "Un transfert",
      body: "Cette carte représente un transfert de l'« Entrepôt principal » vers le « Moulin de Provence ». La flèche indique le sens du déplacement : origine → destination. Vous y voyez aussi le numéro et l'état pour situer le transfert sans l'ouvrir.",
      tip: "Cliquez sur une carte pour ouvrir le détail du transfert et accéder à ses lignes et actions.",
    },
    "transf-etat": {
      title: "L'état du transfert",
      body: "Le badge coloré indique où en est le transfert dans son cycle : En rédaction → En attente d'expédition → Expédié → Terminé (ou Transféré partiellement) → Soldé. C'est votre repère pour savoir quelle action attend chaque transfert.",
      tip: "Chaque changement d'état enregistre l'utilisateur et la date — indispensable pour la traçabilité et un éventuel contrôle.",
    },
    "transf-new": {
      title: "Créer un transfert",
      body: "Le bouton « Nouveau transfert » ouvre le formulaire de création. C'est le point de départ : vous choisissez d'où part la marchandise et où elle doit arriver. Les articles à déplacer seront ajoutés juste après, sur la fiche.",
      tip: "Pensez transfert dès qu'une marchandise change de site sans être vendue : matière première, en-cours ou produit fini.",
    },
    "transf-maker-open": {
      title: "Ouvrir le formulaire",
      body: "Cliquez sur « Nouveau transfert » pour ouvrir le formulaire de création. Vous n'aurez besoin que de deux informations pour commencer : le site de départ et le site d'arrivée.",
      tip: null,
    },
    "transf-maker-dialog": {
      title: "Formulaire de transfert",
      body: "Un transfert se définit par deux adresses : l'entrepôt de départ et l'entrepôt d'arrivée. C'est volontairement minimal — vous validez d'abord le trajet, puis vous ajouterez les articles (farine, sucre, biscuits…) ensuite, sur la fiche du transfert.",
      tip: "Le départ et l'arrivée doivent être deux sites différents : c'est tout l'intérêt d'un transfert.",
    },
    "transf-depart": {
      title: "L'entrepôt de départ",
      body: "Sélectionnez le site d'origine, d'où la marchandise va quitter — ici l'« Entrepôt principal ». Par défaut, c'est votre entrepôt actif. C'est sur ce site que sera puisé le stock disponible lors de l'expédition.",
      tip: "Vérifiez que le stock à transférer est bien présent sur le site de départ avant de valider.",
    },
    "transf-arrivee": {
      title: "L'entrepôt d'arrivée",
      body: "Sélectionnez le site de destination, où la marchandise doit arriver — ici le « Moulin de Provence ». Il doit être différent du site de départ. C'est là que le stock deviendra disponible une fois la réception faite.",
      tip: "À la création, une « zone de transfert » est générée automatiquement : c'est le transit où le stock attend entre l'expédition et la réception.",
    },
    "transf-maker-save": {
      title: "Enregistrer le transfert",
      body: "Enregistrez : le transfert est créé en état « En rédaction ». Vous arrivez alors sur sa fiche, où vous ajouterez les articles à transférer. Rien n'est encore déplacé en stock à ce stade — c'est juste le brouillon du transfert.",
      tip: "Tant que le transfert reste en rédaction, vous pouvez tout corriger : adresses comme lignes.",
    },
    "transf-open-detail": {
      title: "Ouvrir un transfert",
      body: "Ouvrons le transfert de démo pour suivre son cycle de vie complet, étape par étape. Vous allez voir comment la marchandise passe du site de départ, transite par la zone de transfert, puis arrive sur le site de destination.",
      tip: null,
    },
    "transf-lignes": {
      title: "Les lignes du transfert",
      body: "L'onglet « Lignes » liste les articles à transférer avec leurs quantités — ici 200 kg de farine et 100 kg de sucre. C'est l'inventaire de ce qui doit voyager. Tant que le transfert est en rédaction, vous pouvez ajouter, modifier ou supprimer des lignes.",
      tip: "Une ligne par article : ajoutez tous les articles à déplacer avant de valider, ensuite les lignes seront figées.",
    },
    "transf-valider": {
      title: "1. Valider",
      body: "Une fois les lignes saisies, la validation fait passer le transfert en « En attente d'expédition ». Les lignes sont alors figées : c'est l'engagement sur ce qui doit partir, et la préparation physique peut commencer en atelier.",
      tip: "Au moins une ligne est requise pour valider : un transfert vide n'a pas de sens.",
    },
    "transf-expedier": {
      title: "2. Préparer & expédier",
      body: "Vous préparez la marchandise en palettes ou en vrac, puis vous l'expédiez. L'expédition déplace le stock du site de départ vers la zone de transfert et génère un bon de transfert PDF. Concrètement, vos 200 kg de farine quittent l'entrepôt principal et entrent « en transit ».",
      tip: "Onglet « Préparation » : palettes et vrac cohabitent pour s'adapter à tous les types d'articles.",
    },
    "transf-dechargement": {
      title: "3. Décharger à l'arrivée",
      body: "Sur le site de destination, l'onglet « Déchargement » enregistre l'arrivée physique des articles : on vérifie ce qui a réellement été reçu par rapport à ce qui était attendu. C'est l'étape où l'on constate, par exemple, un sac de farine abîmé ou une quantité incomplète.",
      tip: "Sélectionnez le bon de transfert concerné : les articles et quantités attendus se pré-remplissent automatiquement.",
    },
    "transf-reception": {
      title: "4. Réceptionner",
      body: "La réception saisit, lot par lot, les quantités conformes et non conformes. Elle déplace le stock de la zone de transfert vers l'adresse d'arrivée — la farine est enfin disponible sur le site de destination et utilisable pour fabriquer vos biscuits. C'est l'étape qui crédite réellement le stock.",
      tip: "Les écarts éventuels sont signalés : ce qui n'arrive pas reste en zone de transfert tant que le transfert n'est pas soldé.",
    },
    "transf-solder": {
      title: "5. Terminer ou solder",
      body: "Si tout est reçu, le transfert passe « Terminé ». Si des quantités manquent — un sac de farine resté en route, par exemple — vous pouvez le « Solder » : les écarts sont enregistrés et le transfert est clôturé proprement, sans laisser de stock fantôme en transit.",
      tip: "Solder évite de garder un transfert ouvert indéfiniment quand vous savez que le reliquat n'arrivera jamais.",
    },
    "transf-outro": {
      title: "Un transfert d'un bout à l'autre",
      body: "Vous connaissez le cycle complet : créer → valider → expédier → décharger → réceptionner. Chaque étape génère des mouvements de stock traçables entre vos sites, donc vos quantités restent justes partout, du Moulin de Provence à l'entrepôt principal.",
      tip: "Ces mouvements sont visibles dans la traçabilité de chaque lot : vous pouvez remonter l'historique d'un sac de farine d'un site à l'autre.",
    },
    // === INVENTAIRE ===
    "inv-card": {
      title: "Un inventaire en cours",
      body: "Cette carte représente l'« Inventaire annuel 2026 » de la Boulangerie du Moulin. Tant qu'il n'est pas clôturé, il reste dans cette liste. Un inventaire se déroule par zones (réserve sèche, chambre froide, atelier), comptées en parallèle par plusieurs opérateurs pour gagner du temps.",
      tip: "Donnez un nom parlant à vos inventaires (« Annuel 2026 », « Trimestre 1 ») pour les retrouver facilement dans l'historique.",
    },
    "inv-compter": {
      title: "Compter",
      body: "Le bouton « Compter » ouvre la vue compteur : c'est par là qu'un opérateur accède aux zones qui lui sont assignées pour saisir ses comptages. Par exemple, le boulanger ouvre sa zone « Réserve sèche » et y enregistre les sacs de farine comptés, lot par lot.",
      tip: "Sur le terrain, ce bouton s'utilise depuis un mobile ou une tablette, avec le scan code-barres pour aller plus vite.",
    },
    "inv-menu": {
      title: "Superviser & clôturer",
      body: "Ce menu donne accès aux outils du responsable d'inventaire : la supervision en temps réel, le tableau de bord (répartition par zone, famille et propriétaire) et l'export CSV. C'est de là que vous arbitrez les écarts et lancez la clôture qui régularise les stocks.",
      tip: "Réservez ces actions au responsable : la clôture est irréversible et met à jour tous les stocks d'un coup.",
    },
    "inv-open": {
      title: "Ouvrir l'inventaire",
      body: "Ouvrons la vue compteur de l'inventaire de démo pour découvrir le comptage par zone. C'est l'écran que verra chaque opérateur de la Boulangerie du Moulin quand il commencera à compter sur le terrain.",
      tip: null,
    },
    "inv-zone-compter": {
      title: "Compter cette zone",
      body: "Le bouton « Compter » d'une zone ouvre l'écran de saisie : on y scanne ou sélectionne un article, on choisit le lot concerné, puis on saisit la quantité comptée. Par exemple, scanner un sac de farine T65 et saisir « 12 » sacs comptés sur le lot du jour.",
      tip: "Le compteur ne voit que la zone choisie — on compte zone par zone pour limiter les erreurs et les doublons.",
    },
    "inv-intro": {
      title: "Bienvenue dans l'inventaire",
      body: "Le module Inventaire vous permet de réaliser des inventaires physiques pour confronter votre stock réel au stock théorique de JustUp. Concrètement, à la Boulangerie du Moulin, vous comptez la farine en sacs, le sucre, le beurre et les Biscuits sablés du Moulin finis, puis JustUp régularise les écarts. Vous découpez l'entrepôt en zones et comptez article par article.",
      tip: "Plusieurs compteurs peuvent travailler en même temps : les saisies remontent en temps réel, idéal pour boucler un inventaire annuel en une matinée.",
    },
    "inv-list-overview": {
      title: "Liste des inventaires",
      body: "Cette section regroupe tous vos inventaires en cours. Tant qu'un inventaire n'est pas clôturé, il reste affiché ici : vous pouvez y revenir pour reprendre le comptage, superviser l'avancement ou consulter le tableau de bord. C'est le point de départ de tout le cycle d'inventaire.",
      tip: "Un inventaire disparaît de cette liste dès sa clôture — c'est le signe que les stocks ont été régularisés.",
    },
    "inv-click-add": {
      title: "Créer un inventaire",
      body: "Ce bouton ouvre le formulaire de création. Vous donnez un nom à l'inventaire (ex. « Inventaire annuel 2026 ») et sélectionnez l'entrepôt à inventorier. Une fois créé, vous pourrez y ajouter des zones de comptage et assigner les compteurs.",
      tip: "Créez un inventaire distinct par entrepôt ou par site : les stocks sont régularisés par adresse.",
    },
    "inv-form": {
      title: "Formulaire d'inventaire",
      body: "Saisissez la dénomination et sélectionnez l'adresse (entrepôt) à inventorier.",
      tip: "Vous pourrez ajouter des zones de comptage après la création.",
    },
    "inv-zones": {
      title: "Zones de comptage",
      body: "Les zones découpent l'entrepôt en secteurs physiques. Chaque compteur se voit attribuer une ou plusieurs zones.",
      tip: "Créez des zones correspondant à vos allées ou racks pour faciliter le comptage.",
    },
    "inv-compteur-dashboard": {
      title: "Tableau de bord compteur",
      body: "Le compteur voit ici les zones qui lui sont assignées, chacune avec le nombre de comptages déjà saisis et sa progression. Il choisit une zone (ex. « Chambre froide ») pour commencer à compter, ce qui évite que deux opérateurs comptent la même zone en double.",
      tip: "Une zone marquée comme terminée indique aux autres qu'elle a été entièrement comptée.",
    },
    "inv-select-zone": {
      title: "Sélectionner une zone",
      body: "Choisissez la zone dans laquelle vous allez compter, par exemple la « Réserve sèche » où sont stockés les sacs de farine et de sucre. Le comptage se fait zone par zone : vous ne saisissez que les articles physiquement présents dans cette zone, ce qui structure le travail et limite les oublis.",
      tip: "Faites correspondre vos zones à vos allées ou racks réels pour que les compteurs se repèrent instantanément.",
    },
    "inv-scan": {
      title: "Scanner les articles",
      body: "Utilisez le scanner intégré pour lire les codes-barres EAN13, EAN14 ou GS1-128. L'article est identifié automatiquement.",
      tip: "Si le code-barres n'est pas reconnu, vous pouvez sélectionner l'article manuellement.",
    },
    "inv-comptage-form": {
      title: "Formulaire de comptage",
      body: "Après le scan, saisissez la quantité comptée. Le formulaire s'adapte au type de comptage de l'article.",
      tip: null,
    },
    "inv-types-comptage": {
      title: "Types de comptage",
      body: "Selon l'article, le comptage s'adapte : simple (quantité directe pour les biscuits à l'unité), par packs/colis (cartons de 24 biscuits + unités isolées), par mesure, par pesée avec sur-emballage (sacs de farine au poids) ou par rouleaux. Le bon format de saisie s'affiche automatiquement, ce qui évite les erreurs de conversion.",
      tip: "Le type de comptage se règle dans la fiche article. Bien le configurer en amont accélère et fiabilise tout l'inventaire.",
    },
    "inv-save-comptage": {
      title: "Enregistrer le comptage",
      body: "Validez pour enregistrer le comptage : il remonte aussitôt vers la supervision et alimente le bilan de l'article. Si un comptage existe déjà pour cet article dans cette zone, JustUp vous demande confirmation avant de l'écraser, pour éviter d'effacer le travail d'un autre compteur par mégarde.",
      tip: "En cas de doute sur une quantité, comptez à nouveau plutôt que d'estimer : un comptage faux fausse l'écart et la valorisation du stock.",
    },
    "inv-supervision": {
      title: "Supervision en temps réel",
      body: "La vue Supervision affiche les bilans en temps réel via WebSocket : vous voyez les comptages arriver au fur et à mesure que les opérateurs saisissent sur le terrain. Le responsable suit ainsi l'avancement zone par zone sans attendre la fin de l'inventaire.",
      tip: "Le code couleur signale les articles prêts (vert) et ceux encore en attente de comptage (orange) — un coup d'œil suffit pour relancer une zone à la traîne.",
    },
    "inv-bilan-list": {
      title: "Bilans par article",
      body: "Chaque article affiche le stock théorique, le comptage retenu et l'écart. Dépliez une ligne pour voir le détail par lot et zone.",
      tip: "Les bilans se mettent à jour automatiquement quand un nouveau comptage est enregistré.",
    },
    "inv-ecarts": {
      title: "Écarts de stock",
      body: "Les écarts entre le stock théorique de JustUp et les comptages physiques sont mis en évidence ici. Par exemple, 50 sacs de farine attendus mais 47 comptés : l'écart de 3 sacs apparaît clairement. Les écarts significatifs doivent être arbitrés avant la clôture.",
      tip: "Un écart peut venir d'une erreur de comptage, d'un mouvement non saisi (casse, perte) ou d'un vrai problème de stock — vérifiez avant de régulariser.",
    },
    "inv-arbitrage": {
      title: "Arbitrer un bilan",
      body: "L'arbitrage permet, quand plusieurs comptages existent pour un même lot, de choisir celui qui sera retenu, ou de saisir manuellement la quantité finale. Vous pouvez aussi ajuster la valeur unitaire qui servira à valoriser le stock régularisé. C'est l'étape de validation avant la clôture.",
      tip: "Vous pouvez supprimer un comptage manifestement erroné depuis cette fenêtre pour ne garder que les saisies fiables.",
    },
    "inv-dashboard-admin": {
      title: "Tableau de bord administrateur",
      body: "Le dashboard affiche la répartition par zone, par famille et par propriétaire. Ajoutez des zones et suivez la progression globale.",
      tip: null,
    },
    "inv-cloture": {
      title: "Clôturer l'inventaire",
      body: "La clôture régularise les stocks de JustUp selon les comptages validés. Deux modes : RAZ des lots non comptés (remet à zéro tout ce qui n'a pas été vu) ou mise à jour uniquement des lots comptés (laisse le reste inchangé). À partir de là, votre stock système reflète la réalité physique.",
      tip: "La clôture est irréversible. Vérifiez tous les bilans et arbitrez chaque écart avant de cliquer — un bilan sans quantité retenue bloque la clôture.",
    },
    "inv-outro": {
      title: "L'inventaire, du comptage à la clôture",
      body: "Vous avez suivi tout le cycle d'inventaire : création, comptage par zone et par scan, supervision en temps réel, arbitrage des écarts, puis clôture qui régularise les stocks. Votre stock système colle maintenant à la réalité de l'entrepôt.",
      tip: "Planifiez vos inventaires régulièrement (annuel complet, tournants par zone) pour maintenir la fiabilité de vos stocks et la justesse de vos coûts.",
    },
    // === TRACABILITE ===
    "traca-intro": {
      title: "Bienvenue dans la traçabilité",
      body: "Le module Traçabilité reconstitue toute l'histoire d'un lot : d'où viennent ses ingrédients (amont) et où sont partis les produits finis (aval). Ici vous suivez un lot de « Biscuits sablés du Moulin » : remontez jusqu'aux sacs de farine et de beurre reçus, descendez jusqu'aux clients livrés. En cas de rappel sanitaire, c'est ce qui vous permet d'identifier en quelques secondes tous les lots et clients concernés.",
      tip: "La traçabilité ascendante et descendante (one step up, one step down) est une obligation réglementaire en agroalimentaire. Tenez-la à jour à chaque réception et chaque expédition.",
    },
    "traca-sankey": {
      title: "Diagramme Sankey",
      body: "Le graphe Sankey affiche les nœuds (lots de matières, OF, tiers) et les flux qui les relient : réception de la farine, production des biscuits, expédition aux clients. Le lot de biscuits tracé est au centre, l'amont à gauche et l'aval à droite.",
      tip: "La largeur de chaque flux est proportionnelle à la quantité échangée : un flux épais signale une matière fortement consommée, comme la farine dans une recette de sablés.",
    },
    "traca-legend": {
      title: "Légende du graphe",
      body: "La légende distingue les types de nœuds (Lot en bleu, OF en violet, Tiers en vert) et les types de liens (Réception, Production, Consommation, Expédition, Regroupement). Elle vous aide à lire en un instant quel acteur a fait quoi dans le parcours du biscuit.",
      tip: "Repérez les nœuds verts (tiers) : à gauche ce sont vos fournisseurs de matières, à droite vos clients livrés.",
    },
    "traca-zoom": {
      title: "Contrôles de navigation",
      body: "Utilisez les boutons zoom avant/arrière et recentrage pour explorer le graphe, surtout quand un lot a un long historique. Le déplacement (pan) se fait aussi en glissant à la souris. Vous gardez ainsi une vue claire même sur des chaînes de production complexes.",
      tip: "Zoomez sur la zone centrale pour lire les libellés des flux, puis recentrez pour retrouver une vue d'ensemble.",
    },
    "traca-node-click": {
      title: "Cliquer sur un nœud",
      body: "Cliquez sur n'importe quel nœud pour ouvrir sa fiche détaillée : un lot de matière, l'OF de fabrication ou un tiers. De proche en proche, vous remontez toute la chaîne, par exemple du carton livré au client jusqu'au sac de farine du fournisseur.",
      tip: "C'est exactement le geste à faire lors d'un audit ou d'un rappel : suivez le fil de nœud en nœud pour reconstituer l'historique complet.",
    },
    "traca-lot-infos": {
      title: "Informations du lot",
      body: "La fiche lot affiche le numéro de lot, la DLUO, l'article associé (« Biscuits sablés du Moulin ») et les documents liés. C'est la carte d'identité du lot : tout ce que vous saisissez ici sera repris sur les étiquettes, les bons de livraison et, en cas de contrôle, présenté aux autorités sanitaires.",
      tip: "Un numéro de lot clair et une DLUO juste évitent les litiges clients et facilitent le retrait ciblé d'un lot précis plutôt que de toute une production.",
    },
    "traca-lot-stocks": {
      title: "Stocks du lot",
      body: "Cliquez sur l'onglet Stocks pour voir les quantités encore disponibles de ce lot de biscuits, ventilées par adresse et par zone. Vous savez ainsi combien de cartons restent en entrepôt, en expédition ou en transit, et où aller les chercher physiquement en cas de blocage qualité.",
      tip: "Les zones de stock reflètent vos emplacements réels : entrepôt, production, expédition, transit. Bloquer une zone met instantanément le lot en quarantaine.",
    },
    "traca-lot-mouvements": {
      title: "Mouvements de stock",
      body: "L'onglet Mouvements retrace toutes les entrées et sorties de ce lot de biscuits : production sur l'OF, transferts entre zones, expéditions vers les clients. Chaque ligne raconte un événement daté, ce qui vous donne l'historique exact de la vie du lot.",
      tip: "Chaque mouvement est horodaté et relié à son opération d'origine (OF, commande, transfert) : cliquez dessus pour ouvrir le document source.",
    },
    "traca-lot-traca-tab": {
      title: "Onglet Traçabilité",
      body: "Cliquez sur l'onglet Traçabilité de la fiche lot pour afficher le diagramme Sankey centré sur ce lot de biscuits. C'est la vue qui relie d'un coup d'œil les matières premières en amont et les expéditions en aval, sans quitter la fiche.",
      tip: "Vous pouvez ouvrir cet onglet depuis n'importe quel lot : un produit fini comme un lot de farine fournisseur.",
    },
    "traca-lot-costs": {
      title: "Onglet Coûts",
      body: "L'onglet Coûts affiche le coût unitaire matière et main-d'œuvre de ce lot de biscuits, calculé à partir des consommations réelles de l'OF. Vous voyez ainsi combien vous a réellement coûté un biscuit (farine, beurre, sucre + temps de fabrication), à comparer avec votre prix de vente.",
      tip: "Le coût réel du lot peut différer du coût théorique de la nomenclature : c'est ici que vous repérez les surconsommations ou les pertes de matière.",
    },
    "traca-amont": {
      title: "Traçabilité amont",
      body: "La partie gauche du graphe montre l'amont : les fournisseurs, les lots de matières premières (farine, beurre, sucre) et les OF de production qui ont contribué à ce lot de biscuits. C'est la réponse à la question « avec quoi ce lot a-t-il été fabriqué ? ».",
      tip: "En cas d'alerte fournisseur (par exemple un lot de beurre rappelé), l'amont identifie en un clic tous vos lots de biscuits impactés.",
    },
    "traca-aval": {
      title: "Traçabilité aval",
      body: "La partie droite du graphe montre l'aval : les expéditions et les clients qui ont reçu des produits issus de ce lot de biscuits. C'est la réponse à la question « où est parti ce lot ? », indispensable pour cibler un retrait commercial.",
      tip: "En cas de non-conformité détectée après expédition, l'aval vous donne la liste exacte des clients à prévenir, sans rappeler toute la production.",
    },
    "traca-refresh": {
      title: "Rafraîchir le graphe",
      body: "Cliquez pour forcer le recalcul du graphe côté serveur. Utile si de nouveaux mouvements ont eu lieu depuis l'ouverture de la fiche, par exemple une nouvelle expédition de ce lot de biscuits enregistrée entre-temps.",
      tip: "Le graphe se reconstruit en temps réel par streaming : vous voyez la chaîne se redessiner progressivement.",
    },
    "traca-fullscreen": {
      title: "Mode plein écran",
      body: "Basculez en plein écran pour une meilleure lisibilité du graphe, idéal lors d'un audit ou d'une réunion qualité où vous présentez la chaîne complète d'un lot de biscuits sur grand écran.",
      tip: "Le plein écran est parfait pour projeter la traçabilité d'un lot devant un auditeur ou un client exigeant.",
    },
    "traca-outro": {
      title: "Remonter et redescendre un lot",
      body: "Vous savez naviguer dans la traçabilité complète d'un lot : Sankey amont/aval, stocks, mouvements et coûts. C'est l'outil qui transforme une demande de rappel en quelques clics, au lieu d'une journée à éplucher des classeurs.",
      tip: "Entraînez-vous à remonter un lot de bout en bout avant un audit : le jour J, vous gagnerez un temps précieux.",
    },
    "nc-intro": {
      title: "À quoi sert une non-conformité",
      body: "Une non-conformité (NC) est la trace écrite d'un écart qualité : un corps étranger, une température hors bornes, une palette abîmée, une réclamation client. La déclarer, ce n'est pas de la paperasse : c'est ce qui permet de retrouver l'écart plus tard, de le chiffrer, et de prouver à un auditeur que vous l'avez traité.",
      tip: "Une NC se déclare même quand le problème est déjà réglé : c'est l'historique qui compte.",
    },
    "nc-page": {
      title: "Le registre des non-conformités",
      body: "Cette page est le registre de toutes vos NC, ouvertes comme clôturées. C'est la première chose qu'un auditeur demande à voir, et c'est aussi votre point d'entrée quotidien pour savoir ce qui reste à traiter.",
      tip: null,
    },
    "nc-liste": {
      title: "La liste",
      body: "Chaque ligne est une non-conformité, la plus récente en tête. Le numéro est attribué automatiquement (format NC + année + compteur) : c'est lui que vous citerez dans un échange avec un fournisseur ou un client.",
      tip: "Le numéro ne se ressaisit jamais à la main : il est généré à l'enregistrement.",
    },
    "nc-carte": {
      title: "Lire une NC d'un coup d'œil",
      body: "La carte porte l'essentiel : le type (d'où vient l'écart), la gravité, l'état d'avancement et l'objet concerné. Vous savez en une seconde si c'est une réclamation client critique ou un écart mineur constaté en réception.",
      tip: "La couleur suit la gravité : plus c'est vif, plus l'écart engage.",
    },
    "nc-filtre-etat": {
      title: "Filtrer par état",
      body: "Une NC vit en quatre états : ouverte, en traitement, clôturée, annulée. Le filtre « ouvertes » est celui du quotidien : c'est votre reste-à-faire qualité.",
      tip: "Une NC annulée reste visible : on n'efface pas un constat, on le qualifie.",
    },
    "nc-filtre-gravite": {
      title: "Filtrer par gravité",
      body: "Trois niveaux : mineure, majeure, critique. La gravité n'est pas décorative — c'est elle qui décide si l'écart se traite dans la semaine ou dans l'heure, et c'est le premier tri d'une revue qualité.",
      tip: "Critique se réserve à ce qui engage la sécurité alimentaire, le réglementaire ou un client majeur.",
    },
    "nc-filtre-type": {
      title: "Filtrer par type",
      body: "Le type dit d'où vient l'écart : réception, production, expédition, retour client, réclamation client, audit interne. C'est ce qui permet, en fin de mois, de répondre à « où perdons-nous le plus ? ».",
      tip: "Retour client = de la marchandise revient. Réclamation client = le client se plaint sans retour.",
    },
    "nc-recherche": {
      title: "Retrouver une NC",
      body: "La recherche porte sur le numéro, la description et l'objet lié. En contrôle, on vous demandera souvent une NC par son numéro : c'est le chemin le plus court.",
      tip: null,
    },
    "ncd-intro": {
      title: "Déclarer un écart",
      body: "Nous allons déclarer une non-conformité de production : un corps étranger repéré au conditionnement. L'important n'est pas la longueur du texte, c'est de rattacher l'écart au bon objet et de le qualifier correctement.",
      tip: null,
    },
    "ncd-open": {
      title: "Ouvrir la déclaration",
      body: "Cliquez sur le bouton de création. Le formulaire s'ouvre en fenêtre : rien n'est enregistré tant que vous n'avez pas validé.",
      tip: null,
    },
    "ncd-dialog": {
      title: "Le formulaire",
      body: "Il se lit en trois temps : ce qui s'est passé (type, gravité, description), sur quoi (le lien vers un lot, une palette, une commande, un article) et pourquoi (la cause). Seul le lien est réellement contraignant.",
      tip: "Au moins un lien est obligatoire, sauf pour une NC d'audit interne qui peut n'en porter aucun.",
    },
    "ncd-type": {
      title: "Le type",
      body: "Choisissez « Production » : l'écart a été constaté pendant la fabrication. Le type conditionne les liens qu'on vous proposera ensuite et alimente vos statistiques par origine.",
      tip: null,
    },
    "ncd-gravite": {
      title: "La gravité",
      body: "Un corps étranger dans un produit alimentaire engage la sécurité du consommateur : c'est au minimum « Majeure ». Ce choix pilote l'urgence de traitement et ressortira dans votre revue qualité.",
      tip: "Dans le doute, qualifiez plus haut : on peut toujours requalifier à la baisse après analyse.",
    },
    "ncd-description": {
      title: "Décrire les faits",
      body: "Écrivez ce qui a été constaté, pas ce que vous en concluez : « corps étranger métallique repéré au détecteur, ligne 1, 14 h 20 ». Un auditeur lira cette phrase deux ans plus tard, sans vous pour l'expliquer.",
      tip: "Les faits ici, l'analyse dans la cause : les mélanger rend la NC inexploitable.",
    },
    "ncd-lien": {
      title: "Rattacher à un lot",
      body: "C'est le champ qui donne sa valeur à la NC : sans lien, vous avez un post-it ; avec le lot, vous avez une traçabilité. Depuis ce lot, vous saurez plus tard quels clients ont été livrés.",
      tip: "Vous pouvez aussi rattacher une palette, une commande, un fournisseur ou un article selon le type.",
    },
    "ncd-quantite": {
      title: "La quantité concernée",
      body: "Indiquez combien d'unités sont touchées, pas la taille du lot. C'est cette quantité qui sera valorisée en coût matière si vous décidez du rebut.",
      tip: "Une NC peut ne concerner qu'une partie d'un lot : c'est le cas le plus fréquent.",
    },
    "ncd-cause": {
      title: "La cause (5M)",
      body: "Classez la cause racine dans l'une des cinq familles : Matière, Machine, Méthode, Main-d'œuvre, Milieu — auxquelles s'ajoute Mesure. Un détecteur qui remonte du métal pointe la Machine.",
      tip: "Ce classement ne sert à rien sur une NC isolée ; il devient précieux quand vous en avez cinquante.",
    },
    "ncd-detection": {
      title: "Qui a détecté ?",
      body: "Interne si c'est vous qui l'avez vu, externe si c'est le client ou un contrôle officiel. Cet axe alimente un indicateur qu'on regarde en revue de direction : la part d'écarts qui vous ont échappé.",
      tip: "Un taux d'échappées qui monte est un signal plus fort que le nombre total de NC.",
    },
    "ncd-zone": {
      title: "Isoler physiquement la marchandise",
      body: "Cette option déplace la quantité concernée en zone non conforme. Ce n'est pas qu'un drapeau : le stock bouge réellement, la marchandise cesse d'être disponible à la vente et à la production.",
      tip: "À activer dès que le produit ne doit plus partir — c'est plus sûr qu'une consigne orale.",
    },
    "ncd-save": {
      title: "Enregistrer",
      body: "Validez : la NC reçoit son numéro et s'ouvre à l'état « Ouverte ». Elle apparaît immédiatement dans le registre et dans le cockpit qualité.",
      tip: null,
    },
    "ncd-done": {
      title: "Elle est dans le registre",
      body: "Votre non-conformité est déclarée. À ce stade elle constate, elle ne décide rien : c'est l'instruction, à la section suivante, qui tranchera le sort de la marchandise.",
      tip: null,
    },
    "nct-intro": {
      title: "Instruire, puis trancher",
      body: "Une NC ouverte n'a pas encore de conclusion. L'instruire, c'est comprendre pourquoi c'est arrivé ; la clôturer, c'est décider ce qu'on fait de la marchandise et chiffrer ce que l'écart a coûté.",
      tip: null,
    },
    "nct-open": {
      title: "Ouvrir la fiche",
      body: "Cliquez sur la carte pour ouvrir le détail. Vous y trouverez tout l'historique de la NC : qui l'a créée, qui l'a modifiée, et à quel moment elle a changé d'état.",
      tip: null,
    },
    "nct-detail": {
      title: "La fiche complète",
      body: "Tout est là : la qualification, les liens, les photos, l'historique des états. C'est cette fiche qu'on imprime pour un auditeur ou qu'on joint à une réclamation fournisseur.",
      tip: "Les photos comptent double en audit : un constat illustré ne se discute pas.",
    },
    "nct-edit": {
      title: "Compléter au fil de l'analyse",
      body: "Une NC se complète dans le temps : on découvre la cause réelle deux jours plus tard, on ajoute une photo, on affine la quantité. Tant qu'elle est ouverte, elle reste modifiable.",
      tip: null,
    },
    "nct-cout": {
      title: "Ce que l'écart coûte",
      body: "Le coût d'une NC se compose de trois choses : la matière perdue et la main-d'œuvre déjà incorporée, calculées automatiquement depuis les mouvements de stock, et un coût supplémentaire que vous saisissez (tri, retraitement, analyse en laboratoire, avoir client).",
      tip: "Le coût supplémentaire peut exister seul : une réclamation sans perte matière coûte quand même du temps.",
    },
    "nct-close-open": {
      title: "Lancer la clôture",
      body: "Cliquez sur Clôturer. Une fenêtre s'ouvre : c'est là qu'on tranche, pas dans la fiche. Rien n'est figé tant que vous n'avez pas confirmé.",
      tip: null,
    },
    "nct-close-dialog": {
      title: "La fenêtre de clôture",
      body: "Elle demande trois choses : ce qu'on fait de la marchandise, ce que ça a coûté en plus, et un commentaire de clôture. Les trois se retrouveront dans le dossier d'audit.",
      tip: null,
    },
    "nct-decision": {
      title: "La décision",
      body: "Quatre issues possibles : rebut, retouche, acceptation en dérogation, retour fournisseur. Un corps étranger métallique ne se retouche pas : c'est le rebut.",
      tip: "L'acceptation en dérogation doit rester exceptionnelle et tracée — un auditeur regardera qui l'a signée.",
    },
    "nct-cout-close": {
      title: "Le coût supplémentaire",
      body: "Saisissez ce que l'écart a coûté au-delà de la matière : le temps de tri, le nettoyage de la ligne, l'analyse en laboratoire. C'est ce chiffre qui rend le coût de la non-qualité discutable en réunion.",
      tip: null,
    },
    "nct-commentaire": {
      title: "Le commentaire de clôture",
      body: "Expliquez ce qui a été fait et ce qui a été mis en place pour que ça ne se reproduise pas. C'est la partie que l'auditeur lit en premier — bien plus que la description initiale.",
      tip: null,
    },
    "nct-confirm": {
      title: "Confirmer la clôture",
      body: "Confirmez : la NC passe à l'état clôturé, avec sa date, son auteur et sa décision. Le mouvement de stock correspondant à la décision est généré.",
      tip: null,
    },
    "nct-reopen": {
      title: "Si le problème revient",
      body: "Une NC clôturée peut être rouverte. C'est le bon geste quand le même écart réapparaît sur un autre lot : on rouvre plutôt que de recréer, et l'historique reste d'un seul tenant.",
      tip: null,
    },
    "nct-outro": {
      title: "Et après ?",
      body: "L'analyse ouvre la vue statistique : combien de NC, par type, par gravité, par cause, et ce qu'elles ont coûté. C'est ce qu'on présente en revue de direction — une NC isolée ne prouve rien, une tendance si.",
      tip: "Regardez d'abord la cause qui revient le plus : c'est là que l'action corrective rapporte.",
    },
    "cq-intro": {
      title: "Votre point qualité du matin",
      body: "Le cockpit répond à une seule question : qu'est-ce qui demande mon attention aujourd'hui ? Il n'invente rien — il agrège vos contrôles, vos non-conformités et vos alertes sur la période choisie.",
      tip: "Cinq minutes chaque matin valent mieux qu'une revue mensuelle de deux heures.",
    },
    "cq-vue": {
      title: "La vue d'ensemble",
      body: "Trois blocs, dans un ordre qui n'est pas arbitraire : ce qui vient d'arriver, ce qui traîne, et comment se comportent vos contrôles. On les lit dans cet ordre.",
      tip: null,
    },
    "cq-alertes": {
      title: "Les alertes récentes",
      body: "Ce bloc remonte ce que le système a détecté tout seul : lots proches de péremption, contrôles hors seuil, non-conformités critiques ouvertes. C'est de l'information poussée, pas une liste que vous devez tenir.",
      tip: null,
    },
    "cq-alerte-ligne": {
      title: "Une alerte",
      body: "Chaque ligne porte son objet et sa date. Cliquez dessus pour aller droit au lot, au contrôle ou à la non-conformité concernée — sans repasser par la recherche.",
      tip: null,
    },
    "cq-retards": {
      title: "Les actions en retard",
      body: "Ici, ce que quelqu'un devait faire et n'a pas fait : contrôles non saisis, non-conformités ouvertes depuis trop longtemps, listes de tâches non réalisées. C'est le bloc qui fait perdre les audits.",
      tip: "Un retard qui dure devient une non-conformité système — traitez-le avant qu'il ne se transforme.",
    },
    "cq-retard-ligne": {
      title: "Un retard",
      body: "La ligne dit quoi, depuis quand, et sur quel objet. L'ancienneté compte plus que le nombre : dix contrôles en retard d'un jour valent mieux qu'un seul oublié depuis trois semaines.",
      tip: null,
    },
    "cq-conformite": {
      title: "La conformité des contrôles",
      body: "Ce bloc répond à « est-ce que ce qu'on mesure est bon ? ». Il compare, sur la période, les contrôles conformes et non conformes — par contrôle, pas en global.",
      tip: null,
    },
    "cq-conformite-ligne": {
      title: "Un contrôle",
      body: "Une ligne par définition de contrôle, avec son taux de conformité. Celui qui échoue le plus souvent est votre meilleur candidat à une action corrective : c'est là que l'effort rapporte.",
      tip: "Un contrôle conforme à 100 % depuis six mois mérite aussi une question : mesure-t-il encore quelque chose ?",
    },
    "cqp-intro": {
      title: "Choisir la fenêtre",
      body: "Tout ce que vous venez de lire dépend d'une période. Par défaut, le cockpit regarde le mois écoulé — ce n'est pas la bonne fenêtre pour préparer un audit annuel.",
      tip: null,
    },
    "cqp-periode": {
      title: "Les raccourcis de période",
      body: "Cliquez sur 3 mois. Les trois blocs se recalculent d'un coup : une tendance sur un trimestre ne se lit pas comme une photo du mois.",
      tip: "1 mois pour le pilotage courant, 3 à 12 mois pour préparer une revue ou un audit.",
    },
    "cqp-dates": {
      title: "Une période sur mesure",
      body: "Les deux champs de date permettent de coller à une période précise : une campagne, un trimestre comptable, l'intervalle entre deux audits.",
      tip: null,
    },
    "cqp-rapport": {
      title: "Le rapport qualité",
      body: "Ce bouton produit le rapport de la période : indicateurs, conformité par contrôle, non-conformités et leur coût. C'est le document qu'on emmène en revue de direction ou qu'on pose sur la table d'un auditeur.",
      tip: null,
    },
    "cqp-outro": {
      title: "Le réflexe à prendre",
      body: "Le matin, période courte et on traite les retards. Avant une revue ou un audit, période longue et on sort le rapport. Le même écran répond aux deux besoins.",
      tip: null,
    },
    "chk-intro": {
      title: "Deux métiers, un seul écran",
      body: "Une liste de tâches sert à deux choses très différentes : la DÉFINIR (quelles tâches, à quelle fréquence, par qui) et la RÉALISER (cocher, sur le terrain, ce qui a été fait aujourd'hui). Confondre les deux est la première source d'erreur ici.",
      tip: "On définit une fois, on réalise tous les jours.",
    },
    "chk-listes": {
      title: "Vos listes",
      body: "Chaque carte est une liste définie : nettoyage d'une ligne, tournée hygiène, maintenance préventive, relevés réglementaires. Elles s'exécutent ensuite à leur rythme propre.",
      tip: null,
    },
    "chk-carte": {
      title: "Une liste",
      body: "La carte porte le nom de la liste, son type et sa périodicité. C'est aussi de là qu'on ouvre la définition pour la modifier.",
      tip: null,
    },
    "chk-filtre": {
      title: "Filtrer",
      body: "Le filtre sépare les listes journalières des mensuelles. Sur une usine qui en compte vingt, c'est ce qui rend l'écran lisible le matin.",
      tip: null,
    },
    "chk-acces": {
      title: "Accéder à la réalisation",
      body: "Ce raccourci ouvre la grille de réalisation de la liste : c'est là que les opérateurs cochent. C'est le passage du paramétrage au terrain.",
      tip: null,
    },
    "chkc-intro": {
      title: "Définir une liste",
      body: "Nous allons créer une liste de nettoyage quotidienne pour la ligne 1. Trois décisions à prendre : quand elle tombe, qui doit la faire, et quelles tâches elle contient.",
      tip: null,
    },
    "chkc-open": {
      title: "Créer la liste",
      body: "Cliquez pour ouvrir le formulaire de définition.",
      tip: null,
    },
    "chkc-dialog": {
      title: "Le formulaire de définition",
      body: "Il se lit de haut en bas : d'abord ce qu'est la liste, ensuite quand elle tombe, enfin qui la voit. Les tâches viennent après.",
      tip: null,
    },
    "chkc-denomination": {
      title: "Le nom",
      body: "Nommez la liste pour qu'un opérateur la reconnaisse sans l'ouvrir : l'objet et la fréquence. « Nettoyage ligne 1 — quotidien » se comprend seul.",
      tip: "Évitez les noms génériques : « Checklist 2 » ne dit rien à celui qui la prend en main.",
    },
    "chkc-type": {
      title: "Journalière ou mensuelle",
      body: "Ce choix change la grille de réalisation : une liste journalière se coche jour par jour, une mensuelle se coche sur un calendrier du mois. Il se décide maintenant.",
      tip: null,
    },
    "chkc-jours": {
      title: "Les jours concernés",
      body: "Cochez les jours où la liste tombe. Une ligne qui ne tourne pas le dimanche ne doit pas générer d'occurrence ce jour-là — sinon vous fabriquez un retard permanent.",
      tip: null,
    },
    "chkc-heure": {
      title: "L'heure",
      body: "L'heure à laquelle la tâche est attendue. Elle sert de référence au calcul du retard : sans elle, une tâche n'est jamais « en retard », seulement « pas faite ».",
      tip: null,
    },
    "chkc-tolerance": {
      title: "La tolérance",
      body: "La marge acceptée autour de l'heure prévue. Un nettoyage attendu à 14 h avec une tolérance d'une heure reste conforme à 14 h 45 — c'est ce qui évite de transformer l'atelier en usine à alertes.",
      tip: "Une tolérance trop serrée produit des retards qu'on finit par ignorer : c'est pire que pas de tolérance.",
    },
    "chkc-users": {
      title: "Qui doit la faire",
      body: "Désignez les utilisateurs concernés. Une liste sans destinataire existe mais n'apparaît dans la journée de personne — c'est la panne la plus fréquente sur ce module.",
      tip: null,
    },
    "chkc-of": {
      title: "Rattacher à un OF",
      body: "Une liste peut être liée à un ordre de fabrication plutôt qu'à un calendrier : elle tombe alors avec la production, pas avec la date. C'est le bon réglage pour un nettoyage de fin de série.",
      tip: null,
    },
    "chkc-add-task": {
      title: "Ajouter une tâche",
      body: "Une liste sans tâche ne sert à rien. Ajoutons la première.",
      tip: null,
    },
    "chkc-task-label": {
      title: "L'intitulé de la tâche",
      body: "Écrivez un geste, pas un thème : « démonter et rincer le convoyeur » se coche, « propreté » ne se coche pas. Un intitulé vague produit des cases cochées sans travail derrière.",
      tip: "Une tâche = un geste vérifiable par quelqu'un d'autre.",
    },
    "chkc-task-desc": {
      title: "La consigne",
      body: "La description porte le détail opératoire : produit à utiliser, dosage, temps de contact, point de vigilance. C'est ce que lit quelqu'un qui fait la tâche pour la première fois.",
      tip: null,
    },
    "chkc-task-save": {
      title: "Valider la tâche",
      body: "Enregistrez la tâche. Répétez l'opération pour chaque geste : l'ordre d'affichage sera celui de la saisie.",
      tip: null,
    },
    "chkc-save": {
      title: "Enregistrer la liste",
      body: "Validez : la liste est définie et commencera à générer ses occurrences aux jours et heures prévus.",
      tip: null,
    },
    "chkr-intro": {
      title: "Côté terrain",
      body: "On passe de l'autre côté : ce que voit l'opérateur qui prend son poste. Ici on ne définit plus rien, on coche ce qui a été fait.",
      tip: null,
    },
    "chkr-jour": {
      title: "La grille du jour",
      body: "Une colonne par occurrence, une ligne par tâche. L'état de chaque case dit si c'est fait, à faire, ou en retard par rapport à l'heure et à la tolérance définies.",
      tip: null,
    },
    "chkr-cellule": {
      title: "Cocher une tâche",
      body: "Cliquez sur la case pour déclarer la tâche faite. La saisie porte l'heure et l'utilisateur : c'est cette trace, pas la case elle-même, qui vaut preuve en audit.",
      tip: "Cocher après coup reste possible, mais l'heure enregistrée sera celle du clic — pas celle du geste.",
    },
    "chkr-navigation": {
      title: "Changer de jour",
      body: "Ces flèches déplacent la grille dans le temps. C'est par là qu'on revient sur la veille pour comprendre un trou — ou qu'on prépare le lendemain.",
      tip: null,
    },
    "chkr-mois": {
      title: "La vue du mois",
      body: "Pour les listes mensuelles, la grille s'étale sur le mois : on voit d'un coup les jours tenus et les trous. C'est la vue qu'on montre en audit.",
      tip: null,
    },
    "chkr-save": {
      title: "Enregistrer la saisie",
      body: "Validez pour que les cases cochées soient persistées. Tant que ce n'est pas enregistré, rien n'est tracé.",
      tip: null,
    },
    "chkr-outro": {
      title: "Ce qui remonte ailleurs",
      body: "Les tâches non faites remontent dans le cockpit qualité, au bloc des actions en retard. La liste n'est donc pas un écran isolé : c'est une des sources de votre point du matin.",
      tip: null,
    },
    "mvt-intro": {
      title: "D'où vient votre stock",
      body: "Une quantité en stock n'est jamais saisie : elle est la SOMME de mouvements. Réception, fabrication, consommation, expédition, inventaire — chacun ajoute ou retire. Quand un stock surprend, la réponse est toujours ici.",
      tip: "C'est le premier écran à ouvrir quand quelqu'un dit « le stock est faux ».",
    },
    "mvt-section": {
      title: "L'historique complet",
      body: "Tous les mouvements, tous lots confondus, du plus récent au plus ancien. Chaque ligne porte son type, sa quantité, son emplacement de départ et d'arrivée, sa date et son auteur.",
      tip: null,
    },
    "mvt-recherche": {
      title: "Chercher",
      body: "La recherche porte sur le numéro de lot et l'article. C'est le chemin le plus court quand vous partez d'un lot précis.",
      tip: null,
    },
    "mvt-filtre-type": {
      title: "Filtrer par type",
      body: "Le type dit ce qui s'est passé : réception, fabrication, consommation en production, expédition, transfert, inventaire, perte. C'est le filtre qui répond à « qui a sorti ces 40 kg ? ».",
      tip: "Une sortie inexpliquée est presque toujours une consommation de production ou une expédition.",
    },
    "mvt-filtre-dates": {
      title: "Filtrer par période",
      body: "Bornez la fenêtre autour du moment où l'écart est apparu. Sur une base vivante, sans borne de date la liste est trop longue pour être lue.",
      tip: null,
    },
    "mvt-filtre-adresses": {
      title: "Filtrer par emplacement",
      body: "Utile quand l'écart est localisé : une chambre froide, une zone de préparation, un entrepôt déporté. Vous ne voyez alors que ce qui est entré ou sorti de là.",
      tip: null,
    },
    "mvt-source": {
      title: "Remonter au lot",
      body: "Depuis un mouvement, ce raccourci ouvre le lot concerné. De là, sa traçabilité complète : d'où il vient, ce qu'il a produit, à qui il est parti.",
      tip: null,
    },
    "mvt-clear": {
      title: "Repartir de zéro",
      body: "Ce bouton efface tous les filtres d'un coup. Le réflexe à prendre quand la liste paraît vide : c'est presque toujours un filtre oublié, pas une absence de données.",
      tip: null,
    },
    "mvtc-intro": {
      title: "Corriger, avec précaution",
      body: "Un mouvement est une écriture comptable de stock : on ne le réécrit pas à la légère. Seuls les mouvements d'inventaire — ceux que vous avez saisis — restent modifiables ; un mouvement produit par une réception ou une expédition, non.",
      tip: "Pour corriger un mouvement qui n'est pas modifiable, on passe par un inventaire, jamais par la suppression.",
    },
    "mvtc-edit": {
      title: "Modifier un mouvement d'inventaire",
      body: "Ce bouton n'apparaît que sur les mouvements d'inventaire. C'est volontaire : ce sont les seuls dont vous êtes l'auteur, donc les seuls que vous pouvez rectifier.",
      tip: null,
    },
    "mvtc-quantite": {
      title: "La quantité",
      body: "Corrigez la quantité constatée. Le stock du lot se recalcule immédiatement : ce n'est pas une correction cosmétique, c'est le stock réel qui bouge.",
      tip: null,
    },
    "mvtc-date": {
      title: "La date",
      body: "La date décide de l'ORDRE des mouvements, donc du stock à chaque instant. La reculer d'une journée peut changer le stock d'hier — et les analyses qui s'appuient dessus.",
      tip: "Ne reculez une date que si le geste physique a vraiment eu lieu ce jour-là.",
    },
    "mvtc-commentaire": {
      title: "Le commentaire",
      body: "Dites pourquoi vous corrigez. Dans six mois, personne ne se souviendra — et c'est exactement la ligne qu'un auditeur demandera à expliquer.",
      tip: null,
    },
    "mvtc-supprimer": {
      title: "Supprimer",
      body: "La suppression existe, mais elle efface une trace. Préférez toujours un mouvement correctif, qui laisse l'histoire lisible : on voit l'erreur ET sa correction.",
      tip: null,
    },
    "mvtc-outro": {
      title: "La bonne habitude",
      body: "Devant un écart : filtrer, comprendre, puis corriger par inventaire. Jamais l'inverse — corriger avant d'avoir compris crée un second écart, et vous en aurez deux à expliquer.",
      tip: null,
    },
    "prep-intro": {
      title: "L'écran du quai",
      body: "Cet écran est fait pour être tenu d'une main, sur un téléphone ou une douchette, entre deux palettes. Il ne pilote rien : il exécute. Le pilotage, c'est l'écran Préparation, vu du bureau.",
      tip: "Même commande, deux points de vue : ici on prélève, là-bas on décide.",
    },
    "prep-recherche": {
      title: "Trouver sa commande",
      body: "Cherchez par client ou par numéro de commande. La liste ne montre que ce qui est à préparer : inutile de filtrer les commandes déjà parties.",
      tip: null,
    },
    "prep-mode": {
      title: "Le mode de livraison",
      body: "Ce sélecteur change l'horizon affiché : ce qui part aujourd'hui, demain, cette semaine. C'est ce qui évite de préparer trop tôt une commande dont la DLC compte.",
      tip: null,
    },
    "prep-refresh": {
      title: "Rafraîchir",
      body: "Sur le quai, plusieurs personnes travaillent sur la même commande. Ce bouton récupère ce que les autres ont prélevé pendant que vous étiez dans l'allée.",
      tip: null,
    },
    "prepp-intro": {
      title: "Prélever",
      body: "Préparer, c'est décider pour chaque lot : sur palette, en direct, ou mis de côté. Ces trois gestes couvrent 95 % du travail au quai.",
      tip: null,
    },
    "prepp-scan": {
      title: "Scanner",
      body: "Le scan est le geste par défaut : il identifie le lot sans erreur de frappe et l'affecte à la ligne correspondante. C'est ce qui rend la traçabilité fiable sans ralentir personne.",
      tip: "Un lot scanné qui n'appartient pas à la commande est refusé — c'est voulu.",
    },
    "prepp-auto": {
      title: "Préparation automatique",
      body: "Ce bouton affecte d'un coup les lots proposés par le système, en respectant l'ordre des dates limites. À réserver aux commandes simples : sur un cas particulier, on affecte à la main.",
      tip: null,
    },
    "prepp-palette": {
      title: "Mettre sur palette",
      body: "Le lot rejoint une palette d'expédition, qui recevra son propre code d'identification. C'est le cas normal dès qu'on expédie par palette entière.",
      tip: null,
    },
    "prepp-directe": {
      title: "Livraison directe",
      body: "Le lot part sans passer par une palette : colis isolé, retrait sur place, petite quantité. La traçabilité reste la même, seul le contenant change.",
      tip: null,
    },
    "prepp-garde": {
      title: "Mettre de côté",
      body: "Le lot est réservé pour cette commande mais reste en attente : on l'a repéré, on ne l'a pas encore chargé. Utile quand il manque de la place sur le quai.",
      tip: null,
    },
    "prepp-retirer": {
      title: "Retirer un lot",
      body: "Vous vous êtes trompé de lot : ce bouton l'enlève de la préparation et le rend disponible pour une autre commande. Rien n'est perdu.",
      tip: null,
    },
    "prepp-picking": {
      title: "Le bon de picking",
      body: "La liste de ce qu'il reste à aller chercher, dans l'ordre de l'entrepôt. C'est le papier qu'on prend avec soi quand on ne veut pas manipuler l'écran en allée.",
      tip: null,
    },
    "prepp-bl": {
      title: "Le bon provisoire",
      body: "Un bon de livraison de contrôle, imprimé avant l'expédition définitive. Il sert à vérifier avec le chauffeur ce qui monte dans le camion — ce n'est pas le document final.",
      tip: null,
    },
    "prepp-retour": {
      title: "Revenir à la commande",
      body: "Ce retour ramène au détail de la commande, pour vérifier l'avancement ligne par ligne avant de clore la préparation.",
      tip: null,
    },
    "usr-intro": {
      title: "Rôle et profil de droits",
      body: "Un utilisateur porte deux choses : un RÔLE (ce qu'il est dans le système) et un PROFIL DE DROITS, qui dit quels modules il voit. Le rôle seul ne suffit pas — c'est l'erreur qui produit le fameux « mon collègue ne voit pas le menu Factures ».",
      tip: "Si quelqu'un ne voit pas un écran, regardez son profil de droits avant tout le reste.",
    },
    "usr-onglet": {
      title: "L'onglet Utilisateurs",
      body: "La liste des comptes de votre organisation, avec leur rôle, leur profil et leur état. C'est ici qu'on ouvre et qu'on ferme les accès.",
      tip: null,
    },
    "usr-add": {
      title: "Créer un compte",
      body: "Cliquez pour ouvrir le formulaire. Un compte se crée en trois informations : un identifiant, un rôle, un profil de droits.",
      tip: null,
    },
    "usr-email": {
      title: "L'identifiant",
      body: "C'est avec cette valeur que la personne se connectera. Utilisez son adresse professionnelle : c'est stable, unique, et elle sert aussi aux envois automatiques.",
      tip: null,
    },
    "usr-role": {
      title: "Le rôle",
      body: "« Utilisateur » convient à l'immense majorité des comptes : c'est le rôle de tous vos collaborateurs. Réservez l'administrateur à ceux qui doivent paramétrer l'organisation elle-même.",
      tip: "Un rôle d'administrateur de plus, ce sont des droits qu'on ne peut plus restreindre par le profil.",
    },
    "usr-pass": {
      title: "Le profil de droits",
      body: "C'est LE champ qui décide de ce que la personne verra. Sans profil, elle se connecte sur une application presque vide — et vous croirez à un bug.",
      tip: "Créez quelques profils types (atelier, qualité, commerce) plutôt qu'un profil par personne.",
    },
    "usr-save": {
      title: "Enregistrer",
      body: "Validez : le compte est créé et la personne peut se connecter. Elle changera son mot de passe à la première connexion.",
      tip: null,
    },
    "usr-recherche": {
      title: "Retrouver un compte",
      body: "Sur une équipe de trente personnes, la recherche est plus rapide que le défilement. On l'utilise surtout pour vérifier un profil quand quelqu'un signale un écran manquant.",
      tip: null,
    },
    "usr-desactiver": {
      title: "Désactiver plutôt que supprimer",
      body: "Quand quelqu'un part, désactivez son compte : l'accès est coupé, mais tout ce qu'il a saisi reste attribué à son nom. Supprimer casserait la traçabilité de ses saisies.",
      tip: "Un compte désactivé se réactive — c'est le bon geste pour un saisonnier qui revient.",
    },
    "pass-intro": {
      title: "Pourquoi un profil",
      body: "Régler les droits compte par compte devient ingérable dès la dixième personne. Un profil se définit une fois et s'attribue autant de fois qu'on veut : le jour où un droit change, on le change à un seul endroit.",
      tip: null,
    },
    "pass-onglet": {
      title: "L'onglet des profils",
      body: "La liste de vos profils de droits. Trois ou quatre suffisent à couvrir une usine : atelier, qualité, commerce, administration.",
      tip: null,
    },
    "pass-add": {
      title: "Créer un profil",
      body: "Ouvrez le formulaire pour définir un nouveau profil.",
      tip: null,
    },
    "pass-form": {
      title: "Le formulaire du profil",
      body: "Chaque ligne est un module de l'application. Cocher, c'est rendre l'entrée visible dans le menu et les écrans accessibles. Décocher, c'est les faire disparaître, pas seulement les griser.",
      tip: null,
    },
    "pass-nom": {
      title: "Le nom du profil",
      body: "Nommez-le par le POSTE, pas par la personne : « Opérateur atelier » se réutilise, « Profil de Marc » meurt avec Marc.",
      tip: null,
    },
    "pass-heritage": {
      title: "Partir d'un profil existant",
      body: "L'héritage recopie les droits d'un profil déjà défini : pratique pour créer « Chef d'équipe » à partir d'« Opérateur » en ajoutant deux modules, plutôt que de tout recocher.",
      tip: null,
    },
    "pass-save": {
      title: "Enregistrer le profil",
      body: "Validez : le profil devient attribuable aux comptes. Les utilisateurs qui le portent déjà voient le changement à leur prochaine connexion.",
      tip: null,
    },
    "pass-outro": {
      title: "Le réflexe de dépannage",
      body: "« Je ne vois pas cet écran » se résout presque toujours en trois clics : ouvrir le compte, lire son profil, vérifier la case. Avant de soupçonner un bug, regardez là.",
      tip: null,
    },
    "bio-intro": {
      title: "Ce que l'audit bio prouve",
      body: "Un certificateur pose une question simple : avez-vous acheté assez de bio pour vendre ce que vous avez vendu en bio ? L'audit répond en confrontant, sur une période, les entrées et les sorties d'un article. C'est le bilan matière de la certification.",
      tip: "Le faire avant la visite évite de le découvrir devant l'auditeur.",
    },
    "bio-article": {
      title: "L'article audité",
      body: "Choisissez l'article sur lequel porte le contrôle. L'audit se fait article par article : c'est ainsi que le certificateur procède, en piochant quelques références.",
      tip: null,
    },
    "bio-debut": {
      title: "Le début de période",
      body: "La date à partir de laquelle on compte les entrées et les sorties. Elle correspond en général à votre dernier audit ou à un début d'exercice.",
      tip: null,
    },
    "bio-fin": {
      title: "La fin de période",
      body: "La borne haute du contrôle, en général aujourd'hui. Entre les deux dates, tout ce qui est entré et tout ce qui est sorti sera compté.",
      tip: null,
    },
    "bio-inventaires": {
      title: "Les inventaires de bornes",
      body: "Un bilan matière n'a de sens qu'entre deux stocks connus : ce qu'il y avait au début, ce qu'il reste à la fin. Sans ces bornes, un écart peut toujours s'expliquer par du stock dormant.",
      tip: "C'est la partie qu'on oublie, et celle qui rend le bilan incontestable.",
    },
    "bio-inventorier": {
      title: "Lancer un inventaire de borne",
      body: "Si la borne manque, ce bouton ouvre directement l'inventaire correspondant. On compte, on clôture, puis on revient ici : l'audit disposera alors de son point de départ.",
      tip: null,
    },
    "biol-run": {
      title: "Lancer l'audit",
      body: "Le calcul remonte toute la chaîne : réceptions bio, productions, consommations, expéditions. Sur une longue période, comptez quelques secondes.",
      tip: null,
    },
    "biol-bilan": {
      title: "Lire l'écart",
      body: "Le bilan confronte ce qui est entré et ce qui est sorti. Un écart n'est pas forcément une fraude : pertes de process, freintes, arrondis. Ce qu'on doit pouvoir faire, c'est l'EXPLIQUER — pas le nier.",
      tip: "Un écart expliqué et documenté passe ; un écart découvert par l'auditeur, non.",
    },
    "biol-prod": {
      title: "Détailler les productions",
      body: "Cet affichage déplie les ordres de fabrication de la période : combien a été produit, à partir de quoi. C'est là qu'on retrouve la perte de process qui explique l'écart.",
      tip: null,
    },
    "biol-traca": {
      title: "Remonter la chaîne",
      body: "Cette bascule affiche la traçabilité amont : quels lots de matière ont alimenté les produits finis de la période, et de quels fournisseurs ils venaient. C'est la question suivante du certificateur.",
      tip: null,
    },
    "biol-config": {
      title: "Ajuster le paramétrage",
      body: "Certains articles n'ont pas à entrer dans le bilan (emballages, auxiliaires). Ce réglage sert à cadrer le périmètre une bonne fois, plutôt qu'à justifier chaque année les mêmes exclusions.",
      tip: null,
    },
    "biol-outro": {
      title: "Avant la visite",
      body: "Lancez l'audit sur vos références bio les plus vendues quelques semaines avant la visite. Un écart trouvé en avance se documente ; trouvé le jour même, il se subit.",
      tip: null,
    },
    "eq-intro": {
      title: "Une équipe n'est pas un droit",
      body: "Une équipe regroupe des personnes pour la saisie des heures et le suivi d'activité. Elle ne donne accès à rien : les accès, ce sont les profils de droits. Confondre les deux fait chercher longtemps.",
      tip: null,
    },
    "eq-liste": {
      title: "Vos équipes",
      body: "Chaque carte est une équipe, avec ses responsables et ses membres. Sur une usine, on en compte rarement plus de cinq ou six : matin, après-midi, nuit, maintenance, expédition.",
      tip: null,
    },
    "eq-add": {
      title: "Créer une équipe",
      body: "Cliquez pour ouvrir le formulaire.",
      tip: null,
    },
    "eq-dialog": {
      title: "Le formulaire",
      body: "Trois informations suffisent : un nom, des responsables, des membres. Rien d'autre n'est requis.",
      tip: null,
    },
    "eq-nom": {
      title: "Le nom",
      body: "Nommez l'équipe comme on l'appelle dans l'atelier : « Équipe du matin » se reconnaît, « Équipe A » demande un décodeur.",
      tip: null,
    },
    "eq-leaders": {
      title: "Les responsables",
      body: "Un responsable voit et saisit les heures de toute son équipe, pas seulement les siennes. C'est ce qui permet au chef d'équipe de pointer pour son monde en fin de poste.",
      tip: null,
    },
    "eq-membres": {
      title: "Les membres",
      body: "Ajoutez les personnes de l'équipe. Une même personne peut appartenir à plusieurs équipes : c'est le cas normal d'un polyvalent qui tourne entre deux lignes.",
      tip: null,
    },
    "eq-save": {
      title: "Enregistrer",
      body: "Validez : l'équipe apparaît dans la matrice de saisie des heures, où ses membres se pointent en une grille hebdomadaire.",
      tip: null,
    },
    "eq-edit": {
      title: "Faire évoluer l'équipe",
      body: "Les équipes bougent : arrivées, départs, changements de poste. Mettez-les à jour plutôt que d'en créer de nouvelles — l'historique des heures reste rattaché aux personnes, pas à l'équipe.",
      tip: null,
    },
    "eq-outro": {
      title: "À quoi ça sert ensuite",
      body: "Une fois les équipes en place, la saisie des heures se fait par grille hebdomadaire, équipe par équipe. C'est ce qui alimente le coût de main-d'œuvre de vos ordres de fabrication.",
      tip: null,
    },
    "rec-intro": {
      title: "Formuler avant de produire",
      body: "Ce module sert à mettre au point une recette AVANT qu'elle devienne un article du catalogue : on essaie, on chiffre, on compare, et seulement ensuite on crée le produit fini. Rien de ce qu'on fait ici ne touche votre production.",
      tip: "Un projet peut porter plusieurs essais : c'est fait pour itérer.",
    },
    "rec-creer": {
      title: "Créer un projet",
      body: "Un projet, c'est une intention : « faire une soupe potimarron bio à moins de 1,20 € le litre ». Les essais viendront dessous.",
      tip: null,
    },
    "rec-nom": {
      title: "Le nom du projet",
      body: "Nommez le produit visé, pas l'essai. Le nom restera quand les essais, eux, se succéderont.",
      tip: null,
    },
    "rec-descriptif": {
      title: "Le descriptif",
      body: "Notez la contrainte de départ : un client, un cahier des charges, une allégation visée, une saisonnalité. C'est ce qu'on relit six mois plus tard pour savoir pourquoi la recette est ce qu'elle est.",
      tip: null,
    },
    "rec-ouvrir": {
      title: "Ouvrir le projet",
      body: "Créez et entrez dans le projet : c'est là que se composent les essais.",
      tip: null,
    },
    "reci-intro": {
      title: "Un essai",
      body: "Un essai est une version datée de la formule. On en crée un nouveau à chaque changement notable plutôt que d'écraser le précédent : c'est ce qui permet de revenir en arrière et de comparer.",
      tip: null,
    },
    "reci-nouvel-essai": {
      title: "Nouvel essai",
      body: "Ce bouton ouvre une nouvelle version, en repartant de la précédente. C'est l'itération normale : on change un ingrédient, on regarde l'effet sur le coût et sur l'étiquette.",
      tip: null,
    },
    "reci-courant": {
      title: "L'essai courant",
      body: "Ce marqueur indique sur quelle version vous travaillez. Les essais figés, eux, ne bougent plus : ils gardent la trace de ce qui a été goûté et validé ce jour-là.",
      tip: null,
    },
    "reci-composant": {
      title: "Ajouter un composant",
      body: "Posez les ingrédients et leurs quantités. Un composant peut venir de votre catalogue — il apporte alors son prix et ses allergènes — ou être provisoire, le temps de l'essai.",
      tip: "Un composant provisoire ne bloque rien, mais il laissera un trou dans le coût et dans l'étiquette.",
    },
    "reci-bilan": {
      title: "Le bilan de composition",
      body: "Il totalise la formule et la ramène à 100 : c'est la base de la liste d'ingrédients réglementaire, qui se lit toujours en pourcentages décroissants.",
      tip: null,
    },
    "reci-manques": {
      title: "Ce qui manque",
      body: "Le module REFUSE de combler un trou : si un composant n'a pas de prix ou pas de valeurs nutritionnelles, il le NOMME au lieu d'estimer. Un chiffre plausible mais faux serait pire qu'une case vide.",
      tip: "Traitez ces manques avant de présenter la formule : ce sont eux qui feront capoter la fiche technique.",
    },
    "reci-cout": {
      title: "Le coût de revient",
      body: "Matière, emballage, main-d'œuvre : le coût se recalcule à chaque modification de la formule. C'est ici qu'on voit si la cible de prix tient, ingrédient par ingrédient.",
      tip: null,
    },
    "rece-intro": {
      title: "Ce que la formule produit",
      body: "Une fois la composition posée, le module en déduit ce qui va sur l'emballage : allergènes, valeurs nutritionnelles, Nutri-Score, liste d'ingrédients. Vous ne le saisissez pas — vous le vérifiez.",
      tip: null,
    },
    "rece-allergenes": {
      title: "Les allergènes",
      body: "Ils remontent des composants, sans ressaisie. Le module distingue l'allergène INGRÉDIENT de la simple TRACE : la réglementation ne les traite pas pareil, et les confondre coûte cher dans les deux sens.",
      tip: null,
    },
    "rece-nutriscore": {
      title: "Le Nutri-Score",
      body: "Il est estimé à partir des valeurs nutritionnelles de la formule. S'il manque une donnée, le module rend une FOURCHETTE et dit ce qui manque, plutôt qu'une lettre fausse.",
      tip: "Une fourchette n'est pas un échec : c'est une information honnête sur l'état de votre formule.",
    },
    "rece-constats": {
      title: "Les constats d'étiquetage",
      body: "Le module signale ce qui empêcherait une étiquette conforme : ingrédient sans origine, quantité manquante pour un QUID, allégation non étayée. C'est la liste à solder avant d'imprimer quoi que ce soit.",
      tip: null,
    },
    "rece-sortir": {
      title: "Sortir la fiche technique",
      body: "La fiche technique est le document qu'on envoie au client : composition, allergènes, nutrition, conditionnement, durée de vie. Elle est FIGÉE à la sortie — on saura toujours ce qui a été envoyé, et quand.",
      tip: null,
    },
    "rece-promotion": {
      title: "Devenir un vrai produit",
      body: "Quand la formule est validée, ce bouton la promeut en produit fini du catalogue, avec sa spécification. C'est le passage de la R&D à la production — et la fin du parcours de ce module.",
      tip: null,
    },
    "rece-outro": {
      title: "La règle du module",
      body: "Retenez-en une seule : ce module refuse de deviner. Un coût sans prix, une teneur sans donnée, un Nutri-Score sans nutrition — il le dit plutôt que de l'inventer. Un résultat plausible n'est pas une preuve.",
      tip: null,
    },
  },
};
